'use strict';
export const validateDialBody = validate11;
const schema12 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        TopLevel: {
            type: 'object',
            additionalProperties: false,
            properties: {
                role: {
                    type: 'string',
                    enum: ['HOST', 'GUEST'],
                    description:
                        'The level of privileges the participant has in the conference.',
                },
                destination: {
                    type: 'string',
                    description: 'The target address to call.',
                },
                protocol: {
                    type: 'string',
                    enum: ['sip', 'h323', 'rtmp', 'mssip', 'auto'],
                    description:
                        'The protocol to use to place the outgoing call',
                },
                presentation_url: {
                    type: 'string',
                    description:
                        'This additional parameter can be specified for RTMP calls to send the presentation stream to a separate RTMP destination.',
                },
                streaming: {
                    type: 'string',
                    enum: ['yes', 'no'],
                    default: 'no',
                    description:
                        'Identifies the dialed participant as a streaming or recording device.',
                },
                dtmf_sequence: {
                    type: 'string',
                    description:
                        'An optional DTMF sequence to transmit after the call to the dialed participant starts.',
                },
                source_display_name: {
                    type: 'string',
                    description:
                        'Optional field that specifies what the calling display name should be.',
                },
                source: {
                    type: 'string',
                    description:
                        'Optional field that specifies the source URI (must be a valid URI for the conference).',
                },
                call_type: {
                    type: 'string',
                    enum: ['video', 'video-only', 'audio'],
                    default: ['video'],
                    description:
                        'Optional field that limits the media content of the call.',
                },
                keep_conference_alive: {
                    type: 'string',
                    enum: [
                        'keep_conference_alive',
                        'keep_conference_alive_if_multiple',
                        'keep_conference_alive_never',
                    ],
                    description:
                        'Determines whether the conference continues when all other non-ADP participants have disconnected. Default: `keep_conference_alive` for non-streaming participants, and `keep_conference_alive_never` for streaming participants.',
                },
                remote_display_name: {
                    type: 'string',
                    description:
                        "An optional friendly name for this participant. This may be used instead of the participant's alias in participant lists and as a text overlay in some layout configurations.",
                },
                text: {
                    type: 'string',
                    description:
                        'Optional text to use instead of remote_display_name as the participant name overlay text.',
                },
            },
            required: ['role', 'destination', 'protocol'],
            title: 'TopLevel',
        },
    },
    oneOf: [{$ref: '#/definitions/dial/properties/Body/definitions/TopLevel'}],
};
const schema13 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        role: {
            type: 'string',
            enum: ['HOST', 'GUEST'],
            description:
                'The level of privileges the participant has in the conference.',
        },
        destination: {
            type: 'string',
            description: 'The target address to call.',
        },
        protocol: {
            type: 'string',
            enum: ['sip', 'h323', 'rtmp', 'mssip', 'auto'],
            description: 'The protocol to use to place the outgoing call',
        },
        presentation_url: {
            type: 'string',
            description:
                'This additional parameter can be specified for RTMP calls to send the presentation stream to a separate RTMP destination.',
        },
        streaming: {
            type: 'string',
            enum: ['yes', 'no'],
            default: 'no',
            description:
                'Identifies the dialed participant as a streaming or recording device.',
        },
        dtmf_sequence: {
            type: 'string',
            description:
                'An optional DTMF sequence to transmit after the call to the dialed participant starts.',
        },
        source_display_name: {
            type: 'string',
            description:
                'Optional field that specifies what the calling display name should be.',
        },
        source: {
            type: 'string',
            description:
                'Optional field that specifies the source URI (must be a valid URI for the conference).',
        },
        call_type: {
            type: 'string',
            enum: ['video', 'video-only', 'audio'],
            default: ['video'],
            description:
                'Optional field that limits the media content of the call.',
        },
        keep_conference_alive: {
            type: 'string',
            enum: [
                'keep_conference_alive',
                'keep_conference_alive_if_multiple',
                'keep_conference_alive_never',
            ],
            description:
                'Determines whether the conference continues when all other non-ADP participants have disconnected. Default: `keep_conference_alive` for non-streaming participants, and `keep_conference_alive_never` for streaming participants.',
        },
        remote_display_name: {
            type: 'string',
            description:
                "An optional friendly name for this participant. This may be used instead of the participant's alias in participant lists and as a text overlay in some layout configurations.",
        },
        text: {
            type: 'string',
            description:
                'Optional text to use instead of remote_display_name as the participant name overlay text.',
        },
    },
    required: ['role', 'destination', 'protocol'],
    title: 'TopLevel',
};
const func2 = Object.prototype.hasOwnProperty;
function validate11(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.role === undefined && (missing0 = 'role')) ||
                (data.destination === undefined &&
                    (missing0 = 'destination')) ||
                (data.protocol === undefined && (missing0 = 'protocol'))
            ) {
                const err0 = {
                    instancePath,
                    schemaPath:
                        '#/definitions/dial/properties/Body/definitions/TopLevel/required',
                    keyword: 'required',
                    params: {missingProperty: missing0},
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                } else {
                    vErrors.push(err0);
                }
                errors++;
            } else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!func2.call(schema13.properties, key0)) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.role !== undefined) {
                        let data0 = data.role;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/role',
                                schemaPath:
                                    '#/definitions/dial/properties/Body/definitions/TopLevel/properties/role/type',
                                keyword: 'type',
                                params: {type: 'string'},
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            } else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(data0 === 'HOST' || data0 === 'GUEST')) {
                            const err2 = {
                                instancePath: instancePath + '/role',
                                schemaPath:
                                    '#/definitions/dial/properties/Body/definitions/TopLevel/properties/role/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues:
                                        schema13.properties.role.enum,
                                },
                                message:
                                    'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            } else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    } else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.destination !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.destination !== 'string') {
                                const err3 = {
                                    instancePath: instancePath + '/destination',
                                    schemaPath:
                                        '#/definitions/dial/properties/Body/definitions/TopLevel/properties/destination/type',
                                    keyword: 'type',
                                    params: {type: 'string'},
                                    message: 'must be string',
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                } else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var valid2 = _errs7 === errors;
                        } else {
                            var valid2 = true;
                        }
                        if (valid2) {
                            if (data.protocol !== undefined) {
                                let data2 = data.protocol;
                                const _errs9 = errors;
                                if (typeof data2 !== 'string') {
                                    const err4 = {
                                        instancePath:
                                            instancePath + '/protocol',
                                        schemaPath:
                                            '#/definitions/dial/properties/Body/definitions/TopLevel/properties/protocol/type',
                                        keyword: 'type',
                                        params: {type: 'string'},
                                        message: 'must be string',
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err4];
                                    } else {
                                        vErrors.push(err4);
                                    }
                                    errors++;
                                }
                                if (!(
                                    data2 === 'sip' ||
                                    data2 === 'h323' ||
                                    data2 === 'rtmp' ||
                                    data2 === 'mssip' ||
                                    data2 === 'auto'
                                )) {
                                    const err5 = {
                                        instancePath:
                                            instancePath + '/protocol',
                                        schemaPath:
                                            '#/definitions/dial/properties/Body/definitions/TopLevel/properties/protocol/enum',
                                        keyword: 'enum',
                                        params: {
                                            allowedValues:
                                                schema13.properties.protocol
                                                    .enum,
                                        },
                                        message:
                                            'must be equal to one of the allowed values',
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err5];
                                    } else {
                                        vErrors.push(err5);
                                    }
                                    errors++;
                                }
                                var valid2 = _errs9 === errors;
                            } else {
                                var valid2 = true;
                            }
                            if (valid2) {
                                if (data.presentation_url !== undefined) {
                                    const _errs11 = errors;
                                    if (
                                        typeof data.presentation_url !==
                                        'string'
                                    ) {
                                        const err6 = {
                                            instancePath:
                                                instancePath +
                                                '/presentation_url',
                                            schemaPath:
                                                '#/definitions/dial/properties/Body/definitions/TopLevel/properties/presentation_url/type',
                                            keyword: 'type',
                                            params: {type: 'string'},
                                            message: 'must be string',
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err6];
                                        } else {
                                            vErrors.push(err6);
                                        }
                                        errors++;
                                    }
                                    var valid2 = _errs11 === errors;
                                } else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data.streaming !== undefined) {
                                        let data4 = data.streaming;
                                        const _errs13 = errors;
                                        if (typeof data4 !== 'string') {
                                            const err7 = {
                                                instancePath:
                                                    instancePath + '/streaming',
                                                schemaPath:
                                                    '#/definitions/dial/properties/Body/definitions/TopLevel/properties/streaming/type',
                                                keyword: 'type',
                                                params: {type: 'string'},
                                                message: 'must be string',
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err7];
                                            } else {
                                                vErrors.push(err7);
                                            }
                                            errors++;
                                        }
                                        if (!(
                                            data4 === 'yes' || data4 === 'no'
                                        )) {
                                            const err8 = {
                                                instancePath:
                                                    instancePath + '/streaming',
                                                schemaPath:
                                                    '#/definitions/dial/properties/Body/definitions/TopLevel/properties/streaming/enum',
                                                keyword: 'enum',
                                                params: {
                                                    allowedValues:
                                                        schema13.properties
                                                            .streaming.enum,
                                                },
                                                message:
                                                    'must be equal to one of the allowed values',
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err8];
                                            } else {
                                                vErrors.push(err8);
                                            }
                                            errors++;
                                        }
                                        var valid2 = _errs13 === errors;
                                    } else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data.dtmf_sequence !== undefined) {
                                            const _errs15 = errors;
                                            if (
                                                typeof data.dtmf_sequence !==
                                                'string'
                                            ) {
                                                const err9 = {
                                                    instancePath:
                                                        instancePath +
                                                        '/dtmf_sequence',
                                                    schemaPath:
                                                        '#/definitions/dial/properties/Body/definitions/TopLevel/properties/dtmf_sequence/type',
                                                    keyword: 'type',
                                                    params: {type: 'string'},
                                                    message: 'must be string',
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err9];
                                                } else {
                                                    vErrors.push(err9);
                                                }
                                                errors++;
                                            }
                                            var valid2 = _errs15 === errors;
                                        } else {
                                            var valid2 = true;
                                        }
                                        if (valid2) {
                                            if (
                                                data.source_display_name !==
                                                undefined
                                            ) {
                                                const _errs17 = errors;
                                                if (
                                                    typeof data.source_display_name !==
                                                    'string'
                                                ) {
                                                    const err10 = {
                                                        instancePath:
                                                            instancePath +
                                                            '/source_display_name',
                                                        schemaPath:
                                                            '#/definitions/dial/properties/Body/definitions/TopLevel/properties/source_display_name/type',
                                                        keyword: 'type',
                                                        params: {
                                                            type: 'string',
                                                        },
                                                        message:
                                                            'must be string',
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err10];
                                                    } else {
                                                        vErrors.push(err10);
                                                    }
                                                    errors++;
                                                }
                                                var valid2 = _errs17 === errors;
                                            } else {
                                                var valid2 = true;
                                            }
                                            if (valid2) {
                                                if (data.source !== undefined) {
                                                    const _errs19 = errors;
                                                    if (
                                                        typeof data.source !==
                                                        'string'
                                                    ) {
                                                        const err11 = {
                                                            instancePath:
                                                                instancePath +
                                                                '/source',
                                                            schemaPath:
                                                                '#/definitions/dial/properties/Body/definitions/TopLevel/properties/source/type',
                                                            keyword: 'type',
                                                            params: {
                                                                type: 'string',
                                                            },
                                                            message:
                                                                'must be string',
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err11];
                                                        } else {
                                                            vErrors.push(err11);
                                                        }
                                                        errors++;
                                                    }
                                                    var valid2 =
                                                        _errs19 === errors;
                                                } else {
                                                    var valid2 = true;
                                                }
                                                if (valid2) {
                                                    if (
                                                        data.call_type !==
                                                        undefined
                                                    ) {
                                                        let data8 =
                                                            data.call_type;
                                                        const _errs21 = errors;
                                                        if (
                                                            typeof data8 !==
                                                            'string'
                                                        ) {
                                                            const err12 = {
                                                                instancePath:
                                                                    instancePath +
                                                                    '/call_type',
                                                                schemaPath:
                                                                    '#/definitions/dial/properties/Body/definitions/TopLevel/properties/call_type/type',
                                                                keyword: 'type',
                                                                params: {
                                                                    type: 'string',
                                                                },
                                                                message:
                                                                    'must be string',
                                                            };
                                                            if (
                                                                vErrors === null
                                                            ) {
                                                                vErrors = [
                                                                    err12,
                                                                ];
                                                            } else {
                                                                vErrors.push(
                                                                    err12,
                                                                );
                                                            }
                                                            errors++;
                                                        }
                                                        if (!(
                                                            data8 === 'video' ||
                                                            data8 ===
                                                                'video-only' ||
                                                            data8 === 'audio'
                                                        )) {
                                                            const err13 = {
                                                                instancePath:
                                                                    instancePath +
                                                                    '/call_type',
                                                                schemaPath:
                                                                    '#/definitions/dial/properties/Body/definitions/TopLevel/properties/call_type/enum',
                                                                keyword: 'enum',
                                                                params: {
                                                                    allowedValues:
                                                                        schema13
                                                                            .properties
                                                                            .call_type
                                                                            .enum,
                                                                },
                                                                message:
                                                                    'must be equal to one of the allowed values',
                                                            };
                                                            if (
                                                                vErrors === null
                                                            ) {
                                                                vErrors = [
                                                                    err13,
                                                                ];
                                                            } else {
                                                                vErrors.push(
                                                                    err13,
                                                                );
                                                            }
                                                            errors++;
                                                        }
                                                        var valid2 =
                                                            _errs21 === errors;
                                                    } else {
                                                        var valid2 = true;
                                                    }
                                                    if (valid2) {
                                                        if (
                                                            data.keep_conference_alive !==
                                                            undefined
                                                        ) {
                                                            let data9 =
                                                                data.keep_conference_alive;
                                                            const _errs23 =
                                                                errors;
                                                            if (
                                                                typeof data9 !==
                                                                'string'
                                                            ) {
                                                                const err14 = {
                                                                    instancePath:
                                                                        instancePath +
                                                                        '/keep_conference_alive',
                                                                    schemaPath:
                                                                        '#/definitions/dial/properties/Body/definitions/TopLevel/properties/keep_conference_alive/type',
                                                                    keyword:
                                                                        'type',
                                                                    params: {
                                                                        type: 'string',
                                                                    },
                                                                    message:
                                                                        'must be string',
                                                                };
                                                                if (
                                                                    vErrors ===
                                                                    null
                                                                ) {
                                                                    vErrors = [
                                                                        err14,
                                                                    ];
                                                                } else {
                                                                    vErrors.push(
                                                                        err14,
                                                                    );
                                                                }
                                                                errors++;
                                                            }
                                                            if (!(
                                                                data9 ===
                                                                    'keep_conference_alive' ||
                                                                data9 ===
                                                                    'keep_conference_alive_if_multiple' ||
                                                                data9 ===
                                                                    'keep_conference_alive_never'
                                                            )) {
                                                                const err15 = {
                                                                    instancePath:
                                                                        instancePath +
                                                                        '/keep_conference_alive',
                                                                    schemaPath:
                                                                        '#/definitions/dial/properties/Body/definitions/TopLevel/properties/keep_conference_alive/enum',
                                                                    keyword:
                                                                        'enum',
                                                                    params: {
                                                                        allowedValues:
                                                                            schema13
                                                                                .properties
                                                                                .keep_conference_alive
                                                                                .enum,
                                                                    },
                                                                    message:
                                                                        'must be equal to one of the allowed values',
                                                                };
                                                                if (
                                                                    vErrors ===
                                                                    null
                                                                ) {
                                                                    vErrors = [
                                                                        err15,
                                                                    ];
                                                                } else {
                                                                    vErrors.push(
                                                                        err15,
                                                                    );
                                                                }
                                                                errors++;
                                                            }
                                                            var valid2 =
                                                                _errs23 ===
                                                                errors;
                                                        } else {
                                                            var valid2 = true;
                                                        }
                                                        if (valid2) {
                                                            if (
                                                                data.remote_display_name !==
                                                                undefined
                                                            ) {
                                                                const _errs25 =
                                                                    errors;
                                                                if (
                                                                    typeof data.remote_display_name !==
                                                                    'string'
                                                                ) {
                                                                    const err16 =
                                                                        {
                                                                            instancePath:
                                                                                instancePath +
                                                                                '/remote_display_name',
                                                                            schemaPath:
                                                                                '#/definitions/dial/properties/Body/definitions/TopLevel/properties/remote_display_name/type',
                                                                            keyword:
                                                                                'type',
                                                                            params: {
                                                                                type: 'string',
                                                                            },
                                                                            message:
                                                                                'must be string',
                                                                        };
                                                                    if (
                                                                        vErrors ===
                                                                        null
                                                                    ) {
                                                                        vErrors =
                                                                            [
                                                                                err16,
                                                                            ];
                                                                    } else {
                                                                        vErrors.push(
                                                                            err16,
                                                                        );
                                                                    }
                                                                    errors++;
                                                                }
                                                                var valid2 =
                                                                    _errs25 ===
                                                                    errors;
                                                            } else {
                                                                var valid2 = true;
                                                            }
                                                            if (valid2) {
                                                                if (
                                                                    data.text !==
                                                                    undefined
                                                                ) {
                                                                    const _errs27 =
                                                                        errors;
                                                                    if (
                                                                        typeof data.text !==
                                                                        'string'
                                                                    ) {
                                                                        const err17 =
                                                                            {
                                                                                instancePath:
                                                                                    instancePath +
                                                                                    '/text',
                                                                                schemaPath:
                                                                                    '#/definitions/dial/properties/Body/definitions/TopLevel/properties/text/type',
                                                                                keyword:
                                                                                    'type',
                                                                                params: {
                                                                                    type: 'string',
                                                                                },
                                                                                message:
                                                                                    'must be string',
                                                                            };
                                                                        if (
                                                                            vErrors ===
                                                                            null
                                                                        ) {
                                                                            vErrors =
                                                                                [
                                                                                    err17,
                                                                                ];
                                                                        } else {
                                                                            vErrors.push(
                                                                                err17,
                                                                            );
                                                                        }
                                                                        errors++;
                                                                    }
                                                                    var valid2 =
                                                                        _errs27 ===
                                                                        errors;
                                                                } else {
                                                                    var valid2 = true;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        } else {
            const err18 = {
                instancePath,
                schemaPath:
                    '#/definitions/dial/properties/Body/definitions/TopLevel/type',
                keyword: 'type',
                params: {type: 'object'},
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err18];
            } else {
                vErrors.push(err18);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err19 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err19];
        } else {
            vErrors.push(err19);
        }
        errors++;
        validate11.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate11.errors = vErrors;
    return errors === 0;
}
export const validateDial200 = validate12;
const schema14 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        '200': {
            type: 'object',
            additionalProperties: false,
            properties: {
                status: {
                    type: 'string',
                    description: 'Status of the response, eg. success.',
                    enum: ['success'],
                },
                result: {
                    type: 'array',
                    description:
                        'The response is an array of UUIDs of new participants',
                    items: {type: 'string'},
                },
            },
            required: ['status', 'result'],
            title: 'Status200',
        },
    },
    oneOf: [{$ref: '#/definitions/dial/properties/200/definitions/200'}],
};
const schema15 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        status: {
            type: 'string',
            description: 'Status of the response, eg. success.',
            enum: ['success'],
        },
        result: {
            type: 'array',
            description:
                'The response is an array of UUIDs of new participants',
            items: {type: 'string'},
        },
    },
    required: ['status', 'result'],
    title: 'Status200',
};
function validate12(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))
            ) {
                const err0 = {
                    instancePath,
                    schemaPath:
                        '#/definitions/dial/properties/200/definitions/200/required',
                    keyword: 'required',
                    params: {missingProperty: missing0},
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                } else {
                    vErrors.push(err0);
                }
                errors++;
            } else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/dial/properties/200/definitions/200/properties/status/type',
                                keyword: 'type',
                                params: {type: 'string'},
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            } else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(data0 === 'success')) {
                            const err2 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/dial/properties/200/definitions/200/properties/status/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues:
                                        schema15.properties.status.enum,
                                },
                                message:
                                    'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            } else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    } else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.result !== undefined) {
                            let data1 = data.result;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (Array.isArray(data1)) {
                                    var valid3 = true;
                                    const len0 = data1.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        const _errs9 = errors;
                                        if (typeof data1[i0] !== 'string') {
                                            const err3 = {
                                                instancePath:
                                                    instancePath +
                                                    '/result/' +
                                                    i0,
                                                schemaPath:
                                                    '#/definitions/dial/properties/200/definitions/200/properties/result/items/type',
                                                keyword: 'type',
                                                params: {type: 'string'},
                                                message: 'must be string',
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err3];
                                            } else {
                                                vErrors.push(err3);
                                            }
                                            errors++;
                                        }
                                        var valid3 = _errs9 === errors;
                                        if (!valid3) {
                                            break;
                                        }
                                    }
                                } else {
                                    const err4 = {
                                        instancePath: instancePath + '/result',
                                        schemaPath:
                                            '#/definitions/dial/properties/200/definitions/200/properties/result/type',
                                        keyword: 'type',
                                        params: {type: 'array'},
                                        message: 'must be array',
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err4];
                                    } else {
                                        vErrors.push(err4);
                                    }
                                    errors++;
                                }
                            }
                            var valid2 = _errs7 === errors;
                        } else {
                            var valid2 = true;
                        }
                    }
                }
            }
        } else {
            const err5 = {
                instancePath,
                schemaPath:
                    '#/definitions/dial/properties/200/definitions/200/type',
                keyword: 'type',
                params: {type: 'object'},
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err5];
            } else {
                vErrors.push(err5);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err6 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err6];
        } else {
            vErrors.push(err6);
        }
        errors++;
        validate12.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate12.errors = vErrors;
    return errors === 0;
}
export const validateConferenceStatus200 = validate13;
const schema16 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        '200': {
            type: 'object',
            additionalProperties: false,
            properties: {
                status: {
                    type: 'string',
                    description: 'Status of the response, eg. success.',
                    enum: ['success'],
                },
                result: {
                    $ref: '#/definitions/conference_status/properties/200/definitions/Result',
                },
            },
            required: ['status', 'result'],
            title: 'Status200',
        },
        Result: {
            type: 'object',
            additionalProperties: false,
            properties: {
                breakout: {
                    type: 'boolean',
                    description: 'It is a breakout room or not',
                },
                breakout_name: {
                    type: 'string',
                    description:
                        'The name of the breakout room. Only available when breakout is true',
                },
                breakout_description: {
                    type: 'string',
                    description:
                        'The description of the breakout room. Only available when breakout is true',
                },
                end_action: {
                    type: 'string',
                    description:
                        'The end action when the breakout room is ended triggered by the end time. Only available when breakout is true',
                    enum: ['transfer', 'disconnect'],
                },
                end_time: {
                    type: 'number',
                    description:
                        'The time when breakout ends (in seconds since epoch as floating point number). Only available when breakout is true',
                },
                locked: {
                    type: 'boolean',
                    description: 'Lock status of the conference',
                },
                guests_muted: {
                    type: 'boolean',
                    description: 'Whether Guests are muted',
                },
                started: {
                    type: 'boolean',
                    description: 'If the conference has been started',
                },
                live_captions_available: {
                    type: 'boolean',
                    description:
                        'If live captions is available for the conference',
                },
                live_captions_available_languages: {
                    type: 'array',
                    items: {type: 'string'},
                    description:
                        'The languages available for live captions translation',
                },
                live_captions_source_languages: {
                    type: 'array',
                    items: {type: 'string'},
                    description: 'The languages for live captions source',
                },
                direct_media: {type: 'boolean'},
                all_muted: {type: 'boolean'},
                presentation_allowed: {type: 'boolean'},
                breakout_rooms: {
                    type: 'boolean',
                    description:
                        'If breakout rooms is available for the conference',
                },
                classification: {
                    type: 'object',
                    description: 'conference classification',
                },
                breakout_guests_allowed_to_leave: {
                    type: 'boolean',
                    description: 'If guests can leave a breakout at any time',
                },
                breakoutbuzz: {
                    type: 'object',
                    description:
                        'info about if a breakout room has asked for help',
                },
                guests_can_unmute: {
                    type: 'boolean',
                    description: 'info about if guests can unmute themselves',
                },
                guests_can_present: {
                    type: 'boolean',
                    description: 'info about if guests can present',
                },
                chat_enabled: {
                    type: 'boolean',
                    description:
                        'true = chat is enabled; false = chat is not enabled.',
                },
            },
            required: ['locked', 'guests_muted', 'started'],
            title: 'Result',
        },
    },
    oneOf: [
        {
            $ref: '#/definitions/conference_status/properties/200/definitions/200',
        },
    ],
};
const schema17 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        status: {
            type: 'string',
            description: 'Status of the response, eg. success.',
            enum: ['success'],
        },
        result: {
            $ref: '#/definitions/conference_status/properties/200/definitions/Result',
        },
    },
    required: ['status', 'result'],
    title: 'Status200',
};
const schema18 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        breakout: {
            type: 'boolean',
            description: 'It is a breakout room or not',
        },
        breakout_name: {
            type: 'string',
            description:
                'The name of the breakout room. Only available when breakout is true',
        },
        breakout_description: {
            type: 'string',
            description:
                'The description of the breakout room. Only available when breakout is true',
        },
        end_action: {
            type: 'string',
            description:
                'The end action when the breakout room is ended triggered by the end time. Only available when breakout is true',
            enum: ['transfer', 'disconnect'],
        },
        end_time: {
            type: 'number',
            description:
                'The time when breakout ends (in seconds since epoch as floating point number). Only available when breakout is true',
        },
        locked: {type: 'boolean', description: 'Lock status of the conference'},
        guests_muted: {
            type: 'boolean',
            description: 'Whether Guests are muted',
        },
        started: {
            type: 'boolean',
            description: 'If the conference has been started',
        },
        live_captions_available: {
            type: 'boolean',
            description: 'If live captions is available for the conference',
        },
        live_captions_available_languages: {
            type: 'array',
            items: {type: 'string'},
            description:
                'The languages available for live captions translation',
        },
        live_captions_source_languages: {
            type: 'array',
            items: {type: 'string'},
            description: 'The languages for live captions source',
        },
        direct_media: {type: 'boolean'},
        all_muted: {type: 'boolean'},
        presentation_allowed: {type: 'boolean'},
        breakout_rooms: {
            type: 'boolean',
            description: 'If breakout rooms is available for the conference',
        },
        classification: {
            type: 'object',
            description: 'conference classification',
        },
        breakout_guests_allowed_to_leave: {
            type: 'boolean',
            description: 'If guests can leave a breakout at any time',
        },
        breakoutbuzz: {
            type: 'object',
            description: 'info about if a breakout room has asked for help',
        },
        guests_can_unmute: {
            type: 'boolean',
            description: 'info about if guests can unmute themselves',
        },
        guests_can_present: {
            type: 'boolean',
            description: 'info about if guests can present',
        },
        chat_enabled: {
            type: 'boolean',
            description: 'true = chat is enabled; false = chat is not enabled.',
        },
    },
    required: ['locked', 'guests_muted', 'started'],
    title: 'Result',
};
function validate14(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))
            ) {
                validate14.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: {missingProperty: missing0},
                        message:
                            "must have required property '" + missing0 + "'",
                    },
                ];
                return false;
            } else {
                const _errs1 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs1 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs2 = errors;
                        if (typeof data0 !== 'string') {
                            validate14.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/type',
                                    keyword: 'type',
                                    params: {type: 'string'},
                                    message: 'must be string',
                                },
                            ];
                            return false;
                        }
                        if (!(data0 === 'success')) {
                            validate14.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/enum',
                                    keyword: 'enum',
                                    params: {
                                        allowedValues:
                                            schema17.properties.status.enum,
                                    },
                                    message:
                                        'must be equal to one of the allowed values',
                                },
                            ];
                            return false;
                        }
                        var valid0 = _errs2 === errors;
                    } else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.result !== undefined) {
                            let data1 = data.result;
                            const _errs4 = errors;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (
                                    data1 &&
                                    typeof data1 == 'object' &&
                                    !Array.isArray(data1)
                                ) {
                                    let missing1;
                                    if (
                                        (data1.locked === undefined &&
                                            (missing1 = 'locked')) ||
                                        (data1.guests_muted === undefined &&
                                            (missing1 = 'guests_muted')) ||
                                        (data1.started === undefined &&
                                            (missing1 = 'started'))
                                    ) {
                                        validate14.errors = [
                                            {
                                                instancePath:
                                                    instancePath + '/result',
                                                schemaPath:
                                                    '#/definitions/conference_status/properties/200/definitions/Result/required',
                                                keyword: 'required',
                                                params: {
                                                    missingProperty: missing1,
                                                },
                                                message:
                                                    "must have required property '" +
                                                    missing1 +
                                                    "'",
                                            },
                                        ];
                                        return false;
                                    } else {
                                        const _errs7 = errors;
                                        for (const key1 in data1) {
                                            if (
                                                !func2.call(
                                                    schema18.properties,
                                                    key1,
                                                )
                                            ) {
                                                delete data1[key1];
                                            }
                                        }
                                        if (_errs7 === errors) {
                                            if (data1.breakout !== undefined) {
                                                const _errs8 = errors;
                                                if (
                                                    typeof data1.breakout !==
                                                    'boolean'
                                                ) {
                                                    validate14.errors = [
                                                        {
                                                            instancePath:
                                                                instancePath +
                                                                '/result/breakout',
                                                            schemaPath:
                                                                '#/definitions/conference_status/properties/200/definitions/Result/properties/breakout/type',
                                                            keyword: 'type',
                                                            params: {
                                                                type: 'boolean',
                                                            },
                                                            message:
                                                                'must be boolean',
                                                        },
                                                    ];
                                                    return false;
                                                }
                                                var valid2 = _errs8 === errors;
                                            } else {
                                                var valid2 = true;
                                            }
                                            if (valid2) {
                                                if (
                                                    data1.breakout_name !==
                                                    undefined
                                                ) {
                                                    const _errs10 = errors;
                                                    if (
                                                        typeof data1.breakout_name !==
                                                        'string'
                                                    ) {
                                                        validate14.errors = [
                                                            {
                                                                instancePath:
                                                                    instancePath +
                                                                    '/result/breakout_name',
                                                                schemaPath:
                                                                    '#/definitions/conference_status/properties/200/definitions/Result/properties/breakout_name/type',
                                                                keyword: 'type',
                                                                params: {
                                                                    type: 'string',
                                                                },
                                                                message:
                                                                    'must be string',
                                                            },
                                                        ];
                                                        return false;
                                                    }
                                                    var valid2 =
                                                        _errs10 === errors;
                                                } else {
                                                    var valid2 = true;
                                                }
                                                if (valid2) {
                                                    if (
                                                        data1.breakout_description !==
                                                        undefined
                                                    ) {
                                                        const _errs12 = errors;
                                                        if (
                                                            typeof data1.breakout_description !==
                                                            'string'
                                                        ) {
                                                            validate14.errors =
                                                                [
                                                                    {
                                                                        instancePath:
                                                                            instancePath +
                                                                            '/result/breakout_description',
                                                                        schemaPath:
                                                                            '#/definitions/conference_status/properties/200/definitions/Result/properties/breakout_description/type',
                                                                        keyword:
                                                                            'type',
                                                                        params: {
                                                                            type: 'string',
                                                                        },
                                                                        message:
                                                                            'must be string',
                                                                    },
                                                                ];
                                                            return false;
                                                        }
                                                        var valid2 =
                                                            _errs12 === errors;
                                                    } else {
                                                        var valid2 = true;
                                                    }
                                                    if (valid2) {
                                                        if (
                                                            data1.end_action !==
                                                            undefined
                                                        ) {
                                                            let data5 =
                                                                data1.end_action;
                                                            const _errs14 =
                                                                errors;
                                                            if (
                                                                typeof data5 !==
                                                                'string'
                                                            ) {
                                                                validate14.errors =
                                                                    [
                                                                        {
                                                                            instancePath:
                                                                                instancePath +
                                                                                '/result/end_action',
                                                                            schemaPath:
                                                                                '#/definitions/conference_status/properties/200/definitions/Result/properties/end_action/type',
                                                                            keyword:
                                                                                'type',
                                                                            params: {
                                                                                type: 'string',
                                                                            },
                                                                            message:
                                                                                'must be string',
                                                                        },
                                                                    ];
                                                                return false;
                                                            }
                                                            if (!(
                                                                data5 ===
                                                                    'transfer' ||
                                                                data5 ===
                                                                    'disconnect'
                                                            )) {
                                                                validate14.errors =
                                                                    [
                                                                        {
                                                                            instancePath:
                                                                                instancePath +
                                                                                '/result/end_action',
                                                                            schemaPath:
                                                                                '#/definitions/conference_status/properties/200/definitions/Result/properties/end_action/enum',
                                                                            keyword:
                                                                                'enum',
                                                                            params: {
                                                                                allowedValues:
                                                                                    schema18
                                                                                        .properties
                                                                                        .end_action
                                                                                        .enum,
                                                                            },
                                                                            message:
                                                                                'must be equal to one of the allowed values',
                                                                        },
                                                                    ];
                                                                return false;
                                                            }
                                                            var valid2 =
                                                                _errs14 ===
                                                                errors;
                                                        } else {
                                                            var valid2 = true;
                                                        }
                                                        if (valid2) {
                                                            if (
                                                                data1.end_time !==
                                                                undefined
                                                            ) {
                                                                const _errs16 =
                                                                    errors;
                                                                if (
                                                                    !(
                                                                        typeof data1.end_time ==
                                                                        'number'
                                                                    )
                                                                ) {
                                                                    validate14.errors =
                                                                        [
                                                                            {
                                                                                instancePath:
                                                                                    instancePath +
                                                                                    '/result/end_time',
                                                                                schemaPath:
                                                                                    '#/definitions/conference_status/properties/200/definitions/Result/properties/end_time/type',
                                                                                keyword:
                                                                                    'type',
                                                                                params: {
                                                                                    type: 'number',
                                                                                },
                                                                                message:
                                                                                    'must be number',
                                                                            },
                                                                        ];
                                                                    return false;
                                                                }
                                                                var valid2 =
                                                                    _errs16 ===
                                                                    errors;
                                                            } else {
                                                                var valid2 = true;
                                                            }
                                                            if (valid2) {
                                                                if (
                                                                    data1.locked !==
                                                                    undefined
                                                                ) {
                                                                    const _errs18 =
                                                                        errors;
                                                                    if (
                                                                        typeof data1.locked !==
                                                                        'boolean'
                                                                    ) {
                                                                        validate14.errors =
                                                                            [
                                                                                {
                                                                                    instancePath:
                                                                                        instancePath +
                                                                                        '/result/locked',
                                                                                    schemaPath:
                                                                                        '#/definitions/conference_status/properties/200/definitions/Result/properties/locked/type',
                                                                                    keyword:
                                                                                        'type',
                                                                                    params: {
                                                                                        type: 'boolean',
                                                                                    },
                                                                                    message:
                                                                                        'must be boolean',
                                                                                },
                                                                            ];
                                                                        return false;
                                                                    }
                                                                    var valid2 =
                                                                        _errs18 ===
                                                                        errors;
                                                                } else {
                                                                    var valid2 = true;
                                                                }
                                                                if (valid2) {
                                                                    if (
                                                                        data1.guests_muted !==
                                                                        undefined
                                                                    ) {
                                                                        const _errs20 =
                                                                            errors;
                                                                        if (
                                                                            typeof data1.guests_muted !==
                                                                            'boolean'
                                                                        ) {
                                                                            validate14.errors =
                                                                                [
                                                                                    {
                                                                                        instancePath:
                                                                                            instancePath +
                                                                                            '/result/guests_muted',
                                                                                        schemaPath:
                                                                                            '#/definitions/conference_status/properties/200/definitions/Result/properties/guests_muted/type',
                                                                                        keyword:
                                                                                            'type',
                                                                                        params: {
                                                                                            type: 'boolean',
                                                                                        },
                                                                                        message:
                                                                                            'must be boolean',
                                                                                    },
                                                                                ];
                                                                            return false;
                                                                        }
                                                                        var valid2 =
                                                                            _errs20 ===
                                                                            errors;
                                                                    } else {
                                                                        var valid2 = true;
                                                                    }
                                                                    if (
                                                                        valid2
                                                                    ) {
                                                                        if (
                                                                            data1.started !==
                                                                            undefined
                                                                        ) {
                                                                            const _errs22 =
                                                                                errors;
                                                                            if (
                                                                                typeof data1.started !==
                                                                                'boolean'
                                                                            ) {
                                                                                validate14.errors =
                                                                                    [
                                                                                        {
                                                                                            instancePath:
                                                                                                instancePath +
                                                                                                '/result/started',
                                                                                            schemaPath:
                                                                                                '#/definitions/conference_status/properties/200/definitions/Result/properties/started/type',
                                                                                            keyword:
                                                                                                'type',
                                                                                            params: {
                                                                                                type: 'boolean',
                                                                                            },
                                                                                            message:
                                                                                                'must be boolean',
                                                                                        },
                                                                                    ];
                                                                                return false;
                                                                            }
                                                                            var valid2 =
                                                                                _errs22 ===
                                                                                errors;
                                                                        } else {
                                                                            var valid2 = true;
                                                                        }
                                                                        if (
                                                                            valid2
                                                                        ) {
                                                                            if (
                                                                                data1.live_captions_available !==
                                                                                undefined
                                                                            ) {
                                                                                const _errs24 =
                                                                                    errors;
                                                                                if (
                                                                                    typeof data1.live_captions_available !==
                                                                                    'boolean'
                                                                                ) {
                                                                                    validate14.errors =
                                                                                        [
                                                                                            {
                                                                                                instancePath:
                                                                                                    instancePath +
                                                                                                    '/result/live_captions_available',
                                                                                                schemaPath:
                                                                                                    '#/definitions/conference_status/properties/200/definitions/Result/properties/live_captions_available/type',
                                                                                                keyword:
                                                                                                    'type',
                                                                                                params: {
                                                                                                    type: 'boolean',
                                                                                                },
                                                                                                message:
                                                                                                    'must be boolean',
                                                                                            },
                                                                                        ];
                                                                                    return false;
                                                                                }
                                                                                var valid2 =
                                                                                    _errs24 ===
                                                                                    errors;
                                                                            } else {
                                                                                var valid2 = true;
                                                                            }
                                                                            if (
                                                                                valid2
                                                                            ) {
                                                                                if (
                                                                                    data1.live_captions_available_languages !==
                                                                                    undefined
                                                                                ) {
                                                                                    let data11 =
                                                                                        data1.live_captions_available_languages;
                                                                                    const _errs26 =
                                                                                        errors;
                                                                                    if (
                                                                                        errors ===
                                                                                        _errs26
                                                                                    ) {
                                                                                        if (
                                                                                            Array.isArray(
                                                                                                data11,
                                                                                            )
                                                                                        ) {
                                                                                            var valid3 = true;
                                                                                            const len0 =
                                                                                                data11.length;
                                                                                            for (
                                                                                                let i0 = 0;
                                                                                                i0 <
                                                                                                len0;
                                                                                                i0++
                                                                                            ) {
                                                                                                const _errs28 =
                                                                                                    errors;
                                                                                                if (
                                                                                                    typeof data11[
                                                                                                        i0
                                                                                                    ] !==
                                                                                                    'string'
                                                                                                ) {
                                                                                                    validate14.errors =
                                                                                                        [
                                                                                                            {
                                                                                                                instancePath:
                                                                                                                    instancePath +
                                                                                                                    '/result/live_captions_available_languages/' +
                                                                                                                    i0,
                                                                                                                schemaPath:
                                                                                                                    '#/definitions/conference_status/properties/200/definitions/Result/properties/live_captions_available_languages/items/type',
                                                                                                                keyword:
                                                                                                                    'type',
                                                                                                                params: {
                                                                                                                    type: 'string',
                                                                                                                },
                                                                                                                message:
                                                                                                                    'must be string',
                                                                                                            },
                                                                                                        ];
                                                                                                    return false;
                                                                                                }
                                                                                                var valid3 =
                                                                                                    _errs28 ===
                                                                                                    errors;
                                                                                                if (
                                                                                                    !valid3
                                                                                                ) {
                                                                                                    break;
                                                                                                }
                                                                                            }
                                                                                        } else {
                                                                                            validate14.errors =
                                                                                                [
                                                                                                    {
                                                                                                        instancePath:
                                                                                                            instancePath +
                                                                                                            '/result/live_captions_available_languages',
                                                                                                        schemaPath:
                                                                                                            '#/definitions/conference_status/properties/200/definitions/Result/properties/live_captions_available_languages/type',
                                                                                                        keyword:
                                                                                                            'type',
                                                                                                        params: {
                                                                                                            type: 'array',
                                                                                                        },
                                                                                                        message:
                                                                                                            'must be array',
                                                                                                    },
                                                                                                ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    var valid2 =
                                                                                        _errs26 ===
                                                                                        errors;
                                                                                } else {
                                                                                    var valid2 = true;
                                                                                }
                                                                                if (
                                                                                    valid2
                                                                                ) {
                                                                                    if (
                                                                                        data1.live_captions_source_languages !==
                                                                                        undefined
                                                                                    ) {
                                                                                        let data13 =
                                                                                            data1.live_captions_source_languages;
                                                                                        const _errs30 =
                                                                                            errors;
                                                                                        if (
                                                                                            errors ===
                                                                                            _errs30
                                                                                        ) {
                                                                                            if (
                                                                                                Array.isArray(
                                                                                                    data13,
                                                                                                )
                                                                                            ) {
                                                                                                var valid4 = true;
                                                                                                const len1 =
                                                                                                    data13.length;
                                                                                                for (
                                                                                                    let i1 = 0;
                                                                                                    i1 <
                                                                                                    len1;
                                                                                                    i1++
                                                                                                ) {
                                                                                                    const _errs32 =
                                                                                                        errors;
                                                                                                    if (
                                                                                                        typeof data13[
                                                                                                            i1
                                                                                                        ] !==
                                                                                                        'string'
                                                                                                    ) {
                                                                                                        validate14.errors =
                                                                                                            [
                                                                                                                {
                                                                                                                    instancePath:
                                                                                                                        instancePath +
                                                                                                                        '/result/live_captions_source_languages/' +
                                                                                                                        i1,
                                                                                                                    schemaPath:
                                                                                                                        '#/definitions/conference_status/properties/200/definitions/Result/properties/live_captions_source_languages/items/type',
                                                                                                                    keyword:
                                                                                                                        'type',
                                                                                                                    params: {
                                                                                                                        type: 'string',
                                                                                                                    },
                                                                                                                    message:
                                                                                                                        'must be string',
                                                                                                                },
                                                                                                            ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    var valid4 =
                                                                                                        _errs32 ===
                                                                                                        errors;
                                                                                                    if (
                                                                                                        !valid4
                                                                                                    ) {
                                                                                                        break;
                                                                                                    }
                                                                                                }
                                                                                            } else {
                                                                                                validate14.errors =
                                                                                                    [
                                                                                                        {
                                                                                                            instancePath:
                                                                                                                instancePath +
                                                                                                                '/result/live_captions_source_languages',
                                                                                                            schemaPath:
                                                                                                                '#/definitions/conference_status/properties/200/definitions/Result/properties/live_captions_source_languages/type',
                                                                                                            keyword:
                                                                                                                'type',
                                                                                                            params: {
                                                                                                                type: 'array',
                                                                                                            },
                                                                                                            message:
                                                                                                                'must be array',
                                                                                                        },
                                                                                                    ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        var valid2 =
                                                                                            _errs30 ===
                                                                                            errors;
                                                                                    } else {
                                                                                        var valid2 = true;
                                                                                    }
                                                                                    if (
                                                                                        valid2
                                                                                    ) {
                                                                                        if (
                                                                                            data1.direct_media !==
                                                                                            undefined
                                                                                        ) {
                                                                                            const _errs34 =
                                                                                                errors;
                                                                                            if (
                                                                                                typeof data1.direct_media !==
                                                                                                'boolean'
                                                                                            ) {
                                                                                                validate14.errors =
                                                                                                    [
                                                                                                        {
                                                                                                            instancePath:
                                                                                                                instancePath +
                                                                                                                '/result/direct_media',
                                                                                                            schemaPath:
                                                                                                                '#/definitions/conference_status/properties/200/definitions/Result/properties/direct_media/type',
                                                                                                            keyword:
                                                                                                                'type',
                                                                                                            params: {
                                                                                                                type: 'boolean',
                                                                                                            },
                                                                                                            message:
                                                                                                                'must be boolean',
                                                                                                        },
                                                                                                    ];
                                                                                                return false;
                                                                                            }
                                                                                            var valid2 =
                                                                                                _errs34 ===
                                                                                                errors;
                                                                                        } else {
                                                                                            var valid2 = true;
                                                                                        }
                                                                                        if (
                                                                                            valid2
                                                                                        ) {
                                                                                            if (
                                                                                                data1.all_muted !==
                                                                                                undefined
                                                                                            ) {
                                                                                                const _errs36 =
                                                                                                    errors;
                                                                                                if (
                                                                                                    typeof data1.all_muted !==
                                                                                                    'boolean'
                                                                                                ) {
                                                                                                    validate14.errors =
                                                                                                        [
                                                                                                            {
                                                                                                                instancePath:
                                                                                                                    instancePath +
                                                                                                                    '/result/all_muted',
                                                                                                                schemaPath:
                                                                                                                    '#/definitions/conference_status/properties/200/definitions/Result/properties/all_muted/type',
                                                                                                                keyword:
                                                                                                                    'type',
                                                                                                                params: {
                                                                                                                    type: 'boolean',
                                                                                                                },
                                                                                                                message:
                                                                                                                    'must be boolean',
                                                                                                            },
                                                                                                        ];
                                                                                                    return false;
                                                                                                }
                                                                                                var valid2 =
                                                                                                    _errs36 ===
                                                                                                    errors;
                                                                                            } else {
                                                                                                var valid2 = true;
                                                                                            }
                                                                                            if (
                                                                                                valid2
                                                                                            ) {
                                                                                                if (
                                                                                                    data1.presentation_allowed !==
                                                                                                    undefined
                                                                                                ) {
                                                                                                    const _errs38 =
                                                                                                        errors;
                                                                                                    if (
                                                                                                        typeof data1.presentation_allowed !==
                                                                                                        'boolean'
                                                                                                    ) {
                                                                                                        validate14.errors =
                                                                                                            [
                                                                                                                {
                                                                                                                    instancePath:
                                                                                                                        instancePath +
                                                                                                                        '/result/presentation_allowed',
                                                                                                                    schemaPath:
                                                                                                                        '#/definitions/conference_status/properties/200/definitions/Result/properties/presentation_allowed/type',
                                                                                                                    keyword:
                                                                                                                        'type',
                                                                                                                    params: {
                                                                                                                        type: 'boolean',
                                                                                                                    },
                                                                                                                    message:
                                                                                                                        'must be boolean',
                                                                                                                },
                                                                                                            ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    var valid2 =
                                                                                                        _errs38 ===
                                                                                                        errors;
                                                                                                } else {
                                                                                                    var valid2 = true;
                                                                                                }
                                                                                                if (
                                                                                                    valid2
                                                                                                ) {
                                                                                                    if (
                                                                                                        data1.breakout_rooms !==
                                                                                                        undefined
                                                                                                    ) {
                                                                                                        const _errs40 =
                                                                                                            errors;
                                                                                                        if (
                                                                                                            typeof data1.breakout_rooms !==
                                                                                                            'boolean'
                                                                                                        ) {
                                                                                                            validate14.errors =
                                                                                                                [
                                                                                                                    {
                                                                                                                        instancePath:
                                                                                                                            instancePath +
                                                                                                                            '/result/breakout_rooms',
                                                                                                                        schemaPath:
                                                                                                                            '#/definitions/conference_status/properties/200/definitions/Result/properties/breakout_rooms/type',
                                                                                                                        keyword:
                                                                                                                            'type',
                                                                                                                        params: {
                                                                                                                            type: 'boolean',
                                                                                                                        },
                                                                                                                        message:
                                                                                                                            'must be boolean',
                                                                                                                    },
                                                                                                                ];
                                                                                                            return false;
                                                                                                        }
                                                                                                        var valid2 =
                                                                                                            _errs40 ===
                                                                                                            errors;
                                                                                                    } else {
                                                                                                        var valid2 = true;
                                                                                                    }
                                                                                                    if (
                                                                                                        valid2
                                                                                                    ) {
                                                                                                        if (
                                                                                                            data1.classification !==
                                                                                                            undefined
                                                                                                        ) {
                                                                                                            let data19 =
                                                                                                                data1.classification;
                                                                                                            const _errs42 =
                                                                                                                errors;
                                                                                                            if (!(
                                                                                                                data19 &&
                                                                                                                typeof data19 ==
                                                                                                                    'object' &&
                                                                                                                !Array.isArray(
                                                                                                                    data19,
                                                                                                                )
                                                                                                            )) {
                                                                                                                validate14.errors =
                                                                                                                    [
                                                                                                                        {
                                                                                                                            instancePath:
                                                                                                                                instancePath +
                                                                                                                                '/result/classification',
                                                                                                                            schemaPath:
                                                                                                                                '#/definitions/conference_status/properties/200/definitions/Result/properties/classification/type',
                                                                                                                            keyword:
                                                                                                                                'type',
                                                                                                                            params: {
                                                                                                                                type: 'object',
                                                                                                                            },
                                                                                                                            message:
                                                                                                                                'must be object',
                                                                                                                        },
                                                                                                                    ];
                                                                                                                return false;
                                                                                                            }
                                                                                                            var valid2 =
                                                                                                                _errs42 ===
                                                                                                                errors;
                                                                                                        } else {
                                                                                                            var valid2 = true;
                                                                                                        }
                                                                                                        if (
                                                                                                            valid2
                                                                                                        ) {
                                                                                                            if (
                                                                                                                data1.breakout_guests_allowed_to_leave !==
                                                                                                                undefined
                                                                                                            ) {
                                                                                                                const _errs44 =
                                                                                                                    errors;
                                                                                                                if (
                                                                                                                    typeof data1.breakout_guests_allowed_to_leave !==
                                                                                                                    'boolean'
                                                                                                                ) {
                                                                                                                    validate14.errors =
                                                                                                                        [
                                                                                                                            {
                                                                                                                                instancePath:
                                                                                                                                    instancePath +
                                                                                                                                    '/result/breakout_guests_allowed_to_leave',
                                                                                                                                schemaPath:
                                                                                                                                    '#/definitions/conference_status/properties/200/definitions/Result/properties/breakout_guests_allowed_to_leave/type',
                                                                                                                                keyword:
                                                                                                                                    'type',
                                                                                                                                params: {
                                                                                                                                    type: 'boolean',
                                                                                                                                },
                                                                                                                                message:
                                                                                                                                    'must be boolean',
                                                                                                                            },
                                                                                                                        ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                                var valid2 =
                                                                                                                    _errs44 ===
                                                                                                                    errors;
                                                                                                            } else {
                                                                                                                var valid2 = true;
                                                                                                            }
                                                                                                            if (
                                                                                                                valid2
                                                                                                            ) {
                                                                                                                if (
                                                                                                                    data1.breakoutbuzz !==
                                                                                                                    undefined
                                                                                                                ) {
                                                                                                                    let data21 =
                                                                                                                        data1.breakoutbuzz;
                                                                                                                    const _errs46 =
                                                                                                                        errors;
                                                                                                                    if (!(
                                                                                                                        data21 &&
                                                                                                                        typeof data21 ==
                                                                                                                            'object' &&
                                                                                                                        !Array.isArray(
                                                                                                                            data21,
                                                                                                                        )
                                                                                                                    )) {
                                                                                                                        validate14.errors =
                                                                                                                            [
                                                                                                                                {
                                                                                                                                    instancePath:
                                                                                                                                        instancePath +
                                                                                                                                        '/result/breakoutbuzz',
                                                                                                                                    schemaPath:
                                                                                                                                        '#/definitions/conference_status/properties/200/definitions/Result/properties/breakoutbuzz/type',
                                                                                                                                    keyword:
                                                                                                                                        'type',
                                                                                                                                    params: {
                                                                                                                                        type: 'object',
                                                                                                                                    },
                                                                                                                                    message:
                                                                                                                                        'must be object',
                                                                                                                                },
                                                                                                                            ];
                                                                                                                        return false;
                                                                                                                    }
                                                                                                                    var valid2 =
                                                                                                                        _errs46 ===
                                                                                                                        errors;
                                                                                                                } else {
                                                                                                                    var valid2 = true;
                                                                                                                }
                                                                                                                if (
                                                                                                                    valid2
                                                                                                                ) {
                                                                                                                    if (
                                                                                                                        data1.guests_can_unmute !==
                                                                                                                        undefined
                                                                                                                    ) {
                                                                                                                        const _errs48 =
                                                                                                                            errors;
                                                                                                                        if (
                                                                                                                            typeof data1.guests_can_unmute !==
                                                                                                                            'boolean'
                                                                                                                        ) {
                                                                                                                            validate14.errors =
                                                                                                                                [
                                                                                                                                    {
                                                                                                                                        instancePath:
                                                                                                                                            instancePath +
                                                                                                                                            '/result/guests_can_unmute',
                                                                                                                                        schemaPath:
                                                                                                                                            '#/definitions/conference_status/properties/200/definitions/Result/properties/guests_can_unmute/type',
                                                                                                                                        keyword:
                                                                                                                                            'type',
                                                                                                                                        params: {
                                                                                                                                            type: 'boolean',
                                                                                                                                        },
                                                                                                                                        message:
                                                                                                                                            'must be boolean',
                                                                                                                                    },
                                                                                                                                ];
                                                                                                                            return false;
                                                                                                                        }
                                                                                                                        var valid2 =
                                                                                                                            _errs48 ===
                                                                                                                            errors;
                                                                                                                    } else {
                                                                                                                        var valid2 = true;
                                                                                                                    }
                                                                                                                    if (
                                                                                                                        valid2
                                                                                                                    ) {
                                                                                                                        if (
                                                                                                                            data1.guests_can_present !==
                                                                                                                            undefined
                                                                                                                        ) {
                                                                                                                            const _errs50 =
                                                                                                                                errors;
                                                                                                                            if (
                                                                                                                                typeof data1.guests_can_present !==
                                                                                                                                'boolean'
                                                                                                                            ) {
                                                                                                                                validate14.errors =
                                                                                                                                    [
                                                                                                                                        {
                                                                                                                                            instancePath:
                                                                                                                                                instancePath +
                                                                                                                                                '/result/guests_can_present',
                                                                                                                                            schemaPath:
                                                                                                                                                '#/definitions/conference_status/properties/200/definitions/Result/properties/guests_can_present/type',
                                                                                                                                            keyword:
                                                                                                                                                'type',
                                                                                                                                            params: {
                                                                                                                                                type: 'boolean',
                                                                                                                                            },
                                                                                                                                            message:
                                                                                                                                                'must be boolean',
                                                                                                                                        },
                                                                                                                                    ];
                                                                                                                                return false;
                                                                                                                            }
                                                                                                                            var valid2 =
                                                                                                                                _errs50 ===
                                                                                                                                errors;
                                                                                                                        } else {
                                                                                                                            var valid2 = true;
                                                                                                                        }
                                                                                                                        if (
                                                                                                                            valid2
                                                                                                                        ) {
                                                                                                                            if (
                                                                                                                                data1.chat_enabled !==
                                                                                                                                undefined
                                                                                                                            ) {
                                                                                                                                const _errs52 =
                                                                                                                                    errors;
                                                                                                                                if (
                                                                                                                                    typeof data1.chat_enabled !==
                                                                                                                                    'boolean'
                                                                                                                                ) {
                                                                                                                                    validate14.errors =
                                                                                                                                        [
                                                                                                                                            {
                                                                                                                                                instancePath:
                                                                                                                                                    instancePath +
                                                                                                                                                    '/result/chat_enabled',
                                                                                                                                                schemaPath:
                                                                                                                                                    '#/definitions/conference_status/properties/200/definitions/Result/properties/chat_enabled/type',
                                                                                                                                                keyword:
                                                                                                                                                    'type',
                                                                                                                                                params: {
                                                                                                                                                    type: 'boolean',
                                                                                                                                                },
                                                                                                                                                message:
                                                                                                                                                    'must be boolean',
                                                                                                                                            },
                                                                                                                                        ];
                                                                                                                                    return false;
                                                                                                                                }
                                                                                                                                var valid2 =
                                                                                                                                    _errs52 ===
                                                                                                                                    errors;
                                                                                                                            } else {
                                                                                                                                var valid2 = true;
                                                                                                                            }
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    validate14.errors = [
                                        {
                                            instancePath:
                                                instancePath + '/result',
                                            schemaPath:
                                                '#/definitions/conference_status/properties/200/definitions/Result/type',
                                            keyword: 'type',
                                            params: {type: 'object'},
                                            message: 'must be object',
                                        },
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs4 === errors;
                        } else {
                            var valid0 = true;
                        }
                    }
                }
            }
        } else {
            validate14.errors = [
                {
                    instancePath,
                    schemaPath: '#/type',
                    keyword: 'type',
                    params: {type: 'object'},
                    message: 'must be object',
                },
            ];
            return false;
        }
    }
    validate14.errors = vErrors;
    return errors === 0;
}
function validate13(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (
        !validate14(data, {
            instancePath,
            parentData,
            parentDataProperty,
            rootData,
        })
    ) {
        vErrors =
            vErrors === null
                ? validate14.errors
                : vErrors.concat(validate14.errors);
        errors = vErrors.length;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err0 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err0];
        } else {
            vErrors.push(err0);
        }
        errors++;
        validate13.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate13.errors = vErrors;
    return errors === 0;
}
export const validateLock200 = validate16;
const schema19 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        '200': {
            type: 'object',
            additionalProperties: false,
            properties: {
                status: {
                    type: 'string',
                    description: 'Status of the response, eg. success.',
                    enum: ['success'],
                },
                result: {
                    type: 'boolean',
                    description:
                        'The result is true if successful, false otherwise.',
                },
            },
            required: ['status', 'result'],
            title: 'Status200',
        },
    },
    oneOf: [{$ref: '#/definitions/lock/properties/200/definitions/200'}],
};
const schema20 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        status: {
            type: 'string',
            description: 'Status of the response, eg. success.',
            enum: ['success'],
        },
        result: {
            type: 'boolean',
            description: 'The result is true if successful, false otherwise.',
        },
    },
    required: ['status', 'result'],
    title: 'Status200',
};
function validate16(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))
            ) {
                const err0 = {
                    instancePath,
                    schemaPath:
                        '#/definitions/lock/properties/200/definitions/200/required',
                    keyword: 'required',
                    params: {missingProperty: missing0},
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                } else {
                    vErrors.push(err0);
                }
                errors++;
            } else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/type',
                                keyword: 'type',
                                params: {type: 'string'},
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            } else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(data0 === 'success')) {
                            const err2 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues:
                                        schema20.properties.status.enum,
                                },
                                message:
                                    'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            } else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    } else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.result !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.result !== 'boolean') {
                                const err3 = {
                                    instancePath: instancePath + '/result',
                                    schemaPath:
                                        '#/definitions/lock/properties/200/definitions/200/properties/result/type',
                                    keyword: 'type',
                                    params: {type: 'boolean'},
                                    message: 'must be boolean',
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                } else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var valid2 = _errs7 === errors;
                        } else {
                            var valid2 = true;
                        }
                    }
                }
            }
        } else {
            const err4 = {
                instancePath,
                schemaPath:
                    '#/definitions/lock/properties/200/definitions/200/type',
                keyword: 'type',
                params: {type: 'object'},
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err4];
            } else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err5];
        } else {
            vErrors.push(err5);
        }
        errors++;
        validate16.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate16.errors = vErrors;
    return errors === 0;
}
export const validateUnlock200 = validate17;
function validate17(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))
            ) {
                const err0 = {
                    instancePath,
                    schemaPath:
                        '#/definitions/lock/properties/200/definitions/200/required',
                    keyword: 'required',
                    params: {missingProperty: missing0},
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                } else {
                    vErrors.push(err0);
                }
                errors++;
            } else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/type',
                                keyword: 'type',
                                params: {type: 'string'},
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            } else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(data0 === 'success')) {
                            const err2 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues:
                                        schema20.properties.status.enum,
                                },
                                message:
                                    'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            } else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    } else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.result !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.result !== 'boolean') {
                                const err3 = {
                                    instancePath: instancePath + '/result',
                                    schemaPath:
                                        '#/definitions/lock/properties/200/definitions/200/properties/result/type',
                                    keyword: 'type',
                                    params: {type: 'boolean'},
                                    message: 'must be boolean',
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                } else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var valid2 = _errs7 === errors;
                        } else {
                            var valid2 = true;
                        }
                    }
                }
            }
        } else {
            const err4 = {
                instancePath,
                schemaPath:
                    '#/definitions/lock/properties/200/definitions/200/type',
                keyword: 'type',
                params: {type: 'object'},
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err4];
            } else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err5];
        } else {
            vErrors.push(err5);
        }
        errors++;
        validate17.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate17.errors = vErrors;
    return errors === 0;
}
export const validateStartConference200 = validate18;
function validate18(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))
            ) {
                const err0 = {
                    instancePath,
                    schemaPath:
                        '#/definitions/lock/properties/200/definitions/200/required',
                    keyword: 'required',
                    params: {missingProperty: missing0},
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                } else {
                    vErrors.push(err0);
                }
                errors++;
            } else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/type',
                                keyword: 'type',
                                params: {type: 'string'},
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            } else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(data0 === 'success')) {
                            const err2 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues:
                                        schema20.properties.status.enum,
                                },
                                message:
                                    'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            } else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    } else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.result !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.result !== 'boolean') {
                                const err3 = {
                                    instancePath: instancePath + '/result',
                                    schemaPath:
                                        '#/definitions/lock/properties/200/definitions/200/properties/result/type',
                                    keyword: 'type',
                                    params: {type: 'boolean'},
                                    message: 'must be boolean',
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                } else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var valid2 = _errs7 === errors;
                        } else {
                            var valid2 = true;
                        }
                    }
                }
            }
        } else {
            const err4 = {
                instancePath,
                schemaPath:
                    '#/definitions/lock/properties/200/definitions/200/type',
                keyword: 'type',
                params: {type: 'object'},
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err4];
            } else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err5];
        } else {
            vErrors.push(err5);
        }
        errors++;
        validate18.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate18.errors = vErrors;
    return errors === 0;
}
export const validateMuteguests200 = validate19;
function validate19(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))
            ) {
                const err0 = {
                    instancePath,
                    schemaPath:
                        '#/definitions/lock/properties/200/definitions/200/required',
                    keyword: 'required',
                    params: {missingProperty: missing0},
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                } else {
                    vErrors.push(err0);
                }
                errors++;
            } else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/type',
                                keyword: 'type',
                                params: {type: 'string'},
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            } else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(data0 === 'success')) {
                            const err2 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues:
                                        schema20.properties.status.enum,
                                },
                                message:
                                    'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            } else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    } else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.result !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.result !== 'boolean') {
                                const err3 = {
                                    instancePath: instancePath + '/result',
                                    schemaPath:
                                        '#/definitions/lock/properties/200/definitions/200/properties/result/type',
                                    keyword: 'type',
                                    params: {type: 'boolean'},
                                    message: 'must be boolean',
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                } else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var valid2 = _errs7 === errors;
                        } else {
                            var valid2 = true;
                        }
                    }
                }
            }
        } else {
            const err4 = {
                instancePath,
                schemaPath:
                    '#/definitions/lock/properties/200/definitions/200/type',
                keyword: 'type',
                params: {type: 'object'},
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err4];
            } else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err5];
        } else {
            vErrors.push(err5);
        }
        errors++;
        validate19.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate19.errors = vErrors;
    return errors === 0;
}
export const validateUnmuteguests200 = validate20;
function validate20(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))
            ) {
                const err0 = {
                    instancePath,
                    schemaPath:
                        '#/definitions/lock/properties/200/definitions/200/required',
                    keyword: 'required',
                    params: {missingProperty: missing0},
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                } else {
                    vErrors.push(err0);
                }
                errors++;
            } else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/type',
                                keyword: 'type',
                                params: {type: 'string'},
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            } else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(data0 === 'success')) {
                            const err2 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues:
                                        schema20.properties.status.enum,
                                },
                                message:
                                    'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            } else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    } else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.result !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.result !== 'boolean') {
                                const err3 = {
                                    instancePath: instancePath + '/result',
                                    schemaPath:
                                        '#/definitions/lock/properties/200/definitions/200/properties/result/type',
                                    keyword: 'type',
                                    params: {type: 'boolean'},
                                    message: 'must be boolean',
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                } else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var valid2 = _errs7 === errors;
                        } else {
                            var valid2 = true;
                        }
                    }
                }
            }
        } else {
            const err4 = {
                instancePath,
                schemaPath:
                    '#/definitions/lock/properties/200/definitions/200/type',
                keyword: 'type',
                params: {type: 'object'},
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err4];
            } else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err5];
        } else {
            vErrors.push(err5);
        }
        errors++;
        validate20.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate20.errors = vErrors;
    return errors === 0;
}
export const validateSetGuestsCanUnmuteBody = validate21;
const schema29 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        TopLevel: {
            type: 'object',
            additionalProperties: false,
            properties: {
                setting: {
                    type: 'boolean',
                    description:
                        'API at the conference level which allows a Host to configure whether or not Guests can unmute themselves when they have been muted by a Host (either directly muted or via mute-all-guests setting).',
                },
            },
            required: ['setting'],
            title: 'TopLevel',
        },
    },
    oneOf: [
        {
            $ref: '#/definitions/set_guests_can_unmute/properties/Body/definitions/TopLevel',
        },
    ],
};
const schema30 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        setting: {
            type: 'boolean',
            description:
                'API at the conference level which allows a Host to configure whether or not Guests can unmute themselves when they have been muted by a Host (either directly muted or via mute-all-guests setting).',
        },
    },
    required: ['setting'],
    title: 'TopLevel',
};
function validate21(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.setting === undefined && (missing0 = 'setting')) {
                const err0 = {
                    instancePath,
                    schemaPath:
                        '#/definitions/set_guests_can_unmute/properties/Body/definitions/TopLevel/required',
                    keyword: 'required',
                    params: {missingProperty: missing0},
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                } else {
                    vErrors.push(err0);
                }
                errors++;
            } else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'setting')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.setting !== undefined) {
                        if (typeof data.setting !== 'boolean') {
                            const err1 = {
                                instancePath: instancePath + '/setting',
                                schemaPath:
                                    '#/definitions/set_guests_can_unmute/properties/Body/definitions/TopLevel/properties/setting/type',
                                keyword: 'type',
                                params: {type: 'boolean'},
                                message: 'must be boolean',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            } else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                    }
                }
            }
        } else {
            const err2 = {
                instancePath,
                schemaPath:
                    '#/definitions/set_guests_can_unmute/properties/Body/definitions/TopLevel/type',
                keyword: 'type',
                params: {type: 'object'},
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err2];
            } else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err3 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err3];
        } else {
            vErrors.push(err3);
        }
        errors++;
        validate21.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate21.errors = vErrors;
    return errors === 0;
}
export const validateSetGuestsCanUnmute200 = validate22;
function validate22(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))
            ) {
                const err0 = {
                    instancePath,
                    schemaPath:
                        '#/definitions/lock/properties/200/definitions/200/required',
                    keyword: 'required',
                    params: {missingProperty: missing0},
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                } else {
                    vErrors.push(err0);
                }
                errors++;
            } else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/type',
                                keyword: 'type',
                                params: {type: 'string'},
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            } else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(data0 === 'success')) {
                            const err2 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues:
                                        schema20.properties.status.enum,
                                },
                                message:
                                    'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            } else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    } else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.result !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.result !== 'boolean') {
                                const err3 = {
                                    instancePath: instancePath + '/result',
                                    schemaPath:
                                        '#/definitions/lock/properties/200/definitions/200/properties/result/type',
                                    keyword: 'type',
                                    params: {type: 'boolean'},
                                    message: 'must be boolean',
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                } else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var valid2 = _errs7 === errors;
                        } else {
                            var valid2 = true;
                        }
                    }
                }
            }
        } else {
            const err4 = {
                instancePath,
                schemaPath:
                    '#/definitions/lock/properties/200/definitions/200/type',
                keyword: 'type',
                params: {type: 'object'},
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err4];
            } else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err5];
        } else {
            vErrors.push(err5);
        }
        errors++;
        validate22.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate22.errors = vErrors;
    return errors === 0;
}
export const validateDisconnect200 = validate23;
function validate23(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))
            ) {
                const err0 = {
                    instancePath,
                    schemaPath:
                        '#/definitions/lock/properties/200/definitions/200/required',
                    keyword: 'required',
                    params: {missingProperty: missing0},
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                } else {
                    vErrors.push(err0);
                }
                errors++;
            } else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/type',
                                keyword: 'type',
                                params: {type: 'string'},
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            } else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(data0 === 'success')) {
                            const err2 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues:
                                        schema20.properties.status.enum,
                                },
                                message:
                                    'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            } else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    } else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.result !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.result !== 'boolean') {
                                const err3 = {
                                    instancePath: instancePath + '/result',
                                    schemaPath:
                                        '#/definitions/lock/properties/200/definitions/200/properties/result/type',
                                    keyword: 'type',
                                    params: {type: 'boolean'},
                                    message: 'must be boolean',
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                } else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var valid2 = _errs7 === errors;
                        } else {
                            var valid2 = true;
                        }
                    }
                }
            }
        } else {
            const err4 = {
                instancePath,
                schemaPath:
                    '#/definitions/lock/properties/200/definitions/200/type',
                keyword: 'type',
                params: {type: 'object'},
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err4];
            } else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err5];
        } else {
            vErrors.push(err5);
        }
        errors++;
        validate23.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate23.errors = vErrors;
    return errors === 0;
}
export const validateMessageConferenceBody = validate24;
const schema35 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        TopLevel: {
            type: 'object',
            additionalProperties: false,
            properties: {
                type: {
                    type: 'string',
                    enum: ['text/plain', 'application/json'],
                    description: 'The MIME Content-Type.',
                },
                payload: {type: 'string', description: 'Message to send.'},
            },
            required: ['type', 'payload'],
            title: 'TopLevel',
        },
    },
    oneOf: [
        {
            $ref: '#/definitions/message_conference/properties/Body/definitions/TopLevel',
        },
    ],
};
const schema36 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        type: {
            type: 'string',
            enum: ['text/plain', 'application/json'],
            description: 'The MIME Content-Type.',
        },
        payload: {type: 'string', description: 'Message to send.'},
    },
    required: ['type', 'payload'],
    title: 'TopLevel',
};
function validate24(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.type === undefined && (missing0 = 'type')) ||
                (data.payload === undefined && (missing0 = 'payload'))
            ) {
                const err0 = {
                    instancePath,
                    schemaPath:
                        '#/definitions/message_conference/properties/Body/definitions/TopLevel/required',
                    keyword: 'required',
                    params: {missingProperty: missing0},
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                } else {
                    vErrors.push(err0);
                }
                errors++;
            } else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'type' || key0 === 'payload')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.type !== undefined) {
                        let data0 = data.type;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/type',
                                schemaPath:
                                    '#/definitions/message_conference/properties/Body/definitions/TopLevel/properties/type/type',
                                keyword: 'type',
                                params: {type: 'string'},
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            } else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(
                            data0 === 'text/plain' ||
                            data0 === 'application/json'
                        )) {
                            const err2 = {
                                instancePath: instancePath + '/type',
                                schemaPath:
                                    '#/definitions/message_conference/properties/Body/definitions/TopLevel/properties/type/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues:
                                        schema36.properties.type.enum,
                                },
                                message:
                                    'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            } else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    } else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.payload !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.payload !== 'string') {
                                const err3 = {
                                    instancePath: instancePath + '/payload',
                                    schemaPath:
                                        '#/definitions/message_conference/properties/Body/definitions/TopLevel/properties/payload/type',
                                    keyword: 'type',
                                    params: {type: 'string'},
                                    message: 'must be string',
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                } else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var valid2 = _errs7 === errors;
                        } else {
                            var valid2 = true;
                        }
                    }
                }
            }
        } else {
            const err4 = {
                instancePath,
                schemaPath:
                    '#/definitions/message_conference/properties/Body/definitions/TopLevel/type',
                keyword: 'type',
                params: {type: 'object'},
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err4];
            } else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err5];
        } else {
            vErrors.push(err5);
        }
        errors++;
        validate24.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate24.errors = vErrors;
    return errors === 0;
}
export const validateMessageConference200 = validate25;
function validate25(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))
            ) {
                const err0 = {
                    instancePath,
                    schemaPath:
                        '#/definitions/lock/properties/200/definitions/200/required',
                    keyword: 'required',
                    params: {missingProperty: missing0},
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                } else {
                    vErrors.push(err0);
                }
                errors++;
            } else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/type',
                                keyword: 'type',
                                params: {type: 'string'},
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            } else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(data0 === 'success')) {
                            const err2 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues:
                                        schema20.properties.status.enum,
                                },
                                message:
                                    'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            } else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    } else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.result !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.result !== 'boolean') {
                                const err3 = {
                                    instancePath: instancePath + '/result',
                                    schemaPath:
                                        '#/definitions/lock/properties/200/definitions/200/properties/result/type',
                                    keyword: 'type',
                                    params: {type: 'boolean'},
                                    message: 'must be boolean',
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                } else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var valid2 = _errs7 === errors;
                        } else {
                            var valid2 = true;
                        }
                    }
                }
            }
        } else {
            const err4 = {
                instancePath,
                schemaPath:
                    '#/definitions/lock/properties/200/definitions/200/type',
                keyword: 'type',
                params: {type: 'object'},
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err4];
            } else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err5];
        } else {
            vErrors.push(err5);
        }
        errors++;
        validate25.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate25.errors = vErrors;
    return errors === 0;
}
export const validateMessageConference404 = validate26;
const schema39 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        '404': {
            type: 'object',
            additionalProperties: false,
            properties: {
                status: {
                    type: 'string',
                    description: 'Status of the response, eg. failed.',
                    enum: ['failed'],
                },
                result: {type: 'string'},
            },
            required: ['status', 'result'],
            title: 'Status404',
        },
    },
    oneOf: [
        {
            $ref: '#/definitions/message_conference/properties/404/definitions/404',
        },
    ],
};
const schema40 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        status: {
            type: 'string',
            description: 'Status of the response, eg. failed.',
            enum: ['failed'],
        },
        result: {type: 'string'},
    },
    required: ['status', 'result'],
    title: 'Status404',
};
function validate26(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))
            ) {
                const err0 = {
                    instancePath,
                    schemaPath:
                        '#/definitions/message_conference/properties/404/definitions/404/required',
                    keyword: 'required',
                    params: {missingProperty: missing0},
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                } else {
                    vErrors.push(err0);
                }
                errors++;
            } else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/message_conference/properties/404/definitions/404/properties/status/type',
                                keyword: 'type',
                                params: {type: 'string'},
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            } else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(data0 === 'failed')) {
                            const err2 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/message_conference/properties/404/definitions/404/properties/status/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues:
                                        schema40.properties.status.enum,
                                },
                                message:
                                    'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            } else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    } else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.result !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.result !== 'string') {
                                const err3 = {
                                    instancePath: instancePath + '/result',
                                    schemaPath:
                                        '#/definitions/message_conference/properties/404/definitions/404/properties/result/type',
                                    keyword: 'type',
                                    params: {type: 'string'},
                                    message: 'must be string',
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                } else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var valid2 = _errs7 === errors;
                        } else {
                            var valid2 = true;
                        }
                    }
                }
            }
        } else {
            const err4 = {
                instancePath,
                schemaPath:
                    '#/definitions/message_conference/properties/404/definitions/404/type',
                keyword: 'type',
                params: {type: 'object'},
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err4];
            } else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err5];
        } else {
            vErrors.push(err5);
        }
        errors++;
        validate26.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate26.errors = vErrors;
    return errors === 0;
}
export const validateParticipants200 = validate27;
const schema41 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        '200': {
            type: 'object',
            additionalProperties: false,
            properties: {
                status: {
                    type: 'string',
                    description: 'Status of the response, eg. success.',
                    enum: ['success'],
                },
                result: {
                    type: 'array',
                    items: {
                        $ref: '#/definitions/participants/properties/200/definitions/Participant',
                    },
                },
            },
            required: ['status', 'result'],
            title: 'Status200',
        },
        PersonalMix: {
            type: 'object',
            additionalProperties: false,
            properties: {
                mix_name: {
                    type: 'string',
                    description:
                        'The name of the current mix received by the participant',
                },
                timestamp: {
                    type: 'number',
                    description: 'Last updated timestamp.',
                },
                mix_config: {
                    type: 'object',
                    additionalProperties: false,
                    description:
                        'Config of the currently received mix by the participant',
                    properties: {
                        transform_layout: {
                            type: 'object',
                            additionalProperties: false,
                            description:
                                'The currently applied layout transformations.',
                            properties: {
                                layout: {
                                    type: 'string',
                                    description:
                                        'In VMRs the layout for Hosts and Guests is controlled by the layout parameter.',
                                },
                            },
                        },
                    },
                },
            },
            required: ['mix_name', 'timestamp'],
        },
        Participant: {
            type: 'object',
            additionalProperties: false,
            properties: {
                api_url: {type: 'string'},
                buzz_time: {
                    type: 'number',
                    description:
                        'A Unix timestamp of when this participant raised their hand, otherwise zero.',
                },
                call_direction: {
                    type: 'string',
                    enum: ['in', 'out'],
                    description:
                        'Either `in` or `out` as to whether this is an inbound or outbound call.',
                },
                call_tag: {
                    type: 'string',
                    description:
                        'An optional call tag that is assigned to this participant.',
                },
                disconnect_supported: {
                    type: 'string',
                    enum: ['YES', 'NO'],
                    description:
                        'Set to `YES` if the participant can be disconnected, `NO` if not.',
                },
                display_name: {
                    type: 'string',
                    description: 'The display name of the participant.',
                },
                encryption: {
                    type: 'string',
                    enum: ['On', 'Off', 'Unknown'],
                    description:
                        '`On`, `Off`, or `Unknown` as to whether this participant is connected via encrypted media.',
                },
                external_node_uuid: {
                    type: 'string',
                    description:
                        'The UUID of an external node e.g. a Skype for Business / Lync meeting associated with an external participant. This allows grouping of external participants as the UUID will be the same for all participants associated with that external node.',
                },
                fecc_supported: {
                    type: 'string',
                    enum: ['YES', 'NO'],
                    description:
                        'Set to `YES` if this participant can be sent FECC messages; `NO` if not.',
                },
                has_media: {
                    type: 'boolean',
                    description:
                        'Boolean indicating whether the user has media capabilities.',
                },
                is_audio_only_call: {
                    type: 'string',
                    enum: ['YES', 'NO'],
                    description: 'Set to `YES` if the call is audio only.',
                },
                is_client_muted: {
                    type: 'boolean',
                    description:
                        'Boolean indicating if the participant is client side muted.',
                },
                is_conjoined: {
                    type: 'boolean',
                    description:
                        'Boolean indicating if the participant is conjoined with another breakout room or main room.',
                },
                is_external: {
                    type: 'boolean',
                    description:
                        'Boolean indicating if it is an external participant, e.g. coming in from a Skype for Business / Lync meeting.',
                },
                is_idp_authenticated: {
                    type: 'boolean',
                    description:
                        'Boolean indicating if the participant is authenticated by an IDP.',
                },
                is_muted: {
                    type: 'string',
                    enum: ['YES', 'NO'],
                    description:
                        'Set to `YES` if the participant is administratively audio muted.',
                },
                is_presenting: {
                    type: 'string',
                    enum: ['YES', 'NO'],
                    description:
                        'Set to `YES` if the participant is the current presenter.',
                },
                is_streaming_conference: {
                    type: 'boolean',
                    description:
                        'Boolean indicating whether this is a streaming/recording participant.',
                },
                is_transferring: {
                    type: 'boolean',
                    description:
                        'Boolean indicating whether the participant is in the process of transferring to another VMR.',
                },
                is_video_call: {
                    type: 'string',
                    enum: ['YES', 'NO'],
                    description:
                        'Set to `YES` if the call has video capability.',
                },
                is_video_muted: {
                    type: 'boolean',
                    description:
                        'Boolean indicating whether this participant is administratively video muted.',
                },
                is_video_silent: {
                    type: 'boolean',
                    description:
                        'When participant is considered silent. Eg when frozen, black or outside of the frame.',
                },
                is_main_video_dropped_out: {type: 'boolean'},
                local_alias: {
                    type: 'string',
                    description:
                        'The calling or `from` alias. This is the alias that the recipient would use to return the call.',
                },
                mute_supported: {
                    type: 'string',
                    enum: ['YES', 'NO'],
                    description:
                        'Set to `YES` if the participant can be muted, `NO` if not.',
                },
                needs_presentation_in_mix: {type: 'boolean'},
                overlay_text: {
                    type: 'string',
                    description:
                        'Text that may be used as an alternative to display_name as the participant name overlay text.',
                },
                presentation_supported: {
                    type: 'string',
                    enum: ['YES', 'NO'],
                    description:
                        'Set to `YES` if the presentation is supported, `NO` if not.',
                },
                protocol: {
                    type: 'string',
                    enum: ['api', 'webrtc', 'sip', 'rtmp', 'h323', 'mssip', ''],
                    description:
                        'The call protocol.Empty for Guest participants.(Note that the protocol is always reported as `api` when an Infinity Connect client dials in to Pexip Infinity.)',
                },
                role: {
                    type: 'string',
                    enum: ['chair', 'guest'],
                    description:
                        'The level of privileges the participant has in the conference',
                },
                rx_presentation_policy: {
                    type: 'string',
                    enum: ['ALLOW', 'DENY'],
                    description:
                        'Set to `ALLOW` if the participant is administratively allowed to receive presentation, or `DENY` if disallowed.',
                },
                service_type: {
                    type: 'string',
                    enum: [
                        'connecting',
                        'waiting_room',
                        'ivr',
                        'conference',
                        'lecture',
                        'gateway',
                        'test_call',
                    ],
                },
                spotlight: {
                    type: 'number',
                    description:
                        'A Unix timestamp of when this participant was spotlighted, if spotlight is used.',
                },
                start_time: {
                    type: ['number', 'null'],
                    description:
                        'A Unix timestamp of when this participant joined (UTC).',
                },
                supports_direct_chat: {
                    type: 'boolean',
                    description:
                        'Boolean indicating whether the participant can receive and send a direct chat message..',
                },
                transfer_supported: {
                    type: 'string',
                    enum: ['YES', 'NO'],
                    description:
                        'Set to `YES` if this participant can be transferred into another VMR; `NO` if not.',
                },
                uuid: {
                    type: 'string',
                    description:
                        'The UUID of this participant, to use with other operations.',
                },
                uri: {
                    type: 'string',
                    description:
                        'The URI of the participant. Empty for Guest participants.',
                },
                vendor: {
                    type: 'string',
                    description:
                        'The vendor identifier of the browser/endpoint with which the participant is connecting. Empty for Guest participants.',
                },
                last_spoken_time: {
                    type: 'number',
                    description:
                        'A Unix timestamp of when this participant last spoke, otherwise zero.',
                },
                can_receive_personal_mix: {
                    type: 'boolean',
                    description: 'Can the participant receive personal mix.',
                },
                receive_from_video_mix: {
                    $ref: '#/definitions/participants/properties/200/definitions/PersonalMix',
                    description:
                        'The personal video mix received by the participant.',
                },
            },
            required: [
                'buzz_time',
                'call_direction',
                'disconnect_supported',
                'display_name',
                'encryption',
                'external_node_uuid',
                'fecc_supported',
                'has_media',
                'is_audio_only_call',
                'is_external',
                'is_muted',
                'is_presenting',
                'is_streaming_conference',
                'is_video_call',
                'is_video_muted',
                'is_video_silent',
                'local_alias',
                'mute_supported',
                'overlay_text',
                'protocol',
                'role',
                'rx_presentation_policy',
                'spotlight',
                'start_time',
                'supports_direct_chat',
                'transfer_supported',
                'uuid',
                'can_receive_personal_mix',
                'receive_from_video_mix',
            ],
            title: 'Participant',
        },
    },
    oneOf: [
        {$ref: '#/definitions/participants/properties/200/definitions/200'},
    ],
};
const schema42 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        status: {
            type: 'string',
            description: 'Status of the response, eg. success.',
            enum: ['success'],
        },
        result: {
            type: 'array',
            items: {
                $ref: '#/definitions/participants/properties/200/definitions/Participant',
            },
        },
    },
    required: ['status', 'result'],
    title: 'Status200',
};
const schema43 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        api_url: {type: 'string'},
        buzz_time: {
            type: 'number',
            description:
                'A Unix timestamp of when this participant raised their hand, otherwise zero.',
        },
        call_direction: {
            type: 'string',
            enum: ['in', 'out'],
            description:
                'Either `in` or `out` as to whether this is an inbound or outbound call.',
        },
        call_tag: {
            type: 'string',
            description:
                'An optional call tag that is assigned to this participant.',
        },
        disconnect_supported: {
            type: 'string',
            enum: ['YES', 'NO'],
            description:
                'Set to `YES` if the participant can be disconnected, `NO` if not.',
        },
        display_name: {
            type: 'string',
            description: 'The display name of the participant.',
        },
        encryption: {
            type: 'string',
            enum: ['On', 'Off', 'Unknown'],
            description:
                '`On`, `Off`, or `Unknown` as to whether this participant is connected via encrypted media.',
        },
        external_node_uuid: {
            type: 'string',
            description:
                'The UUID of an external node e.g. a Skype for Business / Lync meeting associated with an external participant. This allows grouping of external participants as the UUID will be the same for all participants associated with that external node.',
        },
        fecc_supported: {
            type: 'string',
            enum: ['YES', 'NO'],
            description:
                'Set to `YES` if this participant can be sent FECC messages; `NO` if not.',
        },
        has_media: {
            type: 'boolean',
            description:
                'Boolean indicating whether the user has media capabilities.',
        },
        is_audio_only_call: {
            type: 'string',
            enum: ['YES', 'NO'],
            description: 'Set to `YES` if the call is audio only.',
        },
        is_client_muted: {
            type: 'boolean',
            description:
                'Boolean indicating if the participant is client side muted.',
        },
        is_conjoined: {
            type: 'boolean',
            description:
                'Boolean indicating if the participant is conjoined with another breakout room or main room.',
        },
        is_external: {
            type: 'boolean',
            description:
                'Boolean indicating if it is an external participant, e.g. coming in from a Skype for Business / Lync meeting.',
        },
        is_idp_authenticated: {
            type: 'boolean',
            description:
                'Boolean indicating if the participant is authenticated by an IDP.',
        },
        is_muted: {
            type: 'string',
            enum: ['YES', 'NO'],
            description:
                'Set to `YES` if the participant is administratively audio muted.',
        },
        is_presenting: {
            type: 'string',
            enum: ['YES', 'NO'],
            description:
                'Set to `YES` if the participant is the current presenter.',
        },
        is_streaming_conference: {
            type: 'boolean',
            description:
                'Boolean indicating whether this is a streaming/recording participant.',
        },
        is_transferring: {
            type: 'boolean',
            description:
                'Boolean indicating whether the participant is in the process of transferring to another VMR.',
        },
        is_video_call: {
            type: 'string',
            enum: ['YES', 'NO'],
            description: 'Set to `YES` if the call has video capability.',
        },
        is_video_muted: {
            type: 'boolean',
            description:
                'Boolean indicating whether this participant is administratively video muted.',
        },
        is_video_silent: {
            type: 'boolean',
            description:
                'When participant is considered silent. Eg when frozen, black or outside of the frame.',
        },
        is_main_video_dropped_out: {type: 'boolean'},
        local_alias: {
            type: 'string',
            description:
                'The calling or `from` alias. This is the alias that the recipient would use to return the call.',
        },
        mute_supported: {
            type: 'string',
            enum: ['YES', 'NO'],
            description:
                'Set to `YES` if the participant can be muted, `NO` if not.',
        },
        needs_presentation_in_mix: {type: 'boolean'},
        overlay_text: {
            type: 'string',
            description:
                'Text that may be used as an alternative to display_name as the participant name overlay text.',
        },
        presentation_supported: {
            type: 'string',
            enum: ['YES', 'NO'],
            description:
                'Set to `YES` if the presentation is supported, `NO` if not.',
        },
        protocol: {
            type: 'string',
            enum: ['api', 'webrtc', 'sip', 'rtmp', 'h323', 'mssip', ''],
            description:
                'The call protocol.Empty for Guest participants.(Note that the protocol is always reported as `api` when an Infinity Connect client dials in to Pexip Infinity.)',
        },
        role: {
            type: 'string',
            enum: ['chair', 'guest'],
            description:
                'The level of privileges the participant has in the conference',
        },
        rx_presentation_policy: {
            type: 'string',
            enum: ['ALLOW', 'DENY'],
            description:
                'Set to `ALLOW` if the participant is administratively allowed to receive presentation, or `DENY` if disallowed.',
        },
        service_type: {
            type: 'string',
            enum: [
                'connecting',
                'waiting_room',
                'ivr',
                'conference',
                'lecture',
                'gateway',
                'test_call',
            ],
        },
        spotlight: {
            type: 'number',
            description:
                'A Unix timestamp of when this participant was spotlighted, if spotlight is used.',
        },
        start_time: {
            type: ['number', 'null'],
            description:
                'A Unix timestamp of when this participant joined (UTC).',
        },
        supports_direct_chat: {
            type: 'boolean',
            description:
                'Boolean indicating whether the participant can receive and send a direct chat message..',
        },
        transfer_supported: {
            type: 'string',
            enum: ['YES', 'NO'],
            description:
                'Set to `YES` if this participant can be transferred into another VMR; `NO` if not.',
        },
        uuid: {
            type: 'string',
            description:
                'The UUID of this participant, to use with other operations.',
        },
        uri: {
            type: 'string',
            description:
                'The URI of the participant. Empty for Guest participants.',
        },
        vendor: {
            type: 'string',
            description:
                'The vendor identifier of the browser/endpoint with which the participant is connecting. Empty for Guest participants.',
        },
        last_spoken_time: {
            type: 'number',
            description:
                'A Unix timestamp of when this participant last spoke, otherwise zero.',
        },
        can_receive_personal_mix: {
            type: 'boolean',
            description: 'Can the participant receive personal mix.',
        },
        receive_from_video_mix: {
            $ref: '#/definitions/participants/properties/200/definitions/PersonalMix',
            description: 'The personal video mix received by the participant.',
        },
    },
    required: [
        'buzz_time',
        'call_direction',
        'disconnect_supported',
        'display_name',
        'encryption',
        'external_node_uuid',
        'fecc_supported',
        'has_media',
        'is_audio_only_call',
        'is_external',
        'is_muted',
        'is_presenting',
        'is_streaming_conference',
        'is_video_call',
        'is_video_muted',
        'is_video_silent',
        'local_alias',
        'mute_supported',
        'overlay_text',
        'protocol',
        'role',
        'rx_presentation_policy',
        'spotlight',
        'start_time',
        'supports_direct_chat',
        'transfer_supported',
        'uuid',
        'can_receive_personal_mix',
        'receive_from_video_mix',
    ],
    title: 'Participant',
};
const schema44 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        mix_name: {
            type: 'string',
            description:
                'The name of the current mix received by the participant',
        },
        timestamp: {type: 'number', description: 'Last updated timestamp.'},
        mix_config: {
            type: 'object',
            additionalProperties: false,
            description:
                'Config of the currently received mix by the participant',
            properties: {
                transform_layout: {
                    type: 'object',
                    additionalProperties: false,
                    description:
                        'The currently applied layout transformations.',
                    properties: {
                        layout: {
                            type: 'string',
                            description:
                                'In VMRs the layout for Hosts and Guests is controlled by the layout parameter.',
                        },
                    },
                },
            },
        },
    },
    required: ['mix_name', 'timestamp'],
};
function validate29(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.buzz_time === undefined && (missing0 = 'buzz_time')) ||
                (data.call_direction === undefined &&
                    (missing0 = 'call_direction')) ||
                (data.disconnect_supported === undefined &&
                    (missing0 = 'disconnect_supported')) ||
                (data.display_name === undefined &&
                    (missing0 = 'display_name')) ||
                (data.encryption === undefined && (missing0 = 'encryption')) ||
                (data.external_node_uuid === undefined &&
                    (missing0 = 'external_node_uuid')) ||
                (data.fecc_supported === undefined &&
                    (missing0 = 'fecc_supported')) ||
                (data.has_media === undefined && (missing0 = 'has_media')) ||
                (data.is_audio_only_call === undefined &&
                    (missing0 = 'is_audio_only_call')) ||
                (data.is_external === undefined &&
                    (missing0 = 'is_external')) ||
                (data.is_muted === undefined && (missing0 = 'is_muted')) ||
                (data.is_presenting === undefined &&
                    (missing0 = 'is_presenting')) ||
                (data.is_streaming_conference === undefined &&
                    (missing0 = 'is_streaming_conference')) ||
                (data.is_video_call === undefined &&
                    (missing0 = 'is_video_call')) ||
                (data.is_video_muted === undefined &&
                    (missing0 = 'is_video_muted')) ||
                (data.is_video_silent === undefined &&
                    (missing0 = 'is_video_silent')) ||
                (data.local_alias === undefined &&
                    (missing0 = 'local_alias')) ||
                (data.mute_supported === undefined &&
                    (missing0 = 'mute_supported')) ||
                (data.overlay_text === undefined &&
                    (missing0 = 'overlay_text')) ||
                (data.protocol === undefined && (missing0 = 'protocol')) ||
                (data.role === undefined && (missing0 = 'role')) ||
                (data.rx_presentation_policy === undefined &&
                    (missing0 = 'rx_presentation_policy')) ||
                (data.spotlight === undefined && (missing0 = 'spotlight')) ||
                (data.start_time === undefined && (missing0 = 'start_time')) ||
                (data.supports_direct_chat === undefined &&
                    (missing0 = 'supports_direct_chat')) ||
                (data.transfer_supported === undefined &&
                    (missing0 = 'transfer_supported')) ||
                (data.uuid === undefined && (missing0 = 'uuid')) ||
                (data.can_receive_personal_mix === undefined &&
                    (missing0 = 'can_receive_personal_mix')) ||
                (data.receive_from_video_mix === undefined &&
                    (missing0 = 'receive_from_video_mix'))
            ) {
                validate29.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: {missingProperty: missing0},
                        message:
                            "must have required property '" + missing0 + "'",
                    },
                ];
                return false;
            } else {
                const _errs1 = errors;
                for (const key0 in data) {
                    if (!func2.call(schema43.properties, key0)) {
                        delete data[key0];
                    }
                }
                if (_errs1 === errors) {
                    if (data.api_url !== undefined) {
                        const _errs2 = errors;
                        if (typeof data.api_url !== 'string') {
                            validate29.errors = [
                                {
                                    instancePath: instancePath + '/api_url',
                                    schemaPath: '#/properties/api_url/type',
                                    keyword: 'type',
                                    params: {type: 'string'},
                                    message: 'must be string',
                                },
                            ];
                            return false;
                        }
                        var valid0 = _errs2 === errors;
                    } else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.buzz_time !== undefined) {
                            const _errs4 = errors;
                            if (!(typeof data.buzz_time == 'number')) {
                                validate29.errors = [
                                    {
                                        instancePath:
                                            instancePath + '/buzz_time',
                                        schemaPath:
                                            '#/properties/buzz_time/type',
                                        keyword: 'type',
                                        params: {type: 'number'},
                                        message: 'must be number',
                                    },
                                ];
                                return false;
                            }
                            var valid0 = _errs4 === errors;
                        } else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.call_direction !== undefined) {
                                let data2 = data.call_direction;
                                const _errs6 = errors;
                                if (typeof data2 !== 'string') {
                                    validate29.errors = [
                                        {
                                            instancePath:
                                                instancePath +
                                                '/call_direction',
                                            schemaPath:
                                                '#/properties/call_direction/type',
                                            keyword: 'type',
                                            params: {type: 'string'},
                                            message: 'must be string',
                                        },
                                    ];
                                    return false;
                                }
                                if (!(data2 === 'in' || data2 === 'out')) {
                                    validate29.errors = [
                                        {
                                            instancePath:
                                                instancePath +
                                                '/call_direction',
                                            schemaPath:
                                                '#/properties/call_direction/enum',
                                            keyword: 'enum',
                                            params: {
                                                allowedValues:
                                                    schema43.properties
                                                        .call_direction.enum,
                                            },
                                            message:
                                                'must be equal to one of the allowed values',
                                        },
                                    ];
                                    return false;
                                }
                                var valid0 = _errs6 === errors;
                            } else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.call_tag !== undefined) {
                                    const _errs8 = errors;
                                    if (typeof data.call_tag !== 'string') {
                                        validate29.errors = [
                                            {
                                                instancePath:
                                                    instancePath + '/call_tag',
                                                schemaPath:
                                                    '#/properties/call_tag/type',
                                                keyword: 'type',
                                                params: {type: 'string'},
                                                message: 'must be string',
                                            },
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs8 === errors;
                                } else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (
                                        data.disconnect_supported !== undefined
                                    ) {
                                        let data4 = data.disconnect_supported;
                                        const _errs10 = errors;
                                        if (typeof data4 !== 'string') {
                                            validate29.errors = [
                                                {
                                                    instancePath:
                                                        instancePath +
                                                        '/disconnect_supported',
                                                    schemaPath:
                                                        '#/properties/disconnect_supported/type',
                                                    keyword: 'type',
                                                    params: {type: 'string'},
                                                    message: 'must be string',
                                                },
                                            ];
                                            return false;
                                        }
                                        if (!(
                                            data4 === 'YES' || data4 === 'NO'
                                        )) {
                                            validate29.errors = [
                                                {
                                                    instancePath:
                                                        instancePath +
                                                        '/disconnect_supported',
                                                    schemaPath:
                                                        '#/properties/disconnect_supported/enum',
                                                    keyword: 'enum',
                                                    params: {
                                                        allowedValues:
                                                            schema43.properties
                                                                .disconnect_supported
                                                                .enum,
                                                    },
                                                    message:
                                                        'must be equal to one of the allowed values',
                                                },
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs10 === errors;
                                    } else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.display_name !== undefined) {
                                            const _errs12 = errors;
                                            if (
                                                typeof data.display_name !==
                                                'string'
                                            ) {
                                                validate29.errors = [
                                                    {
                                                        instancePath:
                                                            instancePath +
                                                            '/display_name',
                                                        schemaPath:
                                                            '#/properties/display_name/type',
                                                        keyword: 'type',
                                                        params: {
                                                            type: 'string',
                                                        },
                                                        message:
                                                            'must be string',
                                                    },
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs12 === errors;
                                        } else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.encryption !== undefined) {
                                                let data6 = data.encryption;
                                                const _errs14 = errors;
                                                if (typeof data6 !== 'string') {
                                                    validate29.errors = [
                                                        {
                                                            instancePath:
                                                                instancePath +
                                                                '/encryption',
                                                            schemaPath:
                                                                '#/properties/encryption/type',
                                                            keyword: 'type',
                                                            params: {
                                                                type: 'string',
                                                            },
                                                            message:
                                                                'must be string',
                                                        },
                                                    ];
                                                    return false;
                                                }
                                                if (!(
                                                    data6 === 'On' ||
                                                    data6 === 'Off' ||
                                                    data6 === 'Unknown'
                                                )) {
                                                    validate29.errors = [
                                                        {
                                                            instancePath:
                                                                instancePath +
                                                                '/encryption',
                                                            schemaPath:
                                                                '#/properties/encryption/enum',
                                                            keyword: 'enum',
                                                            params: {
                                                                allowedValues:
                                                                    schema43
                                                                        .properties
                                                                        .encryption
                                                                        .enum,
                                                            },
                                                            message:
                                                                'must be equal to one of the allowed values',
                                                        },
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs14 === errors;
                                            } else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (
                                                    data.external_node_uuid !==
                                                    undefined
                                                ) {
                                                    const _errs16 = errors;
                                                    if (
                                                        typeof data.external_node_uuid !==
                                                        'string'
                                                    ) {
                                                        validate29.errors = [
                                                            {
                                                                instancePath:
                                                                    instancePath +
                                                                    '/external_node_uuid',
                                                                schemaPath:
                                                                    '#/properties/external_node_uuid/type',
                                                                keyword: 'type',
                                                                params: {
                                                                    type: 'string',
                                                                },
                                                                message:
                                                                    'must be string',
                                                            },
                                                        ];
                                                        return false;
                                                    }
                                                    var valid0 =
                                                        _errs16 === errors;
                                                } else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (
                                                        data.fecc_supported !==
                                                        undefined
                                                    ) {
                                                        let data8 =
                                                            data.fecc_supported;
                                                        const _errs18 = errors;
                                                        if (
                                                            typeof data8 !==
                                                            'string'
                                                        ) {
                                                            validate29.errors =
                                                                [
                                                                    {
                                                                        instancePath:
                                                                            instancePath +
                                                                            '/fecc_supported',
                                                                        schemaPath:
                                                                            '#/properties/fecc_supported/type',
                                                                        keyword:
                                                                            'type',
                                                                        params: {
                                                                            type: 'string',
                                                                        },
                                                                        message:
                                                                            'must be string',
                                                                    },
                                                                ];
                                                            return false;
                                                        }
                                                        if (!(
                                                            data8 === 'YES' ||
                                                            data8 === 'NO'
                                                        )) {
                                                            validate29.errors =
                                                                [
                                                                    {
                                                                        instancePath:
                                                                            instancePath +
                                                                            '/fecc_supported',
                                                                        schemaPath:
                                                                            '#/properties/fecc_supported/enum',
                                                                        keyword:
                                                                            'enum',
                                                                        params: {
                                                                            allowedValues:
                                                                                schema43
                                                                                    .properties
                                                                                    .fecc_supported
                                                                                    .enum,
                                                                        },
                                                                        message:
                                                                            'must be equal to one of the allowed values',
                                                                    },
                                                                ];
                                                            return false;
                                                        }
                                                        var valid0 =
                                                            _errs18 === errors;
                                                    } else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (
                                                            data.has_media !==
                                                            undefined
                                                        ) {
                                                            const _errs20 =
                                                                errors;
                                                            if (
                                                                typeof data.has_media !==
                                                                'boolean'
                                                            ) {
                                                                validate29.errors =
                                                                    [
                                                                        {
                                                                            instancePath:
                                                                                instancePath +
                                                                                '/has_media',
                                                                            schemaPath:
                                                                                '#/properties/has_media/type',
                                                                            keyword:
                                                                                'type',
                                                                            params: {
                                                                                type: 'boolean',
                                                                            },
                                                                            message:
                                                                                'must be boolean',
                                                                        },
                                                                    ];
                                                                return false;
                                                            }
                                                            var valid0 =
                                                                _errs20 ===
                                                                errors;
                                                        } else {
                                                            var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                            if (
                                                                data.is_audio_only_call !==
                                                                undefined
                                                            ) {
                                                                let data10 =
                                                                    data.is_audio_only_call;
                                                                const _errs22 =
                                                                    errors;
                                                                if (
                                                                    typeof data10 !==
                                                                    'string'
                                                                ) {
                                                                    validate29.errors =
                                                                        [
                                                                            {
                                                                                instancePath:
                                                                                    instancePath +
                                                                                    '/is_audio_only_call',
                                                                                schemaPath:
                                                                                    '#/properties/is_audio_only_call/type',
                                                                                keyword:
                                                                                    'type',
                                                                                params: {
                                                                                    type: 'string',
                                                                                },
                                                                                message:
                                                                                    'must be string',
                                                                            },
                                                                        ];
                                                                    return false;
                                                                }
                                                                if (!(
                                                                    data10 ===
                                                                        'YES' ||
                                                                    data10 ===
                                                                        'NO'
                                                                )) {
                                                                    validate29.errors =
                                                                        [
                                                                            {
                                                                                instancePath:
                                                                                    instancePath +
                                                                                    '/is_audio_only_call',
                                                                                schemaPath:
                                                                                    '#/properties/is_audio_only_call/enum',
                                                                                keyword:
                                                                                    'enum',
                                                                                params: {
                                                                                    allowedValues:
                                                                                        schema43
                                                                                            .properties
                                                                                            .is_audio_only_call
                                                                                            .enum,
                                                                                },
                                                                                message:
                                                                                    'must be equal to one of the allowed values',
                                                                            },
                                                                        ];
                                                                    return false;
                                                                }
                                                                var valid0 =
                                                                    _errs22 ===
                                                                    errors;
                                                            } else {
                                                                var valid0 = true;
                                                            }
                                                            if (valid0) {
                                                                if (
                                                                    data.is_client_muted !==
                                                                    undefined
                                                                ) {
                                                                    const _errs24 =
                                                                        errors;
                                                                    if (
                                                                        typeof data.is_client_muted !==
                                                                        'boolean'
                                                                    ) {
                                                                        validate29.errors =
                                                                            [
                                                                                {
                                                                                    instancePath:
                                                                                        instancePath +
                                                                                        '/is_client_muted',
                                                                                    schemaPath:
                                                                                        '#/properties/is_client_muted/type',
                                                                                    keyword:
                                                                                        'type',
                                                                                    params: {
                                                                                        type: 'boolean',
                                                                                    },
                                                                                    message:
                                                                                        'must be boolean',
                                                                                },
                                                                            ];
                                                                        return false;
                                                                    }
                                                                    var valid0 =
                                                                        _errs24 ===
                                                                        errors;
                                                                } else {
                                                                    var valid0 = true;
                                                                }
                                                                if (valid0) {
                                                                    if (
                                                                        data.is_conjoined !==
                                                                        undefined
                                                                    ) {
                                                                        const _errs26 =
                                                                            errors;
                                                                        if (
                                                                            typeof data.is_conjoined !==
                                                                            'boolean'
                                                                        ) {
                                                                            validate29.errors =
                                                                                [
                                                                                    {
                                                                                        instancePath:
                                                                                            instancePath +
                                                                                            '/is_conjoined',
                                                                                        schemaPath:
                                                                                            '#/properties/is_conjoined/type',
                                                                                        keyword:
                                                                                            'type',
                                                                                        params: {
                                                                                            type: 'boolean',
                                                                                        },
                                                                                        message:
                                                                                            'must be boolean',
                                                                                    },
                                                                                ];
                                                                            return false;
                                                                        }
                                                                        var valid0 =
                                                                            _errs26 ===
                                                                            errors;
                                                                    } else {
                                                                        var valid0 = true;
                                                                    }
                                                                    if (
                                                                        valid0
                                                                    ) {
                                                                        if (
                                                                            data.is_external !==
                                                                            undefined
                                                                        ) {
                                                                            const _errs28 =
                                                                                errors;
                                                                            if (
                                                                                typeof data.is_external !==
                                                                                'boolean'
                                                                            ) {
                                                                                validate29.errors =
                                                                                    [
                                                                                        {
                                                                                            instancePath:
                                                                                                instancePath +
                                                                                                '/is_external',
                                                                                            schemaPath:
                                                                                                '#/properties/is_external/type',
                                                                                            keyword:
                                                                                                'type',
                                                                                            params: {
                                                                                                type: 'boolean',
                                                                                            },
                                                                                            message:
                                                                                                'must be boolean',
                                                                                        },
                                                                                    ];
                                                                                return false;
                                                                            }
                                                                            var valid0 =
                                                                                _errs28 ===
                                                                                errors;
                                                                        } else {
                                                                            var valid0 = true;
                                                                        }
                                                                        if (
                                                                            valid0
                                                                        ) {
                                                                            if (
                                                                                data.is_idp_authenticated !==
                                                                                undefined
                                                                            ) {
                                                                                const _errs30 =
                                                                                    errors;
                                                                                if (
                                                                                    typeof data.is_idp_authenticated !==
                                                                                    'boolean'
                                                                                ) {
                                                                                    validate29.errors =
                                                                                        [
                                                                                            {
                                                                                                instancePath:
                                                                                                    instancePath +
                                                                                                    '/is_idp_authenticated',
                                                                                                schemaPath:
                                                                                                    '#/properties/is_idp_authenticated/type',
                                                                                                keyword:
                                                                                                    'type',
                                                                                                params: {
                                                                                                    type: 'boolean',
                                                                                                },
                                                                                                message:
                                                                                                    'must be boolean',
                                                                                            },
                                                                                        ];
                                                                                    return false;
                                                                                }
                                                                                var valid0 =
                                                                                    _errs30 ===
                                                                                    errors;
                                                                            } else {
                                                                                var valid0 = true;
                                                                            }
                                                                            if (
                                                                                valid0
                                                                            ) {
                                                                                if (
                                                                                    data.is_muted !==
                                                                                    undefined
                                                                                ) {
                                                                                    let data15 =
                                                                                        data.is_muted;
                                                                                    const _errs32 =
                                                                                        errors;
                                                                                    if (
                                                                                        typeof data15 !==
                                                                                        'string'
                                                                                    ) {
                                                                                        validate29.errors =
                                                                                            [
                                                                                                {
                                                                                                    instancePath:
                                                                                                        instancePath +
                                                                                                        '/is_muted',
                                                                                                    schemaPath:
                                                                                                        '#/properties/is_muted/type',
                                                                                                    keyword:
                                                                                                        'type',
                                                                                                    params: {
                                                                                                        type: 'string',
                                                                                                    },
                                                                                                    message:
                                                                                                        'must be string',
                                                                                                },
                                                                                            ];
                                                                                        return false;
                                                                                    }
                                                                                    if (!(
                                                                                        data15 ===
                                                                                            'YES' ||
                                                                                        data15 ===
                                                                                            'NO'
                                                                                    )) {
                                                                                        validate29.errors =
                                                                                            [
                                                                                                {
                                                                                                    instancePath:
                                                                                                        instancePath +
                                                                                                        '/is_muted',
                                                                                                    schemaPath:
                                                                                                        '#/properties/is_muted/enum',
                                                                                                    keyword:
                                                                                                        'enum',
                                                                                                    params: {
                                                                                                        allowedValues:
                                                                                                            schema43
                                                                                                                .properties
                                                                                                                .is_muted
                                                                                                                .enum,
                                                                                                    },
                                                                                                    message:
                                                                                                        'must be equal to one of the allowed values',
                                                                                                },
                                                                                            ];
                                                                                        return false;
                                                                                    }
                                                                                    var valid0 =
                                                                                        _errs32 ===
                                                                                        errors;
                                                                                } else {
                                                                                    var valid0 = true;
                                                                                }
                                                                                if (
                                                                                    valid0
                                                                                ) {
                                                                                    if (
                                                                                        data.is_presenting !==
                                                                                        undefined
                                                                                    ) {
                                                                                        let data16 =
                                                                                            data.is_presenting;
                                                                                        const _errs34 =
                                                                                            errors;
                                                                                        if (
                                                                                            typeof data16 !==
                                                                                            'string'
                                                                                        ) {
                                                                                            validate29.errors =
                                                                                                [
                                                                                                    {
                                                                                                        instancePath:
                                                                                                            instancePath +
                                                                                                            '/is_presenting',
                                                                                                        schemaPath:
                                                                                                            '#/properties/is_presenting/type',
                                                                                                        keyword:
                                                                                                            'type',
                                                                                                        params: {
                                                                                                            type: 'string',
                                                                                                        },
                                                                                                        message:
                                                                                                            'must be string',
                                                                                                    },
                                                                                                ];
                                                                                            return false;
                                                                                        }
                                                                                        if (!(
                                                                                            data16 ===
                                                                                                'YES' ||
                                                                                            data16 ===
                                                                                                'NO'
                                                                                        )) {
                                                                                            validate29.errors =
                                                                                                [
                                                                                                    {
                                                                                                        instancePath:
                                                                                                            instancePath +
                                                                                                            '/is_presenting',
                                                                                                        schemaPath:
                                                                                                            '#/properties/is_presenting/enum',
                                                                                                        keyword:
                                                                                                            'enum',
                                                                                                        params: {
                                                                                                            allowedValues:
                                                                                                                schema43
                                                                                                                    .properties
                                                                                                                    .is_presenting
                                                                                                                    .enum,
                                                                                                        },
                                                                                                        message:
                                                                                                            'must be equal to one of the allowed values',
                                                                                                    },
                                                                                                ];
                                                                                            return false;
                                                                                        }
                                                                                        var valid0 =
                                                                                            _errs34 ===
                                                                                            errors;
                                                                                    } else {
                                                                                        var valid0 = true;
                                                                                    }
                                                                                    if (
                                                                                        valid0
                                                                                    ) {
                                                                                        if (
                                                                                            data.is_streaming_conference !==
                                                                                            undefined
                                                                                        ) {
                                                                                            const _errs36 =
                                                                                                errors;
                                                                                            if (
                                                                                                typeof data.is_streaming_conference !==
                                                                                                'boolean'
                                                                                            ) {
                                                                                                validate29.errors =
                                                                                                    [
                                                                                                        {
                                                                                                            instancePath:
                                                                                                                instancePath +
                                                                                                                '/is_streaming_conference',
                                                                                                            schemaPath:
                                                                                                                '#/properties/is_streaming_conference/type',
                                                                                                            keyword:
                                                                                                                'type',
                                                                                                            params: {
                                                                                                                type: 'boolean',
                                                                                                            },
                                                                                                            message:
                                                                                                                'must be boolean',
                                                                                                        },
                                                                                                    ];
                                                                                                return false;
                                                                                            }
                                                                                            var valid0 =
                                                                                                _errs36 ===
                                                                                                errors;
                                                                                        } else {
                                                                                            var valid0 = true;
                                                                                        }
                                                                                        if (
                                                                                            valid0
                                                                                        ) {
                                                                                            if (
                                                                                                data.is_transferring !==
                                                                                                undefined
                                                                                            ) {
                                                                                                const _errs38 =
                                                                                                    errors;
                                                                                                if (
                                                                                                    typeof data.is_transferring !==
                                                                                                    'boolean'
                                                                                                ) {
                                                                                                    validate29.errors =
                                                                                                        [
                                                                                                            {
                                                                                                                instancePath:
                                                                                                                    instancePath +
                                                                                                                    '/is_transferring',
                                                                                                                schemaPath:
                                                                                                                    '#/properties/is_transferring/type',
                                                                                                                keyword:
                                                                                                                    'type',
                                                                                                                params: {
                                                                                                                    type: 'boolean',
                                                                                                                },
                                                                                                                message:
                                                                                                                    'must be boolean',
                                                                                                            },
                                                                                                        ];
                                                                                                    return false;
                                                                                                }
                                                                                                var valid0 =
                                                                                                    _errs38 ===
                                                                                                    errors;
                                                                                            } else {
                                                                                                var valid0 = true;
                                                                                            }
                                                                                            if (
                                                                                                valid0
                                                                                            ) {
                                                                                                if (
                                                                                                    data.is_video_call !==
                                                                                                    undefined
                                                                                                ) {
                                                                                                    let data19 =
                                                                                                        data.is_video_call;
                                                                                                    const _errs40 =
                                                                                                        errors;
                                                                                                    if (
                                                                                                        typeof data19 !==
                                                                                                        'string'
                                                                                                    ) {
                                                                                                        validate29.errors =
                                                                                                            [
                                                                                                                {
                                                                                                                    instancePath:
                                                                                                                        instancePath +
                                                                                                                        '/is_video_call',
                                                                                                                    schemaPath:
                                                                                                                        '#/properties/is_video_call/type',
                                                                                                                    keyword:
                                                                                                                        'type',
                                                                                                                    params: {
                                                                                                                        type: 'string',
                                                                                                                    },
                                                                                                                    message:
                                                                                                                        'must be string',
                                                                                                                },
                                                                                                            ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    if (!(
                                                                                                        data19 ===
                                                                                                            'YES' ||
                                                                                                        data19 ===
                                                                                                            'NO'
                                                                                                    )) {
                                                                                                        validate29.errors =
                                                                                                            [
                                                                                                                {
                                                                                                                    instancePath:
                                                                                                                        instancePath +
                                                                                                                        '/is_video_call',
                                                                                                                    schemaPath:
                                                                                                                        '#/properties/is_video_call/enum',
                                                                                                                    keyword:
                                                                                                                        'enum',
                                                                                                                    params: {
                                                                                                                        allowedValues:
                                                                                                                            schema43
                                                                                                                                .properties
                                                                                                                                .is_video_call
                                                                                                                                .enum,
                                                                                                                    },
                                                                                                                    message:
                                                                                                                        'must be equal to one of the allowed values',
                                                                                                                },
                                                                                                            ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    var valid0 =
                                                                                                        _errs40 ===
                                                                                                        errors;
                                                                                                } else {
                                                                                                    var valid0 = true;
                                                                                                }
                                                                                                if (
                                                                                                    valid0
                                                                                                ) {
                                                                                                    if (
                                                                                                        data.is_video_muted !==
                                                                                                        undefined
                                                                                                    ) {
                                                                                                        const _errs42 =
                                                                                                            errors;
                                                                                                        if (
                                                                                                            typeof data.is_video_muted !==
                                                                                                            'boolean'
                                                                                                        ) {
                                                                                                            validate29.errors =
                                                                                                                [
                                                                                                                    {
                                                                                                                        instancePath:
                                                                                                                            instancePath +
                                                                                                                            '/is_video_muted',
                                                                                                                        schemaPath:
                                                                                                                            '#/properties/is_video_muted/type',
                                                                                                                        keyword:
                                                                                                                            'type',
                                                                                                                        params: {
                                                                                                                            type: 'boolean',
                                                                                                                        },
                                                                                                                        message:
                                                                                                                            'must be boolean',
                                                                                                                    },
                                                                                                                ];
                                                                                                            return false;
                                                                                                        }
                                                                                                        var valid0 =
                                                                                                            _errs42 ===
                                                                                                            errors;
                                                                                                    } else {
                                                                                                        var valid0 = true;
                                                                                                    }
                                                                                                    if (
                                                                                                        valid0
                                                                                                    ) {
                                                                                                        if (
                                                                                                            data.is_video_silent !==
                                                                                                            undefined
                                                                                                        ) {
                                                                                                            const _errs44 =
                                                                                                                errors;
                                                                                                            if (
                                                                                                                typeof data.is_video_silent !==
                                                                                                                'boolean'
                                                                                                            ) {
                                                                                                                validate29.errors =
                                                                                                                    [
                                                                                                                        {
                                                                                                                            instancePath:
                                                                                                                                instancePath +
                                                                                                                                '/is_video_silent',
                                                                                                                            schemaPath:
                                                                                                                                '#/properties/is_video_silent/type',
                                                                                                                            keyword:
                                                                                                                                'type',
                                                                                                                            params: {
                                                                                                                                type: 'boolean',
                                                                                                                            },
                                                                                                                            message:
                                                                                                                                'must be boolean',
                                                                                                                        },
                                                                                                                    ];
                                                                                                                return false;
                                                                                                            }
                                                                                                            var valid0 =
                                                                                                                _errs44 ===
                                                                                                                errors;
                                                                                                        } else {
                                                                                                            var valid0 = true;
                                                                                                        }
                                                                                                        if (
                                                                                                            valid0
                                                                                                        ) {
                                                                                                            if (
                                                                                                                data.is_main_video_dropped_out !==
                                                                                                                undefined
                                                                                                            ) {
                                                                                                                const _errs46 =
                                                                                                                    errors;
                                                                                                                if (
                                                                                                                    typeof data.is_main_video_dropped_out !==
                                                                                                                    'boolean'
                                                                                                                ) {
                                                                                                                    validate29.errors =
                                                                                                                        [
                                                                                                                            {
                                                                                                                                instancePath:
                                                                                                                                    instancePath +
                                                                                                                                    '/is_main_video_dropped_out',
                                                                                                                                schemaPath:
                                                                                                                                    '#/properties/is_main_video_dropped_out/type',
                                                                                                                                keyword:
                                                                                                                                    'type',
                                                                                                                                params: {
                                                                                                                                    type: 'boolean',
                                                                                                                                },
                                                                                                                                message:
                                                                                                                                    'must be boolean',
                                                                                                                            },
                                                                                                                        ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                                var valid0 =
                                                                                                                    _errs46 ===
                                                                                                                    errors;
                                                                                                            } else {
                                                                                                                var valid0 = true;
                                                                                                            }
                                                                                                            if (
                                                                                                                valid0
                                                                                                            ) {
                                                                                                                if (
                                                                                                                    data.local_alias !==
                                                                                                                    undefined
                                                                                                                ) {
                                                                                                                    const _errs48 =
                                                                                                                        errors;
                                                                                                                    if (
                                                                                                                        typeof data.local_alias !==
                                                                                                                        'string'
                                                                                                                    ) {
                                                                                                                        validate29.errors =
                                                                                                                            [
                                                                                                                                {
                                                                                                                                    instancePath:
                                                                                                                                        instancePath +
                                                                                                                                        '/local_alias',
                                                                                                                                    schemaPath:
                                                                                                                                        '#/properties/local_alias/type',
                                                                                                                                    keyword:
                                                                                                                                        'type',
                                                                                                                                    params: {
                                                                                                                                        type: 'string',
                                                                                                                                    },
                                                                                                                                    message:
                                                                                                                                        'must be string',
                                                                                                                                },
                                                                                                                            ];
                                                                                                                        return false;
                                                                                                                    }
                                                                                                                    var valid0 =
                                                                                                                        _errs48 ===
                                                                                                                        errors;
                                                                                                                } else {
                                                                                                                    var valid0 = true;
                                                                                                                }
                                                                                                                if (
                                                                                                                    valid0
                                                                                                                ) {
                                                                                                                    if (
                                                                                                                        data.mute_supported !==
                                                                                                                        undefined
                                                                                                                    ) {
                                                                                                                        let data24 =
                                                                                                                            data.mute_supported;
                                                                                                                        const _errs50 =
                                                                                                                            errors;
                                                                                                                        if (
                                                                                                                            typeof data24 !==
                                                                                                                            'string'
                                                                                                                        ) {
                                                                                                                            validate29.errors =
                                                                                                                                [
                                                                                                                                    {
                                                                                                                                        instancePath:
                                                                                                                                            instancePath +
                                                                                                                                            '/mute_supported',
                                                                                                                                        schemaPath:
                                                                                                                                            '#/properties/mute_supported/type',
                                                                                                                                        keyword:
                                                                                                                                            'type',
                                                                                                                                        params: {
                                                                                                                                            type: 'string',
                                                                                                                                        },
                                                                                                                                        message:
                                                                                                                                            'must be string',
                                                                                                                                    },
                                                                                                                                ];
                                                                                                                            return false;
                                                                                                                        }
                                                                                                                        if (!(
                                                                                                                            data24 ===
                                                                                                                                'YES' ||
                                                                                                                            data24 ===
                                                                                                                                'NO'
                                                                                                                        )) {
                                                                                                                            validate29.errors =
                                                                                                                                [
                                                                                                                                    {
                                                                                                                                        instancePath:
                                                                                                                                            instancePath +
                                                                                                                                            '/mute_supported',
                                                                                                                                        schemaPath:
                                                                                                                                            '#/properties/mute_supported/enum',
                                                                                                                                        keyword:
                                                                                                                                            'enum',
                                                                                                                                        params: {
                                                                                                                                            allowedValues:
                                                                                                                                                schema43
                                                                                                                                                    .properties
                                                                                                                                                    .mute_supported
                                                                                                                                                    .enum,
                                                                                                                                        },
                                                                                                                                        message:
                                                                                                                                            'must be equal to one of the allowed values',
                                                                                                                                    },
                                                                                                                                ];
                                                                                                                            return false;
                                                                                                                        }
                                                                                                                        var valid0 =
                                                                                                                            _errs50 ===
                                                                                                                            errors;
                                                                                                                    } else {
                                                                                                                        var valid0 = true;
                                                                                                                    }
                                                                                                                    if (
                                                                                                                        valid0
                                                                                                                    ) {
                                                                                                                        if (
                                                                                                                            data.needs_presentation_in_mix !==
                                                                                                                            undefined
                                                                                                                        ) {
                                                                                                                            const _errs52 =
                                                                                                                                errors;
                                                                                                                            if (
                                                                                                                                typeof data.needs_presentation_in_mix !==
                                                                                                                                'boolean'
                                                                                                                            ) {
                                                                                                                                validate29.errors =
                                                                                                                                    [
                                                                                                                                        {
                                                                                                                                            instancePath:
                                                                                                                                                instancePath +
                                                                                                                                                '/needs_presentation_in_mix',
                                                                                                                                            schemaPath:
                                                                                                                                                '#/properties/needs_presentation_in_mix/type',
                                                                                                                                            keyword:
                                                                                                                                                'type',
                                                                                                                                            params: {
                                                                                                                                                type: 'boolean',
                                                                                                                                            },
                                                                                                                                            message:
                                                                                                                                                'must be boolean',
                                                                                                                                        },
                                                                                                                                    ];
                                                                                                                                return false;
                                                                                                                            }
                                                                                                                            var valid0 =
                                                                                                                                _errs52 ===
                                                                                                                                errors;
                                                                                                                        } else {
                                                                                                                            var valid0 = true;
                                                                                                                        }
                                                                                                                        if (
                                                                                                                            valid0
                                                                                                                        ) {
                                                                                                                            if (
                                                                                                                                data.overlay_text !==
                                                                                                                                undefined
                                                                                                                            ) {
                                                                                                                                const _errs54 =
                                                                                                                                    errors;
                                                                                                                                if (
                                                                                                                                    typeof data.overlay_text !==
                                                                                                                                    'string'
                                                                                                                                ) {
                                                                                                                                    validate29.errors =
                                                                                                                                        [
                                                                                                                                            {
                                                                                                                                                instancePath:
                                                                                                                                                    instancePath +
                                                                                                                                                    '/overlay_text',
                                                                                                                                                schemaPath:
                                                                                                                                                    '#/properties/overlay_text/type',
                                                                                                                                                keyword:
                                                                                                                                                    'type',
                                                                                                                                                params: {
                                                                                                                                                    type: 'string',
                                                                                                                                                },
                                                                                                                                                message:
                                                                                                                                                    'must be string',
                                                                                                                                            },
                                                                                                                                        ];
                                                                                                                                    return false;
                                                                                                                                }
                                                                                                                                var valid0 =
                                                                                                                                    _errs54 ===
                                                                                                                                    errors;
                                                                                                                            } else {
                                                                                                                                var valid0 = true;
                                                                                                                            }
                                                                                                                            if (
                                                                                                                                valid0
                                                                                                                            ) {
                                                                                                                                if (
                                                                                                                                    data.presentation_supported !==
                                                                                                                                    undefined
                                                                                                                                ) {
                                                                                                                                    let data27 =
                                                                                                                                        data.presentation_supported;
                                                                                                                                    const _errs56 =
                                                                                                                                        errors;
                                                                                                                                    if (
                                                                                                                                        typeof data27 !==
                                                                                                                                        'string'
                                                                                                                                    ) {
                                                                                                                                        validate29.errors =
                                                                                                                                            [
                                                                                                                                                {
                                                                                                                                                    instancePath:
                                                                                                                                                        instancePath +
                                                                                                                                                        '/presentation_supported',
                                                                                                                                                    schemaPath:
                                                                                                                                                        '#/properties/presentation_supported/type',
                                                                                                                                                    keyword:
                                                                                                                                                        'type',
                                                                                                                                                    params: {
                                                                                                                                                        type: 'string',
                                                                                                                                                    },
                                                                                                                                                    message:
                                                                                                                                                        'must be string',
                                                                                                                                                },
                                                                                                                                            ];
                                                                                                                                        return false;
                                                                                                                                    }
                                                                                                                                    if (!(
                                                                                                                                        data27 ===
                                                                                                                                            'YES' ||
                                                                                                                                        data27 ===
                                                                                                                                            'NO'
                                                                                                                                    )) {
                                                                                                                                        validate29.errors =
                                                                                                                                            [
                                                                                                                                                {
                                                                                                                                                    instancePath:
                                                                                                                                                        instancePath +
                                                                                                                                                        '/presentation_supported',
                                                                                                                                                    schemaPath:
                                                                                                                                                        '#/properties/presentation_supported/enum',
                                                                                                                                                    keyword:
                                                                                                                                                        'enum',
                                                                                                                                                    params: {
                                                                                                                                                        allowedValues:
                                                                                                                                                            schema43
                                                                                                                                                                .properties
                                                                                                                                                                .presentation_supported
                                                                                                                                                                .enum,
                                                                                                                                                    },
                                                                                                                                                    message:
                                                                                                                                                        'must be equal to one of the allowed values',
                                                                                                                                                },
                                                                                                                                            ];
                                                                                                                                        return false;
                                                                                                                                    }
                                                                                                                                    var valid0 =
                                                                                                                                        _errs56 ===
                                                                                                                                        errors;
                                                                                                                                } else {
                                                                                                                                    var valid0 = true;
                                                                                                                                }
                                                                                                                                if (
                                                                                                                                    valid0
                                                                                                                                ) {
                                                                                                                                    if (
                                                                                                                                        data.protocol !==
                                                                                                                                        undefined
                                                                                                                                    ) {
                                                                                                                                        let data28 =
                                                                                                                                            data.protocol;
                                                                                                                                        const _errs58 =
                                                                                                                                            errors;
                                                                                                                                        if (
                                                                                                                                            typeof data28 !==
                                                                                                                                            'string'
                                                                                                                                        ) {
                                                                                                                                            validate29.errors =
                                                                                                                                                [
                                                                                                                                                    {
                                                                                                                                                        instancePath:
                                                                                                                                                            instancePath +
                                                                                                                                                            '/protocol',
                                                                                                                                                        schemaPath:
                                                                                                                                                            '#/properties/protocol/type',
                                                                                                                                                        keyword:
                                                                                                                                                            'type',
                                                                                                                                                        params: {
                                                                                                                                                            type: 'string',
                                                                                                                                                        },
                                                                                                                                                        message:
                                                                                                                                                            'must be string',
                                                                                                                                                    },
                                                                                                                                                ];
                                                                                                                                            return false;
                                                                                                                                        }
                                                                                                                                        if (!(
                                                                                                                                            data28 ===
                                                                                                                                                'api' ||
                                                                                                                                            data28 ===
                                                                                                                                                'webrtc' ||
                                                                                                                                            data28 ===
                                                                                                                                                'sip' ||
                                                                                                                                            data28 ===
                                                                                                                                                'rtmp' ||
                                                                                                                                            data28 ===
                                                                                                                                                'h323' ||
                                                                                                                                            data28 ===
                                                                                                                                                'mssip' ||
                                                                                                                                            data28 ===
                                                                                                                                                ''
                                                                                                                                        )) {
                                                                                                                                            validate29.errors =
                                                                                                                                                [
                                                                                                                                                    {
                                                                                                                                                        instancePath:
                                                                                                                                                            instancePath +
                                                                                                                                                            '/protocol',
                                                                                                                                                        schemaPath:
                                                                                                                                                            '#/properties/protocol/enum',
                                                                                                                                                        keyword:
                                                                                                                                                            'enum',
                                                                                                                                                        params: {
                                                                                                                                                            allowedValues:
                                                                                                                                                                schema43
                                                                                                                                                                    .properties
                                                                                                                                                                    .protocol
                                                                                                                                                                    .enum,
                                                                                                                                                        },
                                                                                                                                                        message:
                                                                                                                                                            'must be equal to one of the allowed values',
                                                                                                                                                    },
                                                                                                                                                ];
                                                                                                                                            return false;
                                                                                                                                        }
                                                                                                                                        var valid0 =
                                                                                                                                            _errs58 ===
                                                                                                                                            errors;
                                                                                                                                    } else {
                                                                                                                                        var valid0 = true;
                                                                                                                                    }
                                                                                                                                    if (
                                                                                                                                        valid0
                                                                                                                                    ) {
                                                                                                                                        if (
                                                                                                                                            data.role !==
                                                                                                                                            undefined
                                                                                                                                        ) {
                                                                                                                                            let data29 =
                                                                                                                                                data.role;
                                                                                                                                            const _errs60 =
                                                                                                                                                errors;
                                                                                                                                            if (
                                                                                                                                                typeof data29 !==
                                                                                                                                                'string'
                                                                                                                                            ) {
                                                                                                                                                validate29.errors =
                                                                                                                                                    [
                                                                                                                                                        {
                                                                                                                                                            instancePath:
                                                                                                                                                                instancePath +
                                                                                                                                                                '/role',
                                                                                                                                                            schemaPath:
                                                                                                                                                                '#/properties/role/type',
                                                                                                                                                            keyword:
                                                                                                                                                                'type',
                                                                                                                                                            params: {
                                                                                                                                                                type: 'string',
                                                                                                                                                            },
                                                                                                                                                            message:
                                                                                                                                                                'must be string',
                                                                                                                                                        },
                                                                                                                                                    ];
                                                                                                                                                return false;
                                                                                                                                            }
                                                                                                                                            if (!(
                                                                                                                                                data29 ===
                                                                                                                                                    'chair' ||
                                                                                                                                                data29 ===
                                                                                                                                                    'guest'
                                                                                                                                            )) {
                                                                                                                                                validate29.errors =
                                                                                                                                                    [
                                                                                                                                                        {
                                                                                                                                                            instancePath:
                                                                                                                                                                instancePath +
                                                                                                                                                                '/role',
                                                                                                                                                            schemaPath:
                                                                                                                                                                '#/properties/role/enum',
                                                                                                                                                            keyword:
                                                                                                                                                                'enum',
                                                                                                                                                            params: {
                                                                                                                                                                allowedValues:
                                                                                                                                                                    schema43
                                                                                                                                                                        .properties
                                                                                                                                                                        .role
                                                                                                                                                                        .enum,
                                                                                                                                                            },
                                                                                                                                                            message:
                                                                                                                                                                'must be equal to one of the allowed values',
                                                                                                                                                        },
                                                                                                                                                    ];
                                                                                                                                                return false;
                                                                                                                                            }
                                                                                                                                            var valid0 =
                                                                                                                                                _errs60 ===
                                                                                                                                                errors;
                                                                                                                                        } else {
                                                                                                                                            var valid0 = true;
                                                                                                                                        }
                                                                                                                                        if (
                                                                                                                                            valid0
                                                                                                                                        ) {
                                                                                                                                            if (
                                                                                                                                                data.rx_presentation_policy !==
                                                                                                                                                undefined
                                                                                                                                            ) {
                                                                                                                                                let data30 =
                                                                                                                                                    data.rx_presentation_policy;
                                                                                                                                                const _errs62 =
                                                                                                                                                    errors;
                                                                                                                                                if (
                                                                                                                                                    typeof data30 !==
                                                                                                                                                    'string'
                                                                                                                                                ) {
                                                                                                                                                    validate29.errors =
                                                                                                                                                        [
                                                                                                                                                            {
                                                                                                                                                                instancePath:
                                                                                                                                                                    instancePath +
                                                                                                                                                                    '/rx_presentation_policy',
                                                                                                                                                                schemaPath:
                                                                                                                                                                    '#/properties/rx_presentation_policy/type',
                                                                                                                                                                keyword:
                                                                                                                                                                    'type',
                                                                                                                                                                params: {
                                                                                                                                                                    type: 'string',
                                                                                                                                                                },
                                                                                                                                                                message:
                                                                                                                                                                    'must be string',
                                                                                                                                                            },
                                                                                                                                                        ];
                                                                                                                                                    return false;
                                                                                                                                                }
                                                                                                                                                if (!(
                                                                                                                                                    data30 ===
                                                                                                                                                        'ALLOW' ||
                                                                                                                                                    data30 ===
                                                                                                                                                        'DENY'
                                                                                                                                                )) {
                                                                                                                                                    validate29.errors =
                                                                                                                                                        [
                                                                                                                                                            {
                                                                                                                                                                instancePath:
                                                                                                                                                                    instancePath +
                                                                                                                                                                    '/rx_presentation_policy',
                                                                                                                                                                schemaPath:
                                                                                                                                                                    '#/properties/rx_presentation_policy/enum',
                                                                                                                                                                keyword:
                                                                                                                                                                    'enum',
                                                                                                                                                                params: {
                                                                                                                                                                    allowedValues:
                                                                                                                                                                        schema43
                                                                                                                                                                            .properties
                                                                                                                                                                            .rx_presentation_policy
                                                                                                                                                                            .enum,
                                                                                                                                                                },
                                                                                                                                                                message:
                                                                                                                                                                    'must be equal to one of the allowed values',
                                                                                                                                                            },
                                                                                                                                                        ];
                                                                                                                                                    return false;
                                                                                                                                                }
                                                                                                                                                var valid0 =
                                                                                                                                                    _errs62 ===
                                                                                                                                                    errors;
                                                                                                                                            } else {
                                                                                                                                                var valid0 = true;
                                                                                                                                            }
                                                                                                                                            if (
                                                                                                                                                valid0
                                                                                                                                            ) {
                                                                                                                                                if (
                                                                                                                                                    data.service_type !==
                                                                                                                                                    undefined
                                                                                                                                                ) {
                                                                                                                                                    let data31 =
                                                                                                                                                        data.service_type;
                                                                                                                                                    const _errs64 =
                                                                                                                                                        errors;
                                                                                                                                                    if (
                                                                                                                                                        typeof data31 !==
                                                                                                                                                        'string'
                                                                                                                                                    ) {
                                                                                                                                                        validate29.errors =
                                                                                                                                                            [
                                                                                                                                                                {
                                                                                                                                                                    instancePath:
                                                                                                                                                                        instancePath +
                                                                                                                                                                        '/service_type',
                                                                                                                                                                    schemaPath:
                                                                                                                                                                        '#/properties/service_type/type',
                                                                                                                                                                    keyword:
                                                                                                                                                                        'type',
                                                                                                                                                                    params: {
                                                                                                                                                                        type: 'string',
                                                                                                                                                                    },
                                                                                                                                                                    message:
                                                                                                                                                                        'must be string',
                                                                                                                                                                },
                                                                                                                                                            ];
                                                                                                                                                        return false;
                                                                                                                                                    }
                                                                                                                                                    if (!(
                                                                                                                                                        data31 ===
                                                                                                                                                            'connecting' ||
                                                                                                                                                        data31 ===
                                                                                                                                                            'waiting_room' ||
                                                                                                                                                        data31 ===
                                                                                                                                                            'ivr' ||
                                                                                                                                                        data31 ===
                                                                                                                                                            'conference' ||
                                                                                                                                                        data31 ===
                                                                                                                                                            'lecture' ||
                                                                                                                                                        data31 ===
                                                                                                                                                            'gateway' ||
                                                                                                                                                        data31 ===
                                                                                                                                                            'test_call'
                                                                                                                                                    )) {
                                                                                                                                                        validate29.errors =
                                                                                                                                                            [
                                                                                                                                                                {
                                                                                                                                                                    instancePath:
                                                                                                                                                                        instancePath +
                                                                                                                                                                        '/service_type',
                                                                                                                                                                    schemaPath:
                                                                                                                                                                        '#/properties/service_type/enum',
                                                                                                                                                                    keyword:
                                                                                                                                                                        'enum',
                                                                                                                                                                    params: {
                                                                                                                                                                        allowedValues:
                                                                                                                                                                            schema43
                                                                                                                                                                                .properties
                                                                                                                                                                                .service_type
                                                                                                                                                                                .enum,
                                                                                                                                                                    },
                                                                                                                                                                    message:
                                                                                                                                                                        'must be equal to one of the allowed values',
                                                                                                                                                                },
                                                                                                                                                            ];
                                                                                                                                                        return false;
                                                                                                                                                    }
                                                                                                                                                    var valid0 =
                                                                                                                                                        _errs64 ===
                                                                                                                                                        errors;
                                                                                                                                                } else {
                                                                                                                                                    var valid0 = true;
                                                                                                                                                }
                                                                                                                                                if (
                                                                                                                                                    valid0
                                                                                                                                                ) {
                                                                                                                                                    if (
                                                                                                                                                        data.spotlight !==
                                                                                                                                                        undefined
                                                                                                                                                    ) {
                                                                                                                                                        const _errs66 =
                                                                                                                                                            errors;
                                                                                                                                                        if (
                                                                                                                                                            !(
                                                                                                                                                                typeof data.spotlight ==
                                                                                                                                                                'number'
                                                                                                                                                            )
                                                                                                                                                        ) {
                                                                                                                                                            validate29.errors =
                                                                                                                                                                [
                                                                                                                                                                    {
                                                                                                                                                                        instancePath:
                                                                                                                                                                            instancePath +
                                                                                                                                                                            '/spotlight',
                                                                                                                                                                        schemaPath:
                                                                                                                                                                            '#/properties/spotlight/type',
                                                                                                                                                                        keyword:
                                                                                                                                                                            'type',
                                                                                                                                                                        params: {
                                                                                                                                                                            type: 'number',
                                                                                                                                                                        },
                                                                                                                                                                        message:
                                                                                                                                                                            'must be number',
                                                                                                                                                                    },
                                                                                                                                                                ];
                                                                                                                                                            return false;
                                                                                                                                                        }
                                                                                                                                                        var valid0 =
                                                                                                                                                            _errs66 ===
                                                                                                                                                            errors;
                                                                                                                                                    } else {
                                                                                                                                                        var valid0 = true;
                                                                                                                                                    }
                                                                                                                                                    if (
                                                                                                                                                        valid0
                                                                                                                                                    ) {
                                                                                                                                                        if (
                                                                                                                                                            data.start_time !==
                                                                                                                                                            undefined
                                                                                                                                                        ) {
                                                                                                                                                            let data33 =
                                                                                                                                                                data.start_time;
                                                                                                                                                            const _errs68 =
                                                                                                                                                                errors;
                                                                                                                                                            if (
                                                                                                                                                                !(
                                                                                                                                                                    typeof data33 ==
                                                                                                                                                                    'number'
                                                                                                                                                                ) &&
                                                                                                                                                                data33 !==
                                                                                                                                                                    null
                                                                                                                                                            ) {
                                                                                                                                                                validate29.errors =
                                                                                                                                                                    [
                                                                                                                                                                        {
                                                                                                                                                                            instancePath:
                                                                                                                                                                                instancePath +
                                                                                                                                                                                '/start_time',
                                                                                                                                                                            schemaPath:
                                                                                                                                                                                '#/properties/start_time/type',
                                                                                                                                                                            keyword:
                                                                                                                                                                                'type',
                                                                                                                                                                            params: {
                                                                                                                                                                                type: schema43
                                                                                                                                                                                    .properties
                                                                                                                                                                                    .start_time
                                                                                                                                                                                    .type,
                                                                                                                                                                            },
                                                                                                                                                                            message:
                                                                                                                                                                                'must be number,null',
                                                                                                                                                                        },
                                                                                                                                                                    ];
                                                                                                                                                                return false;
                                                                                                                                                            }
                                                                                                                                                            var valid0 =
                                                                                                                                                                _errs68 ===
                                                                                                                                                                errors;
                                                                                                                                                        } else {
                                                                                                                                                            var valid0 = true;
                                                                                                                                                        }
                                                                                                                                                        if (
                                                                                                                                                            valid0
                                                                                                                                                        ) {
                                                                                                                                                            if (
                                                                                                                                                                data.supports_direct_chat !==
                                                                                                                                                                undefined
                                                                                                                                                            ) {
                                                                                                                                                                const _errs70 =
                                                                                                                                                                    errors;
                                                                                                                                                                if (
                                                                                                                                                                    typeof data.supports_direct_chat !==
                                                                                                                                                                    'boolean'
                                                                                                                                                                ) {
                                                                                                                                                                    validate29.errors =
                                                                                                                                                                        [
                                                                                                                                                                            {
                                                                                                                                                                                instancePath:
                                                                                                                                                                                    instancePath +
                                                                                                                                                                                    '/supports_direct_chat',
                                                                                                                                                                                schemaPath:
                                                                                                                                                                                    '#/properties/supports_direct_chat/type',
                                                                                                                                                                                keyword:
                                                                                                                                                                                    'type',
                                                                                                                                                                                params: {
                                                                                                                                                                                    type: 'boolean',
                                                                                                                                                                                },
                                                                                                                                                                                message:
                                                                                                                                                                                    'must be boolean',
                                                                                                                                                                            },
                                                                                                                                                                        ];
                                                                                                                                                                    return false;
                                                                                                                                                                }
                                                                                                                                                                var valid0 =
                                                                                                                                                                    _errs70 ===
                                                                                                                                                                    errors;
                                                                                                                                                            } else {
                                                                                                                                                                var valid0 = true;
                                                                                                                                                            }
                                                                                                                                                            if (
                                                                                                                                                                valid0
                                                                                                                                                            ) {
                                                                                                                                                                if (
                                                                                                                                                                    data.transfer_supported !==
                                                                                                                                                                    undefined
                                                                                                                                                                ) {
                                                                                                                                                                    let data35 =
                                                                                                                                                                        data.transfer_supported;
                                                                                                                                                                    const _errs72 =
                                                                                                                                                                        errors;
                                                                                                                                                                    if (
                                                                                                                                                                        typeof data35 !==
                                                                                                                                                                        'string'
                                                                                                                                                                    ) {
                                                                                                                                                                        validate29.errors =
                                                                                                                                                                            [
                                                                                                                                                                                {
                                                                                                                                                                                    instancePath:
                                                                                                                                                                                        instancePath +
                                                                                                                                                                                        '/transfer_supported',
                                                                                                                                                                                    schemaPath:
                                                                                                                                                                                        '#/properties/transfer_supported/type',
                                                                                                                                                                                    keyword:
                                                                                                                                                                                        'type',
                                                                                                                                                                                    params: {
                                                                                                                                                                                        type: 'string',
                                                                                                                                                                                    },
                                                                                                                                                                                    message:
                                                                                                                                                                                        'must be string',
                                                                                                                                                                                },
                                                                                                                                                                            ];
                                                                                                                                                                        return false;
                                                                                                                                                                    }
                                                                                                                                                                    if (!(
                                                                                                                                                                        data35 ===
                                                                                                                                                                            'YES' ||
                                                                                                                                                                        data35 ===
                                                                                                                                                                            'NO'
                                                                                                                                                                    )) {
                                                                                                                                                                        validate29.errors =
                                                                                                                                                                            [
                                                                                                                                                                                {
                                                                                                                                                                                    instancePath:
                                                                                                                                                                                        instancePath +
                                                                                                                                                                                        '/transfer_supported',
                                                                                                                                                                                    schemaPath:
                                                                                                                                                                                        '#/properties/transfer_supported/enum',
                                                                                                                                                                                    keyword:
                                                                                                                                                                                        'enum',
                                                                                                                                                                                    params: {
                                                                                                                                                                                        allowedValues:
                                                                                                                                                                                            schema43
                                                                                                                                                                                                .properties
                                                                                                                                                                                                .transfer_supported
                                                                                                                                                                                                .enum,
                                                                                                                                                                                    },
                                                                                                                                                                                    message:
                                                                                                                                                                                        'must be equal to one of the allowed values',
                                                                                                                                                                                },
                                                                                                                                                                            ];
                                                                                                                                                                        return false;
                                                                                                                                                                    }
                                                                                                                                                                    var valid0 =
                                                                                                                                                                        _errs72 ===
                                                                                                                                                                        errors;
                                                                                                                                                                } else {
                                                                                                                                                                    var valid0 = true;
                                                                                                                                                                }
                                                                                                                                                                if (
                                                                                                                                                                    valid0
                                                                                                                                                                ) {
                                                                                                                                                                    if (
                                                                                                                                                                        data.uuid !==
                                                                                                                                                                        undefined
                                                                                                                                                                    ) {
                                                                                                                                                                        const _errs74 =
                                                                                                                                                                            errors;
                                                                                                                                                                        if (
                                                                                                                                                                            typeof data.uuid !==
                                                                                                                                                                            'string'
                                                                                                                                                                        ) {
                                                                                                                                                                            validate29.errors =
                                                                                                                                                                                [
                                                                                                                                                                                    {
                                                                                                                                                                                        instancePath:
                                                                                                                                                                                            instancePath +
                                                                                                                                                                                            '/uuid',
                                                                                                                                                                                        schemaPath:
                                                                                                                                                                                            '#/properties/uuid/type',
                                                                                                                                                                                        keyword:
                                                                                                                                                                                            'type',
                                                                                                                                                                                        params: {
                                                                                                                                                                                            type: 'string',
                                                                                                                                                                                        },
                                                                                                                                                                                        message:
                                                                                                                                                                                            'must be string',
                                                                                                                                                                                    },
                                                                                                                                                                                ];
                                                                                                                                                                            return false;
                                                                                                                                                                        }
                                                                                                                                                                        var valid0 =
                                                                                                                                                                            _errs74 ===
                                                                                                                                                                            errors;
                                                                                                                                                                    } else {
                                                                                                                                                                        var valid0 = true;
                                                                                                                                                                    }
                                                                                                                                                                    if (
                                                                                                                                                                        valid0
                                                                                                                                                                    ) {
                                                                                                                                                                        if (
                                                                                                                                                                            data.uri !==
                                                                                                                                                                            undefined
                                                                                                                                                                        ) {
                                                                                                                                                                            const _errs76 =
                                                                                                                                                                                errors;
                                                                                                                                                                            if (
                                                                                                                                                                                typeof data.uri !==
                                                                                                                                                                                'string'
                                                                                                                                                                            ) {
                                                                                                                                                                                validate29.errors =
                                                                                                                                                                                    [
                                                                                                                                                                                        {
                                                                                                                                                                                            instancePath:
                                                                                                                                                                                                instancePath +
                                                                                                                                                                                                '/uri',
                                                                                                                                                                                            schemaPath:
                                                                                                                                                                                                '#/properties/uri/type',
                                                                                                                                                                                            keyword:
                                                                                                                                                                                                'type',
                                                                                                                                                                                            params: {
                                                                                                                                                                                                type: 'string',
                                                                                                                                                                                            },
                                                                                                                                                                                            message:
                                                                                                                                                                                                'must be string',
                                                                                                                                                                                        },
                                                                                                                                                                                    ];
                                                                                                                                                                                return false;
                                                                                                                                                                            }
                                                                                                                                                                            var valid0 =
                                                                                                                                                                                _errs76 ===
                                                                                                                                                                                errors;
                                                                                                                                                                        } else {
                                                                                                                                                                            var valid0 = true;
                                                                                                                                                                        }
                                                                                                                                                                        if (
                                                                                                                                                                            valid0
                                                                                                                                                                        ) {
                                                                                                                                                                            if (
                                                                                                                                                                                data.vendor !==
                                                                                                                                                                                undefined
                                                                                                                                                                            ) {
                                                                                                                                                                                const _errs78 =
                                                                                                                                                                                    errors;
                                                                                                                                                                                if (
                                                                                                                                                                                    typeof data.vendor !==
                                                                                                                                                                                    'string'
                                                                                                                                                                                ) {
                                                                                                                                                                                    validate29.errors =
                                                                                                                                                                                        [
                                                                                                                                                                                            {
                                                                                                                                                                                                instancePath:
                                                                                                                                                                                                    instancePath +
                                                                                                                                                                                                    '/vendor',
                                                                                                                                                                                                schemaPath:
                                                                                                                                                                                                    '#/properties/vendor/type',
                                                                                                                                                                                                keyword:
                                                                                                                                                                                                    'type',
                                                                                                                                                                                                params: {
                                                                                                                                                                                                    type: 'string',
                                                                                                                                                                                                },
                                                                                                                                                                                                message:
                                                                                                                                                                                                    'must be string',
                                                                                                                                                                                            },
                                                                                                                                                                                        ];
                                                                                                                                                                                    return false;
                                                                                                                                                                                }
                                                                                                                                                                                var valid0 =
                                                                                                                                                                                    _errs78 ===
                                                                                                                                                                                    errors;
                                                                                                                                                                            } else {
                                                                                                                                                                                var valid0 = true;
                                                                                                                                                                            }
                                                                                                                                                                            if (
                                                                                                                                                                                valid0
                                                                                                                                                                            ) {
                                                                                                                                                                                if (
                                                                                                                                                                                    data.last_spoken_time !==
                                                                                                                                                                                    undefined
                                                                                                                                                                                ) {
                                                                                                                                                                                    const _errs80 =
                                                                                                                                                                                        errors;
                                                                                                                                                                                    if (
                                                                                                                                                                                        !(
                                                                                                                                                                                            typeof data.last_spoken_time ==
                                                                                                                                                                                            'number'
                                                                                                                                                                                        )
                                                                                                                                                                                    ) {
                                                                                                                                                                                        validate29.errors =
                                                                                                                                                                                            [
                                                                                                                                                                                                {
                                                                                                                                                                                                    instancePath:
                                                                                                                                                                                                        instancePath +
                                                                                                                                                                                                        '/last_spoken_time',
                                                                                                                                                                                                    schemaPath:
                                                                                                                                                                                                        '#/properties/last_spoken_time/type',
                                                                                                                                                                                                    keyword:
                                                                                                                                                                                                        'type',
                                                                                                                                                                                                    params: {
                                                                                                                                                                                                        type: 'number',
                                                                                                                                                                                                    },
                                                                                                                                                                                                    message:
                                                                                                                                                                                                        'must be number',
                                                                                                                                                                                                },
                                                                                                                                                                                            ];
                                                                                                                                                                                        return false;
                                                                                                                                                                                    }
                                                                                                                                                                                    var valid0 =
                                                                                                                                                                                        _errs80 ===
                                                                                                                                                                                        errors;
                                                                                                                                                                                } else {
                                                                                                                                                                                    var valid0 = true;
                                                                                                                                                                                }
                                                                                                                                                                                if (
                                                                                                                                                                                    valid0
                                                                                                                                                                                ) {
                                                                                                                                                                                    if (
                                                                                                                                                                                        data.can_receive_personal_mix !==
                                                                                                                                                                                        undefined
                                                                                                                                                                                    ) {
                                                                                                                                                                                        const _errs82 =
                                                                                                                                                                                            errors;
                                                                                                                                                                                        if (
                                                                                                                                                                                            typeof data.can_receive_personal_mix !==
                                                                                                                                                                                            'boolean'
                                                                                                                                                                                        ) {
                                                                                                                                                                                            validate29.errors =
                                                                                                                                                                                                [
                                                                                                                                                                                                    {
                                                                                                                                                                                                        instancePath:
                                                                                                                                                                                                            instancePath +
                                                                                                                                                                                                            '/can_receive_personal_mix',
                                                                                                                                                                                                        schemaPath:
                                                                                                                                                                                                            '#/properties/can_receive_personal_mix/type',
                                                                                                                                                                                                        keyword:
                                                                                                                                                                                                            'type',
                                                                                                                                                                                                        params: {
                                                                                                                                                                                                            type: 'boolean',
                                                                                                                                                                                                        },
                                                                                                                                                                                                        message:
                                                                                                                                                                                                            'must be boolean',
                                                                                                                                                                                                    },
                                                                                                                                                                                                ];
                                                                                                                                                                                            return false;
                                                                                                                                                                                        }
                                                                                                                                                                                        var valid0 =
                                                                                                                                                                                            _errs82 ===
                                                                                                                                                                                            errors;
                                                                                                                                                                                    } else {
                                                                                                                                                                                        var valid0 = true;
                                                                                                                                                                                    }
                                                                                                                                                                                    if (
                                                                                                                                                                                        valid0
                                                                                                                                                                                    ) {
                                                                                                                                                                                        if (
                                                                                                                                                                                            data.receive_from_video_mix !==
                                                                                                                                                                                            undefined
                                                                                                                                                                                        ) {
                                                                                                                                                                                            let data41 =
                                                                                                                                                                                                data.receive_from_video_mix;
                                                                                                                                                                                            const _errs84 =
                                                                                                                                                                                                errors;
                                                                                                                                                                                            const _errs85 =
                                                                                                                                                                                                errors;
                                                                                                                                                                                            if (
                                                                                                                                                                                                errors ===
                                                                                                                                                                                                _errs85
                                                                                                                                                                                            ) {
                                                                                                                                                                                                if (
                                                                                                                                                                                                    data41 &&
                                                                                                                                                                                                    typeof data41 ==
                                                                                                                                                                                                        'object' &&
                                                                                                                                                                                                    !Array.isArray(
                                                                                                                                                                                                        data41,
                                                                                                                                                                                                    )
                                                                                                                                                                                                ) {
                                                                                                                                                                                                    let missing1;
                                                                                                                                                                                                    if (
                                                                                                                                                                                                        (data41.mix_name ===
                                                                                                                                                                                                            undefined &&
                                                                                                                                                                                                            (missing1 =
                                                                                                                                                                                                                'mix_name')) ||
                                                                                                                                                                                                        (data41.timestamp ===
                                                                                                                                                                                                            undefined &&
                                                                                                                                                                                                            (missing1 =
                                                                                                                                                                                                                'timestamp'))
                                                                                                                                                                                                    ) {
                                                                                                                                                                                                        validate29.errors =
                                                                                                                                                                                                            [
                                                                                                                                                                                                                {
                                                                                                                                                                                                                    instancePath:
                                                                                                                                                                                                                        instancePath +
                                                                                                                                                                                                                        '/receive_from_video_mix',
                                                                                                                                                                                                                    schemaPath:
                                                                                                                                                                                                                        '#/definitions/participants/properties/200/definitions/PersonalMix/required',
                                                                                                                                                                                                                    keyword:
                                                                                                                                                                                                                        'required',
                                                                                                                                                                                                                    params: {
                                                                                                                                                                                                                        missingProperty:
                                                                                                                                                                                                                            missing1,
                                                                                                                                                                                                                    },
                                                                                                                                                                                                                    message:
                                                                                                                                                                                                                        "must have required property '" +
                                                                                                                                                                                                                        missing1 +
                                                                                                                                                                                                                        "'",
                                                                                                                                                                                                                },
                                                                                                                                                                                                            ];
                                                                                                                                                                                                        return false;
                                                                                                                                                                                                    } else {
                                                                                                                                                                                                        const _errs87 =
                                                                                                                                                                                                            errors;
                                                                                                                                                                                                        for (const key1 in data41) {
                                                                                                                                                                                                            if (!(
                                                                                                                                                                                                                key1 ===
                                                                                                                                                                                                                    'mix_name' ||
                                                                                                                                                                                                                key1 ===
                                                                                                                                                                                                                    'timestamp' ||
                                                                                                                                                                                                                key1 ===
                                                                                                                                                                                                                    'mix_config'
                                                                                                                                                                                                            )) {
                                                                                                                                                                                                                delete data41[
                                                                                                                                                                                                                    key1
                                                                                                                                                                                                                ];
                                                                                                                                                                                                            }
                                                                                                                                                                                                        }
                                                                                                                                                                                                        if (
                                                                                                                                                                                                            _errs87 ===
                                                                                                                                                                                                            errors
                                                                                                                                                                                                        ) {
                                                                                                                                                                                                            if (
                                                                                                                                                                                                                data41.mix_name !==
                                                                                                                                                                                                                undefined
                                                                                                                                                                                                            ) {
                                                                                                                                                                                                                const _errs88 =
                                                                                                                                                                                                                    errors;
                                                                                                                                                                                                                if (
                                                                                                                                                                                                                    typeof data41.mix_name !==
                                                                                                                                                                                                                    'string'
                                                                                                                                                                                                                ) {
                                                                                                                                                                                                                    validate29.errors =
                                                                                                                                                                                                                        [
                                                                                                                                                                                                                            {
                                                                                                                                                                                                                                instancePath:
                                                                                                                                                                                                                                    instancePath +
                                                                                                                                                                                                                                    '/receive_from_video_mix/mix_name',
                                                                                                                                                                                                                                schemaPath:
                                                                                                                                                                                                                                    '#/definitions/participants/properties/200/definitions/PersonalMix/properties/mix_name/type',
                                                                                                                                                                                                                                keyword:
                                                                                                                                                                                                                                    'type',
                                                                                                                                                                                                                                params: {
                                                                                                                                                                                                                                    type: 'string',
                                                                                                                                                                                                                                },
                                                                                                                                                                                                                                message:
                                                                                                                                                                                                                                    'must be string',
                                                                                                                                                                                                                            },
                                                                                                                                                                                                                        ];
                                                                                                                                                                                                                    return false;
                                                                                                                                                                                                                }
                                                                                                                                                                                                                var valid2 =
                                                                                                                                                                                                                    _errs88 ===
                                                                                                                                                                                                                    errors;
                                                                                                                                                                                                            } else {
                                                                                                                                                                                                                var valid2 = true;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            if (
                                                                                                                                                                                                                valid2
                                                                                                                                                                                                            ) {
                                                                                                                                                                                                                if (
                                                                                                                                                                                                                    data41.timestamp !==
                                                                                                                                                                                                                    undefined
                                                                                                                                                                                                                ) {
                                                                                                                                                                                                                    const _errs90 =
                                                                                                                                                                                                                        errors;
                                                                                                                                                                                                                    if (
                                                                                                                                                                                                                        !(
                                                                                                                                                                                                                            typeof data41.timestamp ==
                                                                                                                                                                                                                            'number'
                                                                                                                                                                                                                        )
                                                                                                                                                                                                                    ) {
                                                                                                                                                                                                                        validate29.errors =
                                                                                                                                                                                                                            [
                                                                                                                                                                                                                                {
                                                                                                                                                                                                                                    instancePath:
                                                                                                                                                                                                                                        instancePath +
                                                                                                                                                                                                                                        '/receive_from_video_mix/timestamp',
                                                                                                                                                                                                                                    schemaPath:
                                                                                                                                                                                                                                        '#/definitions/participants/properties/200/definitions/PersonalMix/properties/timestamp/type',
                                                                                                                                                                                                                                    keyword:
                                                                                                                                                                                                                                        'type',
                                                                                                                                                                                                                                    params: {
                                                                                                                                                                                                                                        type: 'number',
                                                                                                                                                                                                                                    },
                                                                                                                                                                                                                                    message:
                                                                                                                                                                                                                                        'must be number',
                                                                                                                                                                                                                                },
                                                                                                                                                                                                                            ];
                                                                                                                                                                                                                        return false;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    var valid2 =
                                                                                                                                                                                                                        _errs90 ===
                                                                                                                                                                                                                        errors;
                                                                                                                                                                                                                } else {
                                                                                                                                                                                                                    var valid2 = true;
                                                                                                                                                                                                                }
                                                                                                                                                                                                                if (
                                                                                                                                                                                                                    valid2
                                                                                                                                                                                                                ) {
                                                                                                                                                                                                                    if (
                                                                                                                                                                                                                        data41.mix_config !==
                                                                                                                                                                                                                        undefined
                                                                                                                                                                                                                    ) {
                                                                                                                                                                                                                        let data44 =
                                                                                                                                                                                                                            data41.mix_config;
                                                                                                                                                                                                                        const _errs92 =
                                                                                                                                                                                                                            errors;
                                                                                                                                                                                                                        if (
                                                                                                                                                                                                                            errors ===
                                                                                                                                                                                                                            _errs92
                                                                                                                                                                                                                        ) {
                                                                                                                                                                                                                            if (
                                                                                                                                                                                                                                data44 &&
                                                                                                                                                                                                                                typeof data44 ==
                                                                                                                                                                                                                                    'object' &&
                                                                                                                                                                                                                                !Array.isArray(
                                                                                                                                                                                                                                    data44,
                                                                                                                                                                                                                                )
                                                                                                                                                                                                                            ) {
                                                                                                                                                                                                                                const _errs94 =
                                                                                                                                                                                                                                    errors;
                                                                                                                                                                                                                                for (const key2 in data44) {
                                                                                                                                                                                                                                    if (
                                                                                                                                                                                                                                        !(
                                                                                                                                                                                                                                            key2 ===
                                                                                                                                                                                                                                            'transform_layout'
                                                                                                                                                                                                                                        )
                                                                                                                                                                                                                                    ) {
                                                                                                                                                                                                                                        delete data44[
                                                                                                                                                                                                                                            key2
                                                                                                                                                                                                                                        ];
                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                if (
                                                                                                                                                                                                                                    _errs94 ===
                                                                                                                                                                                                                                    errors
                                                                                                                                                                                                                                ) {
                                                                                                                                                                                                                                    if (
                                                                                                                                                                                                                                        data44.transform_layout !==
                                                                                                                                                                                                                                        undefined
                                                                                                                                                                                                                                    ) {
                                                                                                                                                                                                                                        let data45 =
                                                                                                                                                                                                                                            data44.transform_layout;
                                                                                                                                                                                                                                        const _errs95 =
                                                                                                                                                                                                                                            errors;
                                                                                                                                                                                                                                        if (
                                                                                                                                                                                                                                            errors ===
                                                                                                                                                                                                                                            _errs95
                                                                                                                                                                                                                                        ) {
                                                                                                                                                                                                                                            if (
                                                                                                                                                                                                                                                data45 &&
                                                                                                                                                                                                                                                typeof data45 ==
                                                                                                                                                                                                                                                    'object' &&
                                                                                                                                                                                                                                                !Array.isArray(
                                                                                                                                                                                                                                                    data45,
                                                                                                                                                                                                                                                )
                                                                                                                                                                                                                                            ) {
                                                                                                                                                                                                                                                const _errs97 =
                                                                                                                                                                                                                                                    errors;
                                                                                                                                                                                                                                                for (const key3 in data45) {
                                                                                                                                                                                                                                                    if (
                                                                                                                                                                                                                                                        !(
                                                                                                                                                                                                                                                            key3 ===
                                                                                                                                                                                                                                                            'layout'
                                                                                                                                                                                                                                                        )
                                                                                                                                                                                                                                                    ) {
                                                                                                                                                                                                                                                        delete data45[
                                                                                                                                                                                                                                                            key3
                                                                                                                                                                                                                                                        ];
                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                if (
                                                                                                                                                                                                                                                    _errs97 ===
                                                                                                                                                                                                                                                    errors
                                                                                                                                                                                                                                                ) {
                                                                                                                                                                                                                                                    if (
                                                                                                                                                                                                                                                        data45.layout !==
                                                                                                                                                                                                                                                        undefined
                                                                                                                                                                                                                                                    ) {
                                                                                                                                                                                                                                                        if (
                                                                                                                                                                                                                                                            typeof data45.layout !==
                                                                                                                                                                                                                                                            'string'
                                                                                                                                                                                                                                                        ) {
                                                                                                                                                                                                                                                            validate29.errors =
                                                                                                                                                                                                                                                                [
                                                                                                                                                                                                                                                                    {
                                                                                                                                                                                                                                                                        instancePath:
                                                                                                                                                                                                                                                                            instancePath +
                                                                                                                                                                                                                                                                            '/receive_from_video_mix/mix_config/transform_layout/layout',
                                                                                                                                                                                                                                                                        schemaPath:
                                                                                                                                                                                                                                                                            '#/definitions/participants/properties/200/definitions/PersonalMix/properties/mix_config/properties/transform_layout/properties/layout/type',
                                                                                                                                                                                                                                                                        keyword:
                                                                                                                                                                                                                                                                            'type',
                                                                                                                                                                                                                                                                        params: {
                                                                                                                                                                                                                                                                            type: 'string',
                                                                                                                                                                                                                                                                        },
                                                                                                                                                                                                                                                                        message:
                                                                                                                                                                                                                                                                            'must be string',
                                                                                                                                                                                                                                                                    },
                                                                                                                                                                                                                                                                ];
                                                                                                                                                                                                                                                            return false;
                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                            } else {
                                                                                                                                                                                                                                                validate29.errors =
                                                                                                                                                                                                                                                    [
                                                                                                                                                                                                                                                        {
                                                                                                                                                                                                                                                            instancePath:
                                                                                                                                                                                                                                                                instancePath +
                                                                                                                                                                                                                                                                '/receive_from_video_mix/mix_config/transform_layout',
                                                                                                                                                                                                                                                            schemaPath:
                                                                                                                                                                                                                                                                '#/definitions/participants/properties/200/definitions/PersonalMix/properties/mix_config/properties/transform_layout/type',
                                                                                                                                                                                                                                                            keyword:
                                                                                                                                                                                                                                                                'type',
                                                                                                                                                                                                                                                            params: {
                                                                                                                                                                                                                                                                type: 'object',
                                                                                                                                                                                                                                                            },
                                                                                                                                                                                                                                                            message:
                                                                                                                                                                                                                                                                'must be object',
                                                                                                                                                                                                                                                        },
                                                                                                                                                                                                                                                    ];
                                                                                                                                                                                                                                                return false;
                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                }
                                                                                                                                                                                                                            } else {
                                                                                                                                                                                                                                validate29.errors =
                                                                                                                                                                                                                                    [
                                                                                                                                                                                                                                        {
                                                                                                                                                                                                                                            instancePath:
                                                                                                                                                                                                                                                instancePath +
                                                                                                                                                                                                                                                '/receive_from_video_mix/mix_config',
                                                                                                                                                                                                                                            schemaPath:
                                                                                                                                                                                                                                                '#/definitions/participants/properties/200/definitions/PersonalMix/properties/mix_config/type',
                                                                                                                                                                                                                                            keyword:
                                                                                                                                                                                                                                                'type',
                                                                                                                                                                                                                                            params: {
                                                                                                                                                                                                                                                type: 'object',
                                                                                                                                                                                                                                            },
                                                                                                                                                                                                                                            message:
                                                                                                                                                                                                                                                'must be object',
                                                                                                                                                                                                                                        },
                                                                                                                                                                                                                                    ];
                                                                                                                                                                                                                                return false;
                                                                                                                                                                                                                            }
                                                                                                                                                                                                                        }
                                                                                                                                                                                                                        var valid2 =
                                                                                                                                                                                                                            _errs92 ===
                                                                                                                                                                                                                            errors;
                                                                                                                                                                                                                    } else {
                                                                                                                                                                                                                        var valid2 = true;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                }
                                                                                                                                                                                                            }
                                                                                                                                                                                                        }
                                                                                                                                                                                                    }
                                                                                                                                                                                                } else {
                                                                                                                                                                                                    validate29.errors =
                                                                                                                                                                                                        [
                                                                                                                                                                                                            {
                                                                                                                                                                                                                instancePath:
                                                                                                                                                                                                                    instancePath +
                                                                                                                                                                                                                    '/receive_from_video_mix',
                                                                                                                                                                                                                schemaPath:
                                                                                                                                                                                                                    '#/definitions/participants/properties/200/definitions/PersonalMix/type',
                                                                                                                                                                                                                keyword:
                                                                                                                                                                                                                    'type',
                                                                                                                                                                                                                params: {
                                                                                                                                                                                                                    type: 'object',
                                                                                                                                                                                                                },
                                                                                                                                                                                                                message:
                                                                                                                                                                                                                    'must be object',
                                                                                                                                                                                                            },
                                                                                                                                                                                                        ];
                                                                                                                                                                                                    return false;
                                                                                                                                                                                                }
                                                                                                                                                                                            }
                                                                                                                                                                                            var valid0 =
                                                                                                                                                                                                _errs84 ===
                                                                                                                                                                                                errors;
                                                                                                                                                                                        } else {
                                                                                                                                                                                            var valid0 = true;
                                                                                                                                                                                        }
                                                                                                                                                                                    }
                                                                                                                                                                                }
                                                                                                                                                                            }
                                                                                                                                                                        }
                                                                                                                                                                    }
                                                                                                                                                                }
                                                                                                                                                            }
                                                                                                                                                        }
                                                                                                                                                    }
                                                                                                                                                }
                                                                                                                                            }
                                                                                                                                        }
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            }
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        } else {
            validate29.errors = [
                {
                    instancePath,
                    schemaPath: '#/type',
                    keyword: 'type',
                    params: {type: 'object'},
                    message: 'must be object',
                },
            ];
            return false;
        }
    }
    validate29.errors = vErrors;
    return errors === 0;
}
function validate28(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))
            ) {
                validate28.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: {missingProperty: missing0},
                        message:
                            "must have required property '" + missing0 + "'",
                    },
                ];
                return false;
            } else {
                const _errs1 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs1 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs2 = errors;
                        if (typeof data0 !== 'string') {
                            validate28.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/type',
                                    keyword: 'type',
                                    params: {type: 'string'},
                                    message: 'must be string',
                                },
                            ];
                            return false;
                        }
                        if (!(data0 === 'success')) {
                            validate28.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/enum',
                                    keyword: 'enum',
                                    params: {
                                        allowedValues:
                                            schema42.properties.status.enum,
                                    },
                                    message:
                                        'must be equal to one of the allowed values',
                                },
                            ];
                            return false;
                        }
                        var valid0 = _errs2 === errors;
                    } else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.result !== undefined) {
                            let data1 = data.result;
                            const _errs4 = errors;
                            if (errors === _errs4) {
                                if (Array.isArray(data1)) {
                                    var valid1 = true;
                                    const len0 = data1.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        const _errs6 = errors;
                                        if (
                                            !validate29(data1[i0], {
                                                instancePath:
                                                    instancePath +
                                                    '/result/' +
                                                    i0,
                                                parentData: data1,
                                                parentDataProperty: i0,
                                                rootData,
                                            })
                                        ) {
                                            vErrors =
                                                vErrors === null
                                                    ? validate29.errors
                                                    : vErrors.concat(
                                                          validate29.errors,
                                                      );
                                            errors = vErrors.length;
                                        }
                                        var valid1 = _errs6 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                } else {
                                    validate28.errors = [
                                        {
                                            instancePath:
                                                instancePath + '/result',
                                            schemaPath:
                                                '#/properties/result/type',
                                            keyword: 'type',
                                            params: {type: 'array'},
                                            message: 'must be array',
                                        },
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs4 === errors;
                        } else {
                            var valid0 = true;
                        }
                    }
                }
            }
        } else {
            validate28.errors = [
                {
                    instancePath,
                    schemaPath: '#/type',
                    keyword: 'type',
                    params: {type: 'object'},
                    message: 'must be object',
                },
            ];
            return false;
        }
    }
    validate28.errors = vErrors;
    return errors === 0;
}
function validate27(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (
        !validate28(data, {
            instancePath,
            parentData,
            parentDataProperty,
            rootData,
        })
    ) {
        vErrors =
            vErrors === null
                ? validate28.errors
                : vErrors.concat(validate28.errors);
        errors = vErrors.length;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err0 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err0];
        } else {
            vErrors.push(err0);
        }
        errors++;
        validate27.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate27.errors = vErrors;
    return errors === 0;
}
export const validateTransformLayoutBody = validate32;
const schema45 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        TopLevel: {
            type: 'object',
            additionalProperties: false,
            properties: {
                transforms: {
                    $ref: '#/definitions/transform_layout/properties/Body/definitions/Transforms',
                },
            },
            required: ['transforms'],
            title: 'TopLevel',
        },
        Transforms: {
            type: 'object',
            additionalProperties: false,
            properties: {
                layout: {
                    type: 'string',
                    description:
                        'In VMRs the layout for Hosts and Guests is controlled by the layout parameter.',
                },
                host_layout: {
                    type: 'string',
                    description:
                        'In Virtual Auditoriums the Host layout is controlled by the host_layout parameter',
                },
                guest_layout: {
                    type: 'string',
                    description:
                        'In Virtual Auditoriums the Guest layout is controlled by the guest_layout parameter',
                },
                enable_extended_ac: {
                    type: 'boolean',
                    description:
                        'This enables an extended Adaptive Composition (AC) layout that can contain more video participants than the standard AC layout.',
                },
                streaming_indicator: {
                    type: 'boolean',
                    description:
                        'Determines whether the streaming indicator icon is disabled (false) or enabled (true).',
                },
                recording_indicator: {
                    type: 'boolean',
                    description:
                        'Determines whether the recording indicator icon is disabled (false) or enabled (true).',
                },
                enable_active_speaker_indication: {
                    type: 'boolean',
                    description:
                        'Determines whether active speaker indication is disabled (false) or enabled (true).',
                },
                enable_overlay_text: {
                    type: 'boolean',
                    description:
                        'Determines whether active speaker indication is disabled (false) or enabled (true).',
                },
                streaming: {
                    $ref: '#/definitions/transform_layout/properties/Body/definitions/Streaming',
                },
                free_form_overlay_text: {
                    type: 'array',
                    description:
                        'Allows you to customize (override) the overlay text. It contains a list of strings to apply to each participant in the order in which the participants are displayed.',
                    items: {type: 'string'},
                },
            },
            required: [],
            title: 'Transforms',
        },
        Streaming: {
            type: 'object',
            additionalProperties: false,
            properties: {
                layout: {
                    type: 'string',
                    description:
                        'Sets the layout seen by the streaming participant (regardless of Host or Guest role).',
                },
                waiting_screen_enabled: {
                    type: 'boolean',
                    default: false,
                    description:
                        'Determines whether the stream_waiting splash screen is displayed (true) or not (false).',
                },
                plus_n_pip_enabled: {
                    type: 'boolean',
                    default: true,
                    description:
                        'Controls whether the `plus n indicator` i.e. the number of participants present in the conference, is displayed (true) or not (false).',
                },
                indicators_enabled: {
                    type: 'boolean',
                    default: true,
                    description:
                        'Controls whether the in-conference indicators (audio participant indicators, conference locked indicators etc.) are displayed (true) or not (false).',
                },
            },
            required: [],
            title: 'Streaming',
        },
    },
    oneOf: [
        {
            $ref: '#/definitions/transform_layout/properties/Body/definitions/TopLevel',
        },
    ],
};
const schema46 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        transforms: {
            $ref: '#/definitions/transform_layout/properties/Body/definitions/Transforms',
        },
    },
    required: ['transforms'],
    title: 'TopLevel',
};
const schema47 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        layout: {
            type: 'string',
            description:
                'In VMRs the layout for Hosts and Guests is controlled by the layout parameter.',
        },
        host_layout: {
            type: 'string',
            description:
                'In Virtual Auditoriums the Host layout is controlled by the host_layout parameter',
        },
        guest_layout: {
            type: 'string',
            description:
                'In Virtual Auditoriums the Guest layout is controlled by the guest_layout parameter',
        },
        enable_extended_ac: {
            type: 'boolean',
            description:
                'This enables an extended Adaptive Composition (AC) layout that can contain more video participants than the standard AC layout.',
        },
        streaming_indicator: {
            type: 'boolean',
            description:
                'Determines whether the streaming indicator icon is disabled (false) or enabled (true).',
        },
        recording_indicator: {
            type: 'boolean',
            description:
                'Determines whether the recording indicator icon is disabled (false) or enabled (true).',
        },
        enable_active_speaker_indication: {
            type: 'boolean',
            description:
                'Determines whether active speaker indication is disabled (false) or enabled (true).',
        },
        enable_overlay_text: {
            type: 'boolean',
            description:
                'Determines whether active speaker indication is disabled (false) or enabled (true).',
        },
        streaming: {
            $ref: '#/definitions/transform_layout/properties/Body/definitions/Streaming',
        },
        free_form_overlay_text: {
            type: 'array',
            description:
                'Allows you to customize (override) the overlay text. It contains a list of strings to apply to each participant in the order in which the participants are displayed.',
            items: {type: 'string'},
        },
    },
    required: [],
    title: 'Transforms',
};
const schema48 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        layout: {
            type: 'string',
            description:
                'Sets the layout seen by the streaming participant (regardless of Host or Guest role).',
        },
        waiting_screen_enabled: {
            type: 'boolean',
            default: false,
            description:
                'Determines whether the stream_waiting splash screen is displayed (true) or not (false).',
        },
        plus_n_pip_enabled: {
            type: 'boolean',
            default: true,
            description:
                'Controls whether the `plus n indicator` i.e. the number of participants present in the conference, is displayed (true) or not (false).',
        },
        indicators_enabled: {
            type: 'boolean',
            default: true,
            description:
                'Controls whether the in-conference indicators (audio participant indicators, conference locked indicators etc.) are displayed (true) or not (false).',
        },
    },
    required: [],
    title: 'Streaming',
};
function validate34(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            const _errs1 = errors;
            for (const key0 in data) {
                if (!func2.call(schema47.properties, key0)) {
                    delete data[key0];
                }
            }
            if (_errs1 === errors) {
                if (data.layout !== undefined) {
                    const _errs2 = errors;
                    if (typeof data.layout !== 'string') {
                        validate34.errors = [
                            {
                                instancePath: instancePath + '/layout',
                                schemaPath: '#/properties/layout/type',
                                keyword: 'type',
                                params: {type: 'string'},
                                message: 'must be string',
                            },
                        ];
                        return false;
                    }
                    var valid0 = _errs2 === errors;
                } else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.host_layout !== undefined) {
                        const _errs4 = errors;
                        if (typeof data.host_layout !== 'string') {
                            validate34.errors = [
                                {
                                    instancePath: instancePath + '/host_layout',
                                    schemaPath: '#/properties/host_layout/type',
                                    keyword: 'type',
                                    params: {type: 'string'},
                                    message: 'must be string',
                                },
                            ];
                            return false;
                        }
                        var valid0 = _errs4 === errors;
                    } else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.guest_layout !== undefined) {
                            const _errs6 = errors;
                            if (typeof data.guest_layout !== 'string') {
                                validate34.errors = [
                                    {
                                        instancePath:
                                            instancePath + '/guest_layout',
                                        schemaPath:
                                            '#/properties/guest_layout/type',
                                        keyword: 'type',
                                        params: {type: 'string'},
                                        message: 'must be string',
                                    },
                                ];
                                return false;
                            }
                            var valid0 = _errs6 === errors;
                        } else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.enable_extended_ac !== undefined) {
                                const _errs8 = errors;
                                if (
                                    typeof data.enable_extended_ac !== 'boolean'
                                ) {
                                    validate34.errors = [
                                        {
                                            instancePath:
                                                instancePath +
                                                '/enable_extended_ac',
                                            schemaPath:
                                                '#/properties/enable_extended_ac/type',
                                            keyword: 'type',
                                            params: {type: 'boolean'},
                                            message: 'must be boolean',
                                        },
                                    ];
                                    return false;
                                }
                                var valid0 = _errs8 === errors;
                            } else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.streaming_indicator !== undefined) {
                                    const _errs10 = errors;
                                    if (
                                        typeof data.streaming_indicator !==
                                        'boolean'
                                    ) {
                                        validate34.errors = [
                                            {
                                                instancePath:
                                                    instancePath +
                                                    '/streaming_indicator',
                                                schemaPath:
                                                    '#/properties/streaming_indicator/type',
                                                keyword: 'type',
                                                params: {type: 'boolean'},
                                                message: 'must be boolean',
                                            },
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs10 === errors;
                                } else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (
                                        data.recording_indicator !== undefined
                                    ) {
                                        const _errs12 = errors;
                                        if (
                                            typeof data.recording_indicator !==
                                            'boolean'
                                        ) {
                                            validate34.errors = [
                                                {
                                                    instancePath:
                                                        instancePath +
                                                        '/recording_indicator',
                                                    schemaPath:
                                                        '#/properties/recording_indicator/type',
                                                    keyword: 'type',
                                                    params: {type: 'boolean'},
                                                    message: 'must be boolean',
                                                },
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs12 === errors;
                                    } else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (
                                            data.enable_active_speaker_indication !==
                                            undefined
                                        ) {
                                            const _errs14 = errors;
                                            if (
                                                typeof data.enable_active_speaker_indication !==
                                                'boolean'
                                            ) {
                                                validate34.errors = [
                                                    {
                                                        instancePath:
                                                            instancePath +
                                                            '/enable_active_speaker_indication',
                                                        schemaPath:
                                                            '#/properties/enable_active_speaker_indication/type',
                                                        keyword: 'type',
                                                        params: {
                                                            type: 'boolean',
                                                        },
                                                        message:
                                                            'must be boolean',
                                                    },
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs14 === errors;
                                        } else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (
                                                data.enable_overlay_text !==
                                                undefined
                                            ) {
                                                const _errs16 = errors;
                                                if (
                                                    typeof data.enable_overlay_text !==
                                                    'boolean'
                                                ) {
                                                    validate34.errors = [
                                                        {
                                                            instancePath:
                                                                instancePath +
                                                                '/enable_overlay_text',
                                                            schemaPath:
                                                                '#/properties/enable_overlay_text/type',
                                                            keyword: 'type',
                                                            params: {
                                                                type: 'boolean',
                                                            },
                                                            message:
                                                                'must be boolean',
                                                        },
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs16 === errors;
                                            } else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (
                                                    data.streaming !== undefined
                                                ) {
                                                    let data8 = data.streaming;
                                                    const _errs18 = errors;
                                                    const _errs19 = errors;
                                                    if (errors === _errs19) {
                                                        if (
                                                            data8 &&
                                                            typeof data8 ==
                                                                'object' &&
                                                            !Array.isArray(
                                                                data8,
                                                            )
                                                        ) {
                                                            const _errs21 =
                                                                errors;
                                                            for (const key1 in data8) {
                                                                if (!(
                                                                    key1 ===
                                                                        'layout' ||
                                                                    key1 ===
                                                                        'waiting_screen_enabled' ||
                                                                    key1 ===
                                                                        'plus_n_pip_enabled' ||
                                                                    key1 ===
                                                                        'indicators_enabled'
                                                                )) {
                                                                    delete data8[
                                                                        key1
                                                                    ];
                                                                }
                                                            }
                                                            if (
                                                                _errs21 ===
                                                                errors
                                                            ) {
                                                                if (
                                                                    data8.layout !==
                                                                    undefined
                                                                ) {
                                                                    const _errs22 =
                                                                        errors;
                                                                    if (
                                                                        typeof data8.layout !==
                                                                        'string'
                                                                    ) {
                                                                        validate34.errors =
                                                                            [
                                                                                {
                                                                                    instancePath:
                                                                                        instancePath +
                                                                                        '/streaming/layout',
                                                                                    schemaPath:
                                                                                        '#/definitions/transform_layout/properties/Body/definitions/Streaming/properties/layout/type',
                                                                                    keyword:
                                                                                        'type',
                                                                                    params: {
                                                                                        type: 'string',
                                                                                    },
                                                                                    message:
                                                                                        'must be string',
                                                                                },
                                                                            ];
                                                                        return false;
                                                                    }
                                                                    var valid2 =
                                                                        _errs22 ===
                                                                        errors;
                                                                } else {
                                                                    var valid2 = true;
                                                                }
                                                                if (valid2) {
                                                                    if (
                                                                        data8.waiting_screen_enabled !==
                                                                        undefined
                                                                    ) {
                                                                        const _errs24 =
                                                                            errors;
                                                                        if (
                                                                            typeof data8.waiting_screen_enabled !==
                                                                            'boolean'
                                                                        ) {
                                                                            validate34.errors =
                                                                                [
                                                                                    {
                                                                                        instancePath:
                                                                                            instancePath +
                                                                                            '/streaming/waiting_screen_enabled',
                                                                                        schemaPath:
                                                                                            '#/definitions/transform_layout/properties/Body/definitions/Streaming/properties/waiting_screen_enabled/type',
                                                                                        keyword:
                                                                                            'type',
                                                                                        params: {
                                                                                            type: 'boolean',
                                                                                        },
                                                                                        message:
                                                                                            'must be boolean',
                                                                                    },
                                                                                ];
                                                                            return false;
                                                                        }
                                                                        var valid2 =
                                                                            _errs24 ===
                                                                            errors;
                                                                    } else {
                                                                        var valid2 = true;
                                                                    }
                                                                    if (
                                                                        valid2
                                                                    ) {
                                                                        if (
                                                                            data8.plus_n_pip_enabled !==
                                                                            undefined
                                                                        ) {
                                                                            const _errs26 =
                                                                                errors;
                                                                            if (
                                                                                typeof data8.plus_n_pip_enabled !==
                                                                                'boolean'
                                                                            ) {
                                                                                validate34.errors =
                                                                                    [
                                                                                        {
                                                                                            instancePath:
                                                                                                instancePath +
                                                                                                '/streaming/plus_n_pip_enabled',
                                                                                            schemaPath:
                                                                                                '#/definitions/transform_layout/properties/Body/definitions/Streaming/properties/plus_n_pip_enabled/type',
                                                                                            keyword:
                                                                                                'type',
                                                                                            params: {
                                                                                                type: 'boolean',
                                                                                            },
                                                                                            message:
                                                                                                'must be boolean',
                                                                                        },
                                                                                    ];
                                                                                return false;
                                                                            }
                                                                            var valid2 =
                                                                                _errs26 ===
                                                                                errors;
                                                                        } else {
                                                                            var valid2 = true;
                                                                        }
                                                                        if (
                                                                            valid2
                                                                        ) {
                                                                            if (
                                                                                data8.indicators_enabled !==
                                                                                undefined
                                                                            ) {
                                                                                const _errs28 =
                                                                                    errors;
                                                                                if (
                                                                                    typeof data8.indicators_enabled !==
                                                                                    'boolean'
                                                                                ) {
                                                                                    validate34.errors =
                                                                                        [
                                                                                            {
                                                                                                instancePath:
                                                                                                    instancePath +
                                                                                                    '/streaming/indicators_enabled',
                                                                                                schemaPath:
                                                                                                    '#/definitions/transform_layout/properties/Body/definitions/Streaming/properties/indicators_enabled/type',
                                                                                                keyword:
                                                                                                    'type',
                                                                                                params: {
                                                                                                    type: 'boolean',
                                                                                                },
                                                                                                message:
                                                                                                    'must be boolean',
                                                                                            },
                                                                                        ];
                                                                                    return false;
                                                                                }
                                                                                var valid2 =
                                                                                    _errs28 ===
                                                                                    errors;
                                                                            } else {
                                                                                var valid2 = true;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        } else {
                                                            validate34.errors =
                                                                [
                                                                    {
                                                                        instancePath:
                                                                            instancePath +
                                                                            '/streaming',
                                                                        schemaPath:
                                                                            '#/definitions/transform_layout/properties/Body/definitions/Streaming/type',
                                                                        keyword:
                                                                            'type',
                                                                        params: {
                                                                            type: 'object',
                                                                        },
                                                                        message:
                                                                            'must be object',
                                                                    },
                                                                ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid0 =
                                                        _errs18 === errors;
                                                } else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (
                                                        data.free_form_overlay_text !==
                                                        undefined
                                                    ) {
                                                        let data13 =
                                                            data.free_form_overlay_text;
                                                        const _errs30 = errors;
                                                        if (
                                                            errors === _errs30
                                                        ) {
                                                            if (
                                                                Array.isArray(
                                                                    data13,
                                                                )
                                                            ) {
                                                                var valid3 = true;
                                                                const len0 =
                                                                    data13.length;
                                                                for (
                                                                    let i0 = 0;
                                                                    i0 < len0;
                                                                    i0++
                                                                ) {
                                                                    const _errs32 =
                                                                        errors;
                                                                    if (
                                                                        typeof data13[
                                                                            i0
                                                                        ] !==
                                                                        'string'
                                                                    ) {
                                                                        validate34.errors =
                                                                            [
                                                                                {
                                                                                    instancePath:
                                                                                        instancePath +
                                                                                        '/free_form_overlay_text/' +
                                                                                        i0,
                                                                                    schemaPath:
                                                                                        '#/properties/free_form_overlay_text/items/type',
                                                                                    keyword:
                                                                                        'type',
                                                                                    params: {
                                                                                        type: 'string',
                                                                                    },
                                                                                    message:
                                                                                        'must be string',
                                                                                },
                                                                            ];
                                                                        return false;
                                                                    }
                                                                    var valid3 =
                                                                        _errs32 ===
                                                                        errors;
                                                                    if (
                                                                        !valid3
                                                                    ) {
                                                                        break;
                                                                    }
                                                                }
                                                            } else {
                                                                validate34.errors =
                                                                    [
                                                                        {
                                                                            instancePath:
                                                                                instancePath +
                                                                                '/free_form_overlay_text',
                                                                            schemaPath:
                                                                                '#/properties/free_form_overlay_text/type',
                                                                            keyword:
                                                                                'type',
                                                                            params: {
                                                                                type: 'array',
                                                                            },
                                                                            message:
                                                                                'must be array',
                                                                        },
                                                                    ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid0 =
                                                            _errs30 === errors;
                                                    } else {
                                                        var valid0 = true;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        } else {
            validate34.errors = [
                {
                    instancePath,
                    schemaPath: '#/type',
                    keyword: 'type',
                    params: {type: 'object'},
                    message: 'must be object',
                },
            ];
            return false;
        }
    }
    validate34.errors = vErrors;
    return errors === 0;
}
function validate33(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.transforms === undefined && (missing0 = 'transforms')) {
                validate33.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: {missingProperty: missing0},
                        message:
                            "must have required property '" + missing0 + "'",
                    },
                ];
                return false;
            } else {
                const _errs1 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'transforms')) {
                        delete data[key0];
                    }
                }
                if (_errs1 === errors) {
                    if (data.transforms !== undefined) {
                        if (
                            !validate34(data.transforms, {
                                instancePath: instancePath + '/transforms',
                                parentData: data,
                                parentDataProperty: 'transforms',
                                rootData,
                            })
                        ) {
                            vErrors =
                                vErrors === null
                                    ? validate34.errors
                                    : vErrors.concat(validate34.errors);
                            errors = vErrors.length;
                        }
                    }
                }
            }
        } else {
            validate33.errors = [
                {
                    instancePath,
                    schemaPath: '#/type',
                    keyword: 'type',
                    params: {type: 'object'},
                    message: 'must be object',
                },
            ];
            return false;
        }
    }
    validate33.errors = vErrors;
    return errors === 0;
}
function validate32(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (
        !validate33(data, {
            instancePath,
            parentData,
            parentDataProperty,
            rootData,
        })
    ) {
        vErrors =
            vErrors === null
                ? validate33.errors
                : vErrors.concat(validate33.errors);
        errors = vErrors.length;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err0 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err0];
        } else {
            vErrors.push(err0);
        }
        errors++;
        validate32.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate32.errors = vErrors;
    return errors === 0;
}
export const validateTransformLayout200 = validate37;
function validate37(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))
            ) {
                const err0 = {
                    instancePath,
                    schemaPath:
                        '#/definitions/lock/properties/200/definitions/200/required',
                    keyword: 'required',
                    params: {missingProperty: missing0},
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                } else {
                    vErrors.push(err0);
                }
                errors++;
            } else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/type',
                                keyword: 'type',
                                params: {type: 'string'},
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            } else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(data0 === 'success')) {
                            const err2 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues:
                                        schema20.properties.status.enum,
                                },
                                message:
                                    'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            } else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    } else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.result !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.result !== 'boolean') {
                                const err3 = {
                                    instancePath: instancePath + '/result',
                                    schemaPath:
                                        '#/definitions/lock/properties/200/definitions/200/properties/result/type',
                                    keyword: 'type',
                                    params: {type: 'boolean'},
                                    message: 'must be boolean',
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                } else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var valid2 = _errs7 === errors;
                        } else {
                            var valid2 = true;
                        }
                    }
                }
            }
        } else {
            const err4 = {
                instancePath,
                schemaPath:
                    '#/definitions/lock/properties/200/definitions/200/type',
                keyword: 'type',
                params: {type: 'object'},
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err4];
            } else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err5];
        } else {
            vErrors.push(err5);
        }
        errors++;
        validate37.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate37.errors = vErrors;
    return errors === 0;
}
export const validateClearAllBuzz200 = validate38;
function validate38(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))
            ) {
                const err0 = {
                    instancePath,
                    schemaPath:
                        '#/definitions/lock/properties/200/definitions/200/required',
                    keyword: 'required',
                    params: {missingProperty: missing0},
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                } else {
                    vErrors.push(err0);
                }
                errors++;
            } else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/type',
                                keyword: 'type',
                                params: {type: 'string'},
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            } else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(data0 === 'success')) {
                            const err2 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues:
                                        schema20.properties.status.enum,
                                },
                                message:
                                    'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            } else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    } else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.result !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.result !== 'boolean') {
                                const err3 = {
                                    instancePath: instancePath + '/result',
                                    schemaPath:
                                        '#/definitions/lock/properties/200/definitions/200/properties/result/type',
                                    keyword: 'type',
                                    params: {type: 'boolean'},
                                    message: 'must be boolean',
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                } else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var valid2 = _errs7 === errors;
                        } else {
                            var valid2 = true;
                        }
                    }
                }
            }
        } else {
            const err4 = {
                instancePath,
                schemaPath:
                    '#/definitions/lock/properties/200/definitions/200/type',
                keyword: 'type',
                params: {type: 'object'},
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err4];
            } else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err5];
        } else {
            vErrors.push(err5);
        }
        errors++;
        validate38.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate38.errors = vErrors;
    return errors === 0;
}
export const validateSilentVideoDetectionBody = validate39;
const schema53 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        TopLevel: {
            type: 'object',
            additionalProperties: false,
            properties: {
                config: {
                    $ref: '#/definitions/silent_video_detection/properties/Body/definitions/Config',
                },
            },
            required: ['config'],
            title: 'TopLevel',
        },
        Config: {
            type: 'object',
            additionalProperties: false,
            properties: {
                enable: {
                    type: 'boolean',
                    default: true,
                    description:
                        'Determines whether silent video detection (no faces or movement) is disabled (false) or enabled (true).',
                },
                silent_after: {
                    type: 'number',
                    default: 15,
                    description:
                        "The minimum number of seconds the participant's video has to silent before it is considered for removal from the video mix (it may take longer than this before the video is actually removed). Values from 1-120.",
                },
                require_no_faces: {
                    type: 'boolean',
                    default: true,
                    description:
                        'Determines whether or not detected faces in the video are taken into consideration:\ntrue: a participant cannot be marked as silent if a face is detected.\nfalse: face-detection is ignored.',
                },
                reactivate_after: {
                    type: 'number',
                    default: 2,
                    description:
                        'The minimum number of seconds of moving video that is required before marking the participant as no longer silent. Values 1-5.',
                },
            },
            required: [],
            title: 'Config',
        },
    },
    oneOf: [
        {
            $ref: '#/definitions/silent_video_detection/properties/Body/definitions/TopLevel',
        },
    ],
};
const schema54 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        config: {
            $ref: '#/definitions/silent_video_detection/properties/Body/definitions/Config',
        },
    },
    required: ['config'],
    title: 'TopLevel',
};
const schema55 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        enable: {
            type: 'boolean',
            default: true,
            description:
                'Determines whether silent video detection (no faces or movement) is disabled (false) or enabled (true).',
        },
        silent_after: {
            type: 'number',
            default: 15,
            description:
                "The minimum number of seconds the participant's video has to silent before it is considered for removal from the video mix (it may take longer than this before the video is actually removed). Values from 1-120.",
        },
        require_no_faces: {
            type: 'boolean',
            default: true,
            description:
                'Determines whether or not detected faces in the video are taken into consideration:\ntrue: a participant cannot be marked as silent if a face is detected.\nfalse: face-detection is ignored.',
        },
        reactivate_after: {
            type: 'number',
            default: 2,
            description:
                'The minimum number of seconds of moving video that is required before marking the participant as no longer silent. Values 1-5.',
        },
    },
    required: [],
    title: 'Config',
};
function validate40(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.config === undefined && (missing0 = 'config')) {
                validate40.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: {missingProperty: missing0},
                        message:
                            "must have required property '" + missing0 + "'",
                    },
                ];
                return false;
            } else {
                const _errs1 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'config')) {
                        delete data[key0];
                    }
                }
                if (_errs1 === errors) {
                    if (data.config !== undefined) {
                        let data0 = data.config;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (
                                data0 &&
                                typeof data0 == 'object' &&
                                !Array.isArray(data0)
                            ) {
                                const _errs5 = errors;
                                for (const key1 in data0) {
                                    if (!(
                                        key1 === 'enable' ||
                                        key1 === 'silent_after' ||
                                        key1 === 'require_no_faces' ||
                                        key1 === 'reactivate_after'
                                    )) {
                                        delete data0[key1];
                                    }
                                }
                                if (_errs5 === errors) {
                                    if (data0.enable !== undefined) {
                                        const _errs6 = errors;
                                        if (typeof data0.enable !== 'boolean') {
                                            validate40.errors = [
                                                {
                                                    instancePath:
                                                        instancePath +
                                                        '/config/enable',
                                                    schemaPath:
                                                        '#/definitions/silent_video_detection/properties/Body/definitions/Config/properties/enable/type',
                                                    keyword: 'type',
                                                    params: {type: 'boolean'},
                                                    message: 'must be boolean',
                                                },
                                            ];
                                            return false;
                                        }
                                        var valid2 = _errs6 === errors;
                                    } else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data0.silent_after !== undefined) {
                                            const _errs8 = errors;
                                            if (
                                                !(
                                                    typeof data0.silent_after ==
                                                    'number'
                                                )
                                            ) {
                                                validate40.errors = [
                                                    {
                                                        instancePath:
                                                            instancePath +
                                                            '/config/silent_after',
                                                        schemaPath:
                                                            '#/definitions/silent_video_detection/properties/Body/definitions/Config/properties/silent_after/type',
                                                        keyword: 'type',
                                                        params: {
                                                            type: 'number',
                                                        },
                                                        message:
                                                            'must be number',
                                                    },
                                                ];
                                                return false;
                                            }
                                            var valid2 = _errs8 === errors;
                                        } else {
                                            var valid2 = true;
                                        }
                                        if (valid2) {
                                            if (
                                                data0.require_no_faces !==
                                                undefined
                                            ) {
                                                const _errs10 = errors;
                                                if (
                                                    typeof data0.require_no_faces !==
                                                    'boolean'
                                                ) {
                                                    validate40.errors = [
                                                        {
                                                            instancePath:
                                                                instancePath +
                                                                '/config/require_no_faces',
                                                            schemaPath:
                                                                '#/definitions/silent_video_detection/properties/Body/definitions/Config/properties/require_no_faces/type',
                                                            keyword: 'type',
                                                            params: {
                                                                type: 'boolean',
                                                            },
                                                            message:
                                                                'must be boolean',
                                                        },
                                                    ];
                                                    return false;
                                                }
                                                var valid2 = _errs10 === errors;
                                            } else {
                                                var valid2 = true;
                                            }
                                            if (valid2) {
                                                if (
                                                    data0.reactivate_after !==
                                                    undefined
                                                ) {
                                                    const _errs12 = errors;
                                                    if (
                                                        !(
                                                            typeof data0.reactivate_after ==
                                                            'number'
                                                        )
                                                    ) {
                                                        validate40.errors = [
                                                            {
                                                                instancePath:
                                                                    instancePath +
                                                                    '/config/reactivate_after',
                                                                schemaPath:
                                                                    '#/definitions/silent_video_detection/properties/Body/definitions/Config/properties/reactivate_after/type',
                                                                keyword: 'type',
                                                                params: {
                                                                    type: 'number',
                                                                },
                                                                message:
                                                                    'must be number',
                                                            },
                                                        ];
                                                        return false;
                                                    }
                                                    var valid2 =
                                                        _errs12 === errors;
                                                } else {
                                                    var valid2 = true;
                                                }
                                            }
                                        }
                                    }
                                }
                            } else {
                                validate40.errors = [
                                    {
                                        instancePath: instancePath + '/config',
                                        schemaPath:
                                            '#/definitions/silent_video_detection/properties/Body/definitions/Config/type',
                                        keyword: 'type',
                                        params: {type: 'object'},
                                        message: 'must be object',
                                    },
                                ];
                                return false;
                            }
                        }
                    }
                }
            }
        } else {
            validate40.errors = [
                {
                    instancePath,
                    schemaPath: '#/type',
                    keyword: 'type',
                    params: {type: 'object'},
                    message: 'must be object',
                },
            ];
            return false;
        }
    }
    validate40.errors = vErrors;
    return errors === 0;
}
function validate39(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (
        !validate40(data, {
            instancePath,
            parentData,
            parentDataProperty,
            rootData,
        })
    ) {
        vErrors =
            vErrors === null
                ? validate40.errors
                : vErrors.concat(validate40.errors);
        errors = vErrors.length;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err0 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err0];
        } else {
            vErrors.push(err0);
        }
        errors++;
        validate39.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate39.errors = vErrors;
    return errors === 0;
}
export const validateSilentVideoDetection200 = validate42;
function validate42(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))
            ) {
                const err0 = {
                    instancePath,
                    schemaPath:
                        '#/definitions/lock/properties/200/definitions/200/required',
                    keyword: 'required',
                    params: {missingProperty: missing0},
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                } else {
                    vErrors.push(err0);
                }
                errors++;
            } else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/type',
                                keyword: 'type',
                                params: {type: 'string'},
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            } else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(data0 === 'success')) {
                            const err2 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues:
                                        schema20.properties.status.enum,
                                },
                                message:
                                    'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            } else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    } else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.result !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.result !== 'boolean') {
                                const err3 = {
                                    instancePath: instancePath + '/result',
                                    schemaPath:
                                        '#/definitions/lock/properties/200/definitions/200/properties/result/type',
                                    keyword: 'type',
                                    params: {type: 'boolean'},
                                    message: 'must be boolean',
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                } else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var valid2 = _errs7 === errors;
                        } else {
                            var valid2 = true;
                        }
                    }
                }
            }
        } else {
            const err4 = {
                instancePath,
                schemaPath:
                    '#/definitions/lock/properties/200/definitions/200/type',
                keyword: 'type',
                params: {type: 'object'},
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err4];
            } else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err5];
        } else {
            vErrors.push(err5);
        }
        errors++;
        validate42.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate42.errors = vErrors;
    return errors === 0;
}
export const validateTheme200 = validate43;
const schema58 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        '200': {
            type: 'object',
            additionalProperties: false,
            properties: {
                status: {
                    type: 'string',
                    description: 'Status of the response, eg. success.',
                    enum: ['success', 'failed'],
                },
                result: {
                    type: 'object',
                    additionalProperties: false,
                    properties: {
                        direct_media_welcome: {
                            $ref: '#/definitions/theme/properties/200/definitions/Screen',
                        },
                        direct_media_waiting_for_host: {
                            $ref: '#/definitions/theme/properties/200/definitions/Screen',
                        },
                        direct_media_other_participants_audio_only: {
                            $ref: '#/definitions/theme/properties/200/definitions/Screen',
                        },
                        direct_media_escalate: {
                            $ref: '#/definitions/theme/properties/200/definitions/Screen',
                        },
                        direct_media_deescalate: {
                            $ref: '#/definitions/theme/properties/200/definitions/Screen',
                        },
                        direct_media_host_left: {
                            $ref: '#/definitions/theme/properties/200/definitions/Screen',
                        },
                    },
                    required: [
                        'direct_media_welcome',
                        'direct_media_waiting_for_host',
                        'direct_media_other_participants_audio_only',
                        'direct_media_escalate',
                        'direct_media_deescalate',
                    ],
                    title: 'Result',
                },
            },
            required: ['status', 'result'],
            title: 'Status200',
        },
        Screen: {
            type: 'object',
            additionalProperties: false,
            properties: {
                layout_type: {type: 'string', enum: ['direct_media']},
                background: {
                    $ref: '#/definitions/theme/properties/200/definitions/Background',
                },
                elements: {
                    type: 'array',
                    items: {
                        oneOf: [
                            {
                                $ref: '#/definitions/theme/properties/200/definitions/Text',
                            },
                        ],
                    },
                },
            },
            required: ['layout_type', 'background', 'elements'],
            title: 'Screen',
        },
        Background: {
            type: 'object',
            additionalProperties: false,
            properties: {path: {type: 'string'}},
            required: ['path'],
            title: 'Background',
        },
        Text: {
            type: 'object',
            additionalProperties: false,
            properties: {
                type: {type: 'string', enum: ['text']},
                color: {type: 'number'},
                text: {type: 'string'},
            },
            required: ['type', 'color', 'text'],
            title: 'Text',
        },
    },
    oneOf: [{$ref: '#/definitions/theme/properties/200/definitions/200'}],
};
const schema59 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        status: {
            type: 'string',
            description: 'Status of the response, eg. success.',
            enum: ['success', 'failed'],
        },
        result: {
            type: 'object',
            additionalProperties: false,
            properties: {
                direct_media_welcome: {
                    $ref: '#/definitions/theme/properties/200/definitions/Screen',
                },
                direct_media_waiting_for_host: {
                    $ref: '#/definitions/theme/properties/200/definitions/Screen',
                },
                direct_media_other_participants_audio_only: {
                    $ref: '#/definitions/theme/properties/200/definitions/Screen',
                },
                direct_media_escalate: {
                    $ref: '#/definitions/theme/properties/200/definitions/Screen',
                },
                direct_media_deescalate: {
                    $ref: '#/definitions/theme/properties/200/definitions/Screen',
                },
                direct_media_host_left: {
                    $ref: '#/definitions/theme/properties/200/definitions/Screen',
                },
            },
            required: [
                'direct_media_welcome',
                'direct_media_waiting_for_host',
                'direct_media_other_participants_audio_only',
                'direct_media_escalate',
                'direct_media_deescalate',
            ],
            title: 'Result',
        },
    },
    required: ['status', 'result'],
    title: 'Status200',
};
const schema60 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        layout_type: {type: 'string', enum: ['direct_media']},
        background: {
            $ref: '#/definitions/theme/properties/200/definitions/Background',
        },
        elements: {
            type: 'array',
            items: {
                oneOf: [
                    {
                        $ref: '#/definitions/theme/properties/200/definitions/Text',
                    },
                ],
            },
        },
    },
    required: ['layout_type', 'background', 'elements'],
    title: 'Screen',
};
const schema61 = {
    type: 'object',
    additionalProperties: false,
    properties: {path: {type: 'string'}},
    required: ['path'],
    title: 'Background',
};
const schema62 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        type: {type: 'string', enum: ['text']},
        color: {type: 'number'},
        text: {type: 'string'},
    },
    required: ['type', 'color', 'text'],
    title: 'Text',
};
function validate45(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.layout_type === undefined &&
                    (missing0 = 'layout_type')) ||
                (data.background === undefined && (missing0 = 'background')) ||
                (data.elements === undefined && (missing0 = 'elements'))
            ) {
                validate45.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: {missingProperty: missing0},
                        message:
                            "must have required property '" + missing0 + "'",
                    },
                ];
                return false;
            } else {
                const _errs1 = errors;
                for (const key0 in data) {
                    if (!(
                        key0 === 'layout_type' ||
                        key0 === 'background' ||
                        key0 === 'elements'
                    )) {
                        delete data[key0];
                    }
                }
                if (_errs1 === errors) {
                    if (data.layout_type !== undefined) {
                        let data0 = data.layout_type;
                        const _errs2 = errors;
                        if (typeof data0 !== 'string') {
                            validate45.errors = [
                                {
                                    instancePath: instancePath + '/layout_type',
                                    schemaPath: '#/properties/layout_type/type',
                                    keyword: 'type',
                                    params: {type: 'string'},
                                    message: 'must be string',
                                },
                            ];
                            return false;
                        }
                        if (!(data0 === 'direct_media')) {
                            validate45.errors = [
                                {
                                    instancePath: instancePath + '/layout_type',
                                    schemaPath: '#/properties/layout_type/enum',
                                    keyword: 'enum',
                                    params: {
                                        allowedValues:
                                            schema60.properties.layout_type
                                                .enum,
                                    },
                                    message:
                                        'must be equal to one of the allowed values',
                                },
                            ];
                            return false;
                        }
                        var valid0 = _errs2 === errors;
                    } else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.background !== undefined) {
                            let data1 = data.background;
                            const _errs4 = errors;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (
                                    data1 &&
                                    typeof data1 == 'object' &&
                                    !Array.isArray(data1)
                                ) {
                                    let missing1;
                                    if (
                                        data1.path === undefined &&
                                        (missing1 = 'path')
                                    ) {
                                        validate45.errors = [
                                            {
                                                instancePath:
                                                    instancePath +
                                                    '/background',
                                                schemaPath:
                                                    '#/definitions/theme/properties/200/definitions/Background/required',
                                                keyword: 'required',
                                                params: {
                                                    missingProperty: missing1,
                                                },
                                                message:
                                                    "must have required property '" +
                                                    missing1 +
                                                    "'",
                                            },
                                        ];
                                        return false;
                                    } else {
                                        const _errs7 = errors;
                                        for (const key1 in data1) {
                                            if (!(key1 === 'path')) {
                                                delete data1[key1];
                                            }
                                        }
                                        if (_errs7 === errors) {
                                            if (data1.path !== undefined) {
                                                if (
                                                    typeof data1.path !==
                                                    'string'
                                                ) {
                                                    validate45.errors = [
                                                        {
                                                            instancePath:
                                                                instancePath +
                                                                '/background/path',
                                                            schemaPath:
                                                                '#/definitions/theme/properties/200/definitions/Background/properties/path/type',
                                                            keyword: 'type',
                                                            params: {
                                                                type: 'string',
                                                            },
                                                            message:
                                                                'must be string',
                                                        },
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    validate45.errors = [
                                        {
                                            instancePath:
                                                instancePath + '/background',
                                            schemaPath:
                                                '#/definitions/theme/properties/200/definitions/Background/type',
                                            keyword: 'type',
                                            params: {type: 'object'},
                                            message: 'must be object',
                                        },
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs4 === errors;
                        } else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.elements !== undefined) {
                                let data3 = data.elements;
                                const _errs10 = errors;
                                if (errors === _errs10) {
                                    if (Array.isArray(data3)) {
                                        var valid3 = true;
                                        const len0 = data3.length;
                                        for (let i0 = 0; i0 < len0; i0++) {
                                            let data4 = data3[i0];
                                            const _errs12 = errors;
                                            const _errs13 = errors;
                                            let valid4 = false;
                                            let passing0 = null;
                                            const _errs14 = errors;
                                            const _errs15 = errors;
                                            if (errors === _errs15) {
                                                if (
                                                    data4 &&
                                                    typeof data4 == 'object' &&
                                                    !Array.isArray(data4)
                                                ) {
                                                    let missing2;
                                                    if (
                                                        (data4.type ===
                                                            undefined &&
                                                            (missing2 =
                                                                'type')) ||
                                                        (data4.color ===
                                                            undefined &&
                                                            (missing2 =
                                                                'color')) ||
                                                        (data4.text ===
                                                            undefined &&
                                                            (missing2 = 'text'))
                                                    ) {
                                                        const err0 = {
                                                            instancePath:
                                                                instancePath +
                                                                '/elements/' +
                                                                i0,
                                                            schemaPath:
                                                                '#/definitions/theme/properties/200/definitions/Text/required',
                                                            keyword: 'required',
                                                            params: {
                                                                missingProperty:
                                                                    missing2,
                                                            },
                                                            message:
                                                                "must have required property '" +
                                                                missing2 +
                                                                "'",
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err0];
                                                        } else {
                                                            vErrors.push(err0);
                                                        }
                                                        errors++;
                                                    } else {
                                                        const _errs17 = errors;
                                                        for (const key2 in data4) {
                                                            if (!(
                                                                key2 ===
                                                                    'type' ||
                                                                key2 ===
                                                                    'color' ||
                                                                key2 === 'text'
                                                            )) {
                                                                delete data4[
                                                                    key2
                                                                ];
                                                            }
                                                        }
                                                        if (
                                                            _errs17 === errors
                                                        ) {
                                                            if (
                                                                data4.type !==
                                                                undefined
                                                            ) {
                                                                let data5 =
                                                                    data4.type;
                                                                const _errs18 =
                                                                    errors;
                                                                if (
                                                                    typeof data5 !==
                                                                    'string'
                                                                ) {
                                                                    const err1 =
                                                                        {
                                                                            instancePath:
                                                                                instancePath +
                                                                                '/elements/' +
                                                                                i0 +
                                                                                '/type',
                                                                            schemaPath:
                                                                                '#/definitions/theme/properties/200/definitions/Text/properties/type/type',
                                                                            keyword:
                                                                                'type',
                                                                            params: {
                                                                                type: 'string',
                                                                            },
                                                                            message:
                                                                                'must be string',
                                                                        };
                                                                    if (
                                                                        vErrors ===
                                                                        null
                                                                    ) {
                                                                        vErrors =
                                                                            [
                                                                                err1,
                                                                            ];
                                                                    } else {
                                                                        vErrors.push(
                                                                            err1,
                                                                        );
                                                                    }
                                                                    errors++;
                                                                }
                                                                if (
                                                                    !(
                                                                        data5 ===
                                                                        'text'
                                                                    )
                                                                ) {
                                                                    const err2 =
                                                                        {
                                                                            instancePath:
                                                                                instancePath +
                                                                                '/elements/' +
                                                                                i0 +
                                                                                '/type',
                                                                            schemaPath:
                                                                                '#/definitions/theme/properties/200/definitions/Text/properties/type/enum',
                                                                            keyword:
                                                                                'enum',
                                                                            params: {
                                                                                allowedValues:
                                                                                    schema62
                                                                                        .properties
                                                                                        .type
                                                                                        .enum,
                                                                            },
                                                                            message:
                                                                                'must be equal to one of the allowed values',
                                                                        };
                                                                    if (
                                                                        vErrors ===
                                                                        null
                                                                    ) {
                                                                        vErrors =
                                                                            [
                                                                                err2,
                                                                            ];
                                                                    } else {
                                                                        vErrors.push(
                                                                            err2,
                                                                        );
                                                                    }
                                                                    errors++;
                                                                }
                                                                var valid6 =
                                                                    _errs18 ===
                                                                    errors;
                                                            } else {
                                                                var valid6 = true;
                                                            }
                                                            if (valid6) {
                                                                if (
                                                                    data4.color !==
                                                                    undefined
                                                                ) {
                                                                    const _errs20 =
                                                                        errors;
                                                                    if (
                                                                        !(
                                                                            typeof data4.color ==
                                                                            'number'
                                                                        )
                                                                    ) {
                                                                        const err3 =
                                                                            {
                                                                                instancePath:
                                                                                    instancePath +
                                                                                    '/elements/' +
                                                                                    i0 +
                                                                                    '/color',
                                                                                schemaPath:
                                                                                    '#/definitions/theme/properties/200/definitions/Text/properties/color/type',
                                                                                keyword:
                                                                                    'type',
                                                                                params: {
                                                                                    type: 'number',
                                                                                },
                                                                                message:
                                                                                    'must be number',
                                                                            };
                                                                        if (
                                                                            vErrors ===
                                                                            null
                                                                        ) {
                                                                            vErrors =
                                                                                [
                                                                                    err3,
                                                                                ];
                                                                        } else {
                                                                            vErrors.push(
                                                                                err3,
                                                                            );
                                                                        }
                                                                        errors++;
                                                                    }
                                                                    var valid6 =
                                                                        _errs20 ===
                                                                        errors;
                                                                } else {
                                                                    var valid6 = true;
                                                                }
                                                                if (valid6) {
                                                                    if (
                                                                        data4.text !==
                                                                        undefined
                                                                    ) {
                                                                        const _errs22 =
                                                                            errors;
                                                                        if (
                                                                            typeof data4.text !==
                                                                            'string'
                                                                        ) {
                                                                            const err4 =
                                                                                {
                                                                                    instancePath:
                                                                                        instancePath +
                                                                                        '/elements/' +
                                                                                        i0 +
                                                                                        '/text',
                                                                                    schemaPath:
                                                                                        '#/definitions/theme/properties/200/definitions/Text/properties/text/type',
                                                                                    keyword:
                                                                                        'type',
                                                                                    params: {
                                                                                        type: 'string',
                                                                                    },
                                                                                    message:
                                                                                        'must be string',
                                                                                };
                                                                            if (
                                                                                vErrors ===
                                                                                null
                                                                            ) {
                                                                                vErrors =
                                                                                    [
                                                                                        err4,
                                                                                    ];
                                                                            } else {
                                                                                vErrors.push(
                                                                                    err4,
                                                                                );
                                                                            }
                                                                            errors++;
                                                                        }
                                                                        var valid6 =
                                                                            _errs22 ===
                                                                            errors;
                                                                    } else {
                                                                        var valid6 = true;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                } else {
                                                    const err5 = {
                                                        instancePath:
                                                            instancePath +
                                                            '/elements/' +
                                                            i0,
                                                        schemaPath:
                                                            '#/definitions/theme/properties/200/definitions/Text/type',
                                                        keyword: 'type',
                                                        params: {
                                                            type: 'object',
                                                        },
                                                        message:
                                                            'must be object',
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err5];
                                                    } else {
                                                        vErrors.push(err5);
                                                    }
                                                    errors++;
                                                }
                                            }
                                            var _valid0 = _errs14 === errors;
                                            if (_valid0) {
                                                valid4 = true;
                                                passing0 = 0;
                                            }
                                            if (!valid4) {
                                                const err6 = {
                                                    instancePath:
                                                        instancePath +
                                                        '/elements/' +
                                                        i0,
                                                    schemaPath:
                                                        '#/properties/elements/items/oneOf',
                                                    keyword: 'oneOf',
                                                    params: {
                                                        passingSchemas:
                                                            passing0,
                                                    },
                                                    message:
                                                        'must match exactly one schema in oneOf',
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err6];
                                                } else {
                                                    vErrors.push(err6);
                                                }
                                                errors++;
                                                validate45.errors = vErrors;
                                                return false;
                                            } else {
                                                errors = _errs13;
                                                if (vErrors !== null) {
                                                    if (_errs13) {
                                                        vErrors.length =
                                                            _errs13;
                                                    } else {
                                                        vErrors = null;
                                                    }
                                                }
                                            }
                                            var valid3 = _errs12 === errors;
                                            if (!valid3) {
                                                break;
                                            }
                                        }
                                    } else {
                                        validate45.errors = [
                                            {
                                                instancePath:
                                                    instancePath + '/elements',
                                                schemaPath:
                                                    '#/properties/elements/type',
                                                keyword: 'type',
                                                params: {type: 'array'},
                                                message: 'must be array',
                                            },
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs10 === errors;
                            } else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        } else {
            validate45.errors = [
                {
                    instancePath,
                    schemaPath: '#/type',
                    keyword: 'type',
                    params: {type: 'object'},
                    message: 'must be object',
                },
            ];
            return false;
        }
    }
    validate45.errors = vErrors;
    return errors === 0;
}
function validate44(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))
            ) {
                validate44.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: {missingProperty: missing0},
                        message:
                            "must have required property '" + missing0 + "'",
                    },
                ];
                return false;
            } else {
                const _errs1 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs1 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs2 = errors;
                        if (typeof data0 !== 'string') {
                            validate44.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/type',
                                    keyword: 'type',
                                    params: {type: 'string'},
                                    message: 'must be string',
                                },
                            ];
                            return false;
                        }
                        if (!(data0 === 'success' || data0 === 'failed')) {
                            validate44.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/enum',
                                    keyword: 'enum',
                                    params: {
                                        allowedValues:
                                            schema59.properties.status.enum,
                                    },
                                    message:
                                        'must be equal to one of the allowed values',
                                },
                            ];
                            return false;
                        }
                        var valid0 = _errs2 === errors;
                    } else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.result !== undefined) {
                            let data1 = data.result;
                            const _errs4 = errors;
                            if (errors === _errs4) {
                                if (
                                    data1 &&
                                    typeof data1 == 'object' &&
                                    !Array.isArray(data1)
                                ) {
                                    let missing1;
                                    if (
                                        (data1.direct_media_welcome ===
                                            undefined &&
                                            (missing1 =
                                                'direct_media_welcome')) ||
                                        (data1.direct_media_waiting_for_host ===
                                            undefined &&
                                            (missing1 =
                                                'direct_media_waiting_for_host')) ||
                                        (data1.direct_media_other_participants_audio_only ===
                                            undefined &&
                                            (missing1 =
                                                'direct_media_other_participants_audio_only')) ||
                                        (data1.direct_media_escalate ===
                                            undefined &&
                                            (missing1 =
                                                'direct_media_escalate')) ||
                                        (data1.direct_media_deescalate ===
                                            undefined &&
                                            (missing1 =
                                                'direct_media_deescalate'))
                                    ) {
                                        validate44.errors = [
                                            {
                                                instancePath:
                                                    instancePath + '/result',
                                                schemaPath:
                                                    '#/properties/result/required',
                                                keyword: 'required',
                                                params: {
                                                    missingProperty: missing1,
                                                },
                                                message:
                                                    "must have required property '" +
                                                    missing1 +
                                                    "'",
                                            },
                                        ];
                                        return false;
                                    } else {
                                        const _errs6 = errors;
                                        for (const key1 in data1) {
                                            if (!(
                                                key1 ===
                                                    'direct_media_welcome' ||
                                                key1 ===
                                                    'direct_media_waiting_for_host' ||
                                                key1 ===
                                                    'direct_media_other_participants_audio_only' ||
                                                key1 ===
                                                    'direct_media_escalate' ||
                                                key1 ===
                                                    'direct_media_deescalate' ||
                                                key1 ===
                                                    'direct_media_host_left'
                                            )) {
                                                delete data1[key1];
                                            }
                                        }
                                        if (_errs6 === errors) {
                                            if (
                                                data1.direct_media_welcome !==
                                                undefined
                                            ) {
                                                const _errs7 = errors;
                                                if (
                                                    !validate45(
                                                        data1.direct_media_welcome,
                                                        {
                                                            instancePath:
                                                                instancePath +
                                                                '/result/direct_media_welcome',
                                                            parentData: data1,
                                                            parentDataProperty:
                                                                'direct_media_welcome',
                                                            rootData,
                                                        },
                                                    )
                                                ) {
                                                    vErrors =
                                                        vErrors === null
                                                            ? validate45.errors
                                                            : vErrors.concat(
                                                                  validate45.errors,
                                                              );
                                                    errors = vErrors.length;
                                                }
                                                var valid1 = _errs7 === errors;
                                            } else {
                                                var valid1 = true;
                                            }
                                            if (valid1) {
                                                if (
                                                    data1.direct_media_waiting_for_host !==
                                                    undefined
                                                ) {
                                                    const _errs8 = errors;
                                                    if (
                                                        !validate45(
                                                            data1.direct_media_waiting_for_host,
                                                            {
                                                                instancePath:
                                                                    instancePath +
                                                                    '/result/direct_media_waiting_for_host',
                                                                parentData:
                                                                    data1,
                                                                parentDataProperty:
                                                                    'direct_media_waiting_for_host',
                                                                rootData,
                                                            },
                                                        )
                                                    ) {
                                                        vErrors =
                                                            vErrors === null
                                                                ? validate45.errors
                                                                : vErrors.concat(
                                                                      validate45.errors,
                                                                  );
                                                        errors = vErrors.length;
                                                    }
                                                    var valid1 =
                                                        _errs8 === errors;
                                                } else {
                                                    var valid1 = true;
                                                }
                                                if (valid1) {
                                                    if (
                                                        data1.direct_media_other_participants_audio_only !==
                                                        undefined
                                                    ) {
                                                        const _errs9 = errors;
                                                        if (
                                                            !validate45(
                                                                data1.direct_media_other_participants_audio_only,
                                                                {
                                                                    instancePath:
                                                                        instancePath +
                                                                        '/result/direct_media_other_participants_audio_only',
                                                                    parentData:
                                                                        data1,
                                                                    parentDataProperty:
                                                                        'direct_media_other_participants_audio_only',
                                                                    rootData,
                                                                },
                                                            )
                                                        ) {
                                                            vErrors =
                                                                vErrors === null
                                                                    ? validate45.errors
                                                                    : vErrors.concat(
                                                                          validate45.errors,
                                                                      );
                                                            errors =
                                                                vErrors.length;
                                                        }
                                                        var valid1 =
                                                            _errs9 === errors;
                                                    } else {
                                                        var valid1 = true;
                                                    }
                                                    if (valid1) {
                                                        if (
                                                            data1.direct_media_escalate !==
                                                            undefined
                                                        ) {
                                                            const _errs10 =
                                                                errors;
                                                            if (
                                                                !validate45(
                                                                    data1.direct_media_escalate,
                                                                    {
                                                                        instancePath:
                                                                            instancePath +
                                                                            '/result/direct_media_escalate',
                                                                        parentData:
                                                                            data1,
                                                                        parentDataProperty:
                                                                            'direct_media_escalate',
                                                                        rootData,
                                                                    },
                                                                )
                                                            ) {
                                                                vErrors =
                                                                    vErrors ===
                                                                    null
                                                                        ? validate45.errors
                                                                        : vErrors.concat(
                                                                              validate45.errors,
                                                                          );
                                                                errors =
                                                                    vErrors.length;
                                                            }
                                                            var valid1 =
                                                                _errs10 ===
                                                                errors;
                                                        } else {
                                                            var valid1 = true;
                                                        }
                                                        if (valid1) {
                                                            if (
                                                                data1.direct_media_deescalate !==
                                                                undefined
                                                            ) {
                                                                const _errs11 =
                                                                    errors;
                                                                if (
                                                                    !validate45(
                                                                        data1.direct_media_deescalate,
                                                                        {
                                                                            instancePath:
                                                                                instancePath +
                                                                                '/result/direct_media_deescalate',
                                                                            parentData:
                                                                                data1,
                                                                            parentDataProperty:
                                                                                'direct_media_deescalate',
                                                                            rootData,
                                                                        },
                                                                    )
                                                                ) {
                                                                    vErrors =
                                                                        vErrors ===
                                                                        null
                                                                            ? validate45.errors
                                                                            : vErrors.concat(
                                                                                  validate45.errors,
                                                                              );
                                                                    errors =
                                                                        vErrors.length;
                                                                }
                                                                var valid1 =
                                                                    _errs11 ===
                                                                    errors;
                                                            } else {
                                                                var valid1 = true;
                                                            }
                                                            if (valid1) {
                                                                if (
                                                                    data1.direct_media_host_left !==
                                                                    undefined
                                                                ) {
                                                                    const _errs12 =
                                                                        errors;
                                                                    if (
                                                                        !validate45(
                                                                            data1.direct_media_host_left,
                                                                            {
                                                                                instancePath:
                                                                                    instancePath +
                                                                                    '/result/direct_media_host_left',
                                                                                parentData:
                                                                                    data1,
                                                                                parentDataProperty:
                                                                                    'direct_media_host_left',
                                                                                rootData,
                                                                            },
                                                                        )
                                                                    ) {
                                                                        vErrors =
                                                                            vErrors ===
                                                                            null
                                                                                ? validate45.errors
                                                                                : vErrors.concat(
                                                                                      validate45.errors,
                                                                                  );
                                                                        errors =
                                                                            vErrors.length;
                                                                    }
                                                                    var valid1 =
                                                                        _errs12 ===
                                                                        errors;
                                                                } else {
                                                                    var valid1 = true;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    validate44.errors = [
                                        {
                                            instancePath:
                                                instancePath + '/result',
                                            schemaPath:
                                                '#/properties/result/type',
                                            keyword: 'type',
                                            params: {type: 'object'},
                                            message: 'must be object',
                                        },
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs4 === errors;
                        } else {
                            var valid0 = true;
                        }
                    }
                }
            }
        } else {
            validate44.errors = [
                {
                    instancePath,
                    schemaPath: '#/type',
                    keyword: 'type',
                    params: {type: 'object'},
                    message: 'must be object',
                },
            ];
            return false;
        }
    }
    validate44.errors = vErrors;
    return errors === 0;
}
function validate43(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (
        !validate44(data, {
            instancePath,
            parentData,
            parentDataProperty,
            rootData,
        })
    ) {
        vErrors =
            vErrors === null
                ? validate44.errors
                : vErrors.concat(validate44.errors);
        errors = vErrors.length;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err0 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err0];
        } else {
            vErrors.push(err0);
        }
        errors++;
        validate43.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate43.errors = vErrors;
    return errors === 0;
}
export const validateTheme204 = validate53;
const schema63 = {type: 'string'};
function validate53(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    if (typeof data !== 'string') {
        validate53.errors = [
            {
                instancePath,
                schemaPath: '#/type',
                keyword: 'type',
                params: {type: 'string'},
                message: 'must be string',
            },
        ];
        return false;
    }
    validate53.errors = vErrors;
    return errors === 0;
}
export const validateAvailableLayouts200 = validate54;
const schema64 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        '200': {
            type: 'object',
            additionalProperties: false,
            properties: {
                status: {
                    type: 'string',
                    description: 'Status of the response, eg. success.',
                    enum: ['success'],
                },
                result: {
                    type: 'array',
                    description: 'Layout keys',
                    items: {
                        oneOf: [
                            {type: 'string'},
                            {
                                $ref: '#/definitions/available_layouts/properties/200/definitions/Result',
                            },
                        ],
                    },
                },
            },
            required: ['status', 'result'],
            title: 'Status200',
        },
        Result: {
            type: 'object',
            additionalProperties: false,
            properties: {
                name: {type: 'string'},
                tags: {type: 'array', items: {type: 'string'}},
            },
            required: ['name'],
            title: 'Result',
        },
    },
    oneOf: [
        {
            $ref: '#/definitions/available_layouts/properties/200/definitions/200',
        },
    ],
};
const schema65 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        status: {
            type: 'string',
            description: 'Status of the response, eg. success.',
            enum: ['success'],
        },
        result: {
            type: 'array',
            description: 'Layout keys',
            items: {
                oneOf: [
                    {type: 'string'},
                    {
                        $ref: '#/definitions/available_layouts/properties/200/definitions/Result',
                    },
                ],
            },
        },
    },
    required: ['status', 'result'],
    title: 'Status200',
};
const schema66 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        name: {type: 'string'},
        tags: {type: 'array', items: {type: 'string'}},
    },
    required: ['name'],
    title: 'Result',
};
function validate55(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))
            ) {
                validate55.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: {missingProperty: missing0},
                        message:
                            "must have required property '" + missing0 + "'",
                    },
                ];
                return false;
            } else {
                const _errs1 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs1 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs2 = errors;
                        if (typeof data0 !== 'string') {
                            validate55.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/type',
                                    keyword: 'type',
                                    params: {type: 'string'},
                                    message: 'must be string',
                                },
                            ];
                            return false;
                        }
                        if (!(data0 === 'success')) {
                            validate55.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/enum',
                                    keyword: 'enum',
                                    params: {
                                        allowedValues:
                                            schema65.properties.status.enum,
                                    },
                                    message:
                                        'must be equal to one of the allowed values',
                                },
                            ];
                            return false;
                        }
                        var valid0 = _errs2 === errors;
                    } else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.result !== undefined) {
                            let data1 = data.result;
                            const _errs4 = errors;
                            if (errors === _errs4) {
                                if (Array.isArray(data1)) {
                                    var valid1 = true;
                                    const len0 = data1.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data2 = data1[i0];
                                        const _errs6 = errors;
                                        const _errs7 = errors;
                                        let valid2 = false;
                                        let passing0 = null;
                                        const _errs8 = errors;
                                        if (typeof data2 !== 'string') {
                                            const err0 = {
                                                instancePath:
                                                    instancePath +
                                                    '/result/' +
                                                    i0,
                                                schemaPath:
                                                    '#/properties/result/items/oneOf/0/type',
                                                keyword: 'type',
                                                params: {type: 'string'},
                                                message: 'must be string',
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err0];
                                            } else {
                                                vErrors.push(err0);
                                            }
                                            errors++;
                                        }
                                        var _valid0 = _errs8 === errors;
                                        if (_valid0) {
                                            valid2 = true;
                                            passing0 = 0;
                                        }
                                        const _errs10 = errors;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (
                                                data2 &&
                                                typeof data2 == 'object' &&
                                                !Array.isArray(data2)
                                            ) {
                                                let missing1;
                                                if (
                                                    data2.name === undefined &&
                                                    (missing1 = 'name')
                                                ) {
                                                    const err1 = {
                                                        instancePath:
                                                            instancePath +
                                                            '/result/' +
                                                            i0,
                                                        schemaPath:
                                                            '#/definitions/available_layouts/properties/200/definitions/Result/required',
                                                        keyword: 'required',
                                                        params: {
                                                            missingProperty:
                                                                missing1,
                                                        },
                                                        message:
                                                            "must have required property '" +
                                                            missing1 +
                                                            "'",
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err1];
                                                    } else {
                                                        vErrors.push(err1);
                                                    }
                                                    errors++;
                                                } else {
                                                    const _errs13 = errors;
                                                    for (const key1 in data2) {
                                                        if (!(
                                                            key1 === 'name' ||
                                                            key1 === 'tags'
                                                        )) {
                                                            delete data2[key1];
                                                        }
                                                    }
                                                    if (_errs13 === errors) {
                                                        if (
                                                            data2.name !==
                                                            undefined
                                                        ) {
                                                            const _errs14 =
                                                                errors;
                                                            if (
                                                                typeof data2.name !==
                                                                'string'
                                                            ) {
                                                                const err2 = {
                                                                    instancePath:
                                                                        instancePath +
                                                                        '/result/' +
                                                                        i0 +
                                                                        '/name',
                                                                    schemaPath:
                                                                        '#/definitions/available_layouts/properties/200/definitions/Result/properties/name/type',
                                                                    keyword:
                                                                        'type',
                                                                    params: {
                                                                        type: 'string',
                                                                    },
                                                                    message:
                                                                        'must be string',
                                                                };
                                                                if (
                                                                    vErrors ===
                                                                    null
                                                                ) {
                                                                    vErrors = [
                                                                        err2,
                                                                    ];
                                                                } else {
                                                                    vErrors.push(
                                                                        err2,
                                                                    );
                                                                }
                                                                errors++;
                                                            }
                                                            var valid4 =
                                                                _errs14 ===
                                                                errors;
                                                        } else {
                                                            var valid4 = true;
                                                        }
                                                        if (valid4) {
                                                            if (
                                                                data2.tags !==
                                                                undefined
                                                            ) {
                                                                let data4 =
                                                                    data2.tags;
                                                                const _errs16 =
                                                                    errors;
                                                                if (
                                                                    errors ===
                                                                    _errs16
                                                                ) {
                                                                    if (
                                                                        Array.isArray(
                                                                            data4,
                                                                        )
                                                                    ) {
                                                                        var valid5 = true;
                                                                        const len1 =
                                                                            data4.length;
                                                                        for (
                                                                            let i1 = 0;
                                                                            i1 <
                                                                            len1;
                                                                            i1++
                                                                        ) {
                                                                            const _errs18 =
                                                                                errors;
                                                                            if (
                                                                                typeof data4[
                                                                                    i1
                                                                                ] !==
                                                                                'string'
                                                                            ) {
                                                                                const err3 =
                                                                                    {
                                                                                        instancePath:
                                                                                            instancePath +
                                                                                            '/result/' +
                                                                                            i0 +
                                                                                            '/tags/' +
                                                                                            i1,
                                                                                        schemaPath:
                                                                                            '#/definitions/available_layouts/properties/200/definitions/Result/properties/tags/items/type',
                                                                                        keyword:
                                                                                            'type',
                                                                                        params: {
                                                                                            type: 'string',
                                                                                        },
                                                                                        message:
                                                                                            'must be string',
                                                                                    };
                                                                                if (
                                                                                    vErrors ===
                                                                                    null
                                                                                ) {
                                                                                    vErrors =
                                                                                        [
                                                                                            err3,
                                                                                        ];
                                                                                } else {
                                                                                    vErrors.push(
                                                                                        err3,
                                                                                    );
                                                                                }
                                                                                errors++;
                                                                            }
                                                                            var valid5 =
                                                                                _errs18 ===
                                                                                errors;
                                                                            if (
                                                                                !valid5
                                                                            ) {
                                                                                break;
                                                                            }
                                                                        }
                                                                    } else {
                                                                        const err4 =
                                                                            {
                                                                                instancePath:
                                                                                    instancePath +
                                                                                    '/result/' +
                                                                                    i0 +
                                                                                    '/tags',
                                                                                schemaPath:
                                                                                    '#/definitions/available_layouts/properties/200/definitions/Result/properties/tags/type',
                                                                                keyword:
                                                                                    'type',
                                                                                params: {
                                                                                    type: 'array',
                                                                                },
                                                                                message:
                                                                                    'must be array',
                                                                            };
                                                                        if (
                                                                            vErrors ===
                                                                            null
                                                                        ) {
                                                                            vErrors =
                                                                                [
                                                                                    err4,
                                                                                ];
                                                                        } else {
                                                                            vErrors.push(
                                                                                err4,
                                                                            );
                                                                        }
                                                                        errors++;
                                                                    }
                                                                }
                                                                var valid4 =
                                                                    _errs16 ===
                                                                    errors;
                                                            } else {
                                                                var valid4 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            } else {
                                                const err5 = {
                                                    instancePath:
                                                        instancePath +
                                                        '/result/' +
                                                        i0,
                                                    schemaPath:
                                                        '#/definitions/available_layouts/properties/200/definitions/Result/type',
                                                    keyword: 'type',
                                                    params: {type: 'object'},
                                                    message: 'must be object',
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err5];
                                                } else {
                                                    vErrors.push(err5);
                                                }
                                                errors++;
                                            }
                                        }
                                        var _valid0 = _errs10 === errors;
                                        if (_valid0 && valid2) {
                                            valid2 = false;
                                            passing0 = [passing0, 1];
                                        } else {
                                            if (_valid0) {
                                                valid2 = true;
                                                passing0 = 1;
                                            }
                                        }
                                        if (!valid2) {
                                            const err6 = {
                                                instancePath:
                                                    instancePath +
                                                    '/result/' +
                                                    i0,
                                                schemaPath:
                                                    '#/properties/result/items/oneOf',
                                                keyword: 'oneOf',
                                                params: {
                                                    passingSchemas: passing0,
                                                },
                                                message:
                                                    'must match exactly one schema in oneOf',
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err6];
                                            } else {
                                                vErrors.push(err6);
                                            }
                                            errors++;
                                            validate55.errors = vErrors;
                                            return false;
                                        } else {
                                            errors = _errs7;
                                            if (vErrors !== null) {
                                                if (_errs7) {
                                                    vErrors.length = _errs7;
                                                } else {
                                                    vErrors = null;
                                                }
                                            }
                                        }
                                        var valid1 = _errs6 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                } else {
                                    validate55.errors = [
                                        {
                                            instancePath:
                                                instancePath + '/result',
                                            schemaPath:
                                                '#/properties/result/type',
                                            keyword: 'type',
                                            params: {type: 'array'},
                                            message: 'must be array',
                                        },
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs4 === errors;
                        } else {
                            var valid0 = true;
                        }
                    }
                }
            }
        } else {
            validate55.errors = [
                {
                    instancePath,
                    schemaPath: '#/type',
                    keyword: 'type',
                    params: {type: 'object'},
                    message: 'must be object',
                },
            ];
            return false;
        }
    }
    validate55.errors = vErrors;
    return errors === 0;
}
function validate54(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (
        !validate55(data, {
            instancePath,
            parentData,
            parentDataProperty,
            rootData,
        })
    ) {
        vErrors =
            vErrors === null
                ? validate55.errors
                : vErrors.concat(validate55.errors);
        errors = vErrors.length;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err0 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err0];
        } else {
            vErrors.push(err0);
        }
        errors++;
        validate54.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate54.errors = vErrors;
    return errors === 0;
}
export const validateLayoutSvgs200 = validate57;
const schema67 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        '200': {
            type: 'object',
            additionalProperties: false,
            properties: {
                status: {
                    type: 'string',
                    description: 'Status of the response, eg. success.',
                    enum: ['success'],
                },
                result: {
                    $ref: '#/definitions/layout_svgs/properties/200/definitions/Result',
                },
            },
            required: ['status', 'result'],
            title: 'Status200',
        },
        Result: {
            type: 'object',
            additionalProperties: {type: 'string'},
            title: 'Result',
        },
    },
    oneOf: [{$ref: '#/definitions/layout_svgs/properties/200/definitions/200'}],
};
const schema68 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        status: {
            type: 'string',
            description: 'Status of the response, eg. success.',
            enum: ['success'],
        },
        result: {
            $ref: '#/definitions/layout_svgs/properties/200/definitions/Result',
        },
    },
    required: ['status', 'result'],
    title: 'Status200',
};
const schema69 = {
    type: 'object',
    additionalProperties: {type: 'string'},
    title: 'Result',
};
function validate58(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))
            ) {
                validate58.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: {missingProperty: missing0},
                        message:
                            "must have required property '" + missing0 + "'",
                    },
                ];
                return false;
            } else {
                const _errs1 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs1 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs2 = errors;
                        if (typeof data0 !== 'string') {
                            validate58.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/type',
                                    keyword: 'type',
                                    params: {type: 'string'},
                                    message: 'must be string',
                                },
                            ];
                            return false;
                        }
                        if (!(data0 === 'success')) {
                            validate58.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/enum',
                                    keyword: 'enum',
                                    params: {
                                        allowedValues:
                                            schema68.properties.status.enum,
                                    },
                                    message:
                                        'must be equal to one of the allowed values',
                                },
                            ];
                            return false;
                        }
                        var valid0 = _errs2 === errors;
                    } else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.result !== undefined) {
                            let data1 = data.result;
                            const _errs4 = errors;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (
                                    data1 &&
                                    typeof data1 == 'object' &&
                                    !Array.isArray(data1)
                                ) {
                                    const _errs7 = errors;
                                    for (const key1 in data1) {
                                        const _errs8 = errors;
                                        if (typeof data1[key1] !== 'string') {
                                            const err0 = {};
                                            if (vErrors === null) {
                                                vErrors = [err0];
                                            } else {
                                                vErrors.push(err0);
                                            }
                                            errors++;
                                        }
                                        var valid2 = _errs8 === errors;
                                        if (!valid2) {
                                            errors = _errs7;
                                            if (vErrors !== null) {
                                                if (_errs7) {
                                                    vErrors.length = _errs7;
                                                } else {
                                                    vErrors = null;
                                                }
                                            }
                                            delete data1[key1];
                                        }
                                    }
                                } else {
                                    validate58.errors = [
                                        {
                                            instancePath:
                                                instancePath + '/result',
                                            schemaPath:
                                                '#/definitions/layout_svgs/properties/200/definitions/Result/type',
                                            keyword: 'type',
                                            params: {type: 'object'},
                                            message: 'must be object',
                                        },
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs4 === errors;
                        } else {
                            var valid0 = true;
                        }
                    }
                }
            }
        } else {
            validate58.errors = [
                {
                    instancePath,
                    schemaPath: '#/type',
                    keyword: 'type',
                    params: {type: 'object'},
                    message: 'must be object',
                },
            ];
            return false;
        }
    }
    validate58.errors = vErrors;
    return errors === 0;
}
function validate57(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (
        !validate58(data, {
            instancePath,
            parentData,
            parentDataProperty,
            rootData,
        })
    ) {
        vErrors =
            vErrors === null
                ? validate58.errors
                : vErrors.concat(validate58.errors);
        errors = vErrors.length;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err0 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err0];
        } else {
            vErrors.push(err0);
        }
        errors++;
        validate57.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate57.errors = vErrors;
    return errors === 0;
}
export const validateGuestBreakoutBuzz200 = validate60;
function validate60(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))
            ) {
                const err0 = {
                    instancePath,
                    schemaPath:
                        '#/definitions/lock/properties/200/definitions/200/required',
                    keyword: 'required',
                    params: {missingProperty: missing0},
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                } else {
                    vErrors.push(err0);
                }
                errors++;
            } else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/type',
                                keyword: 'type',
                                params: {type: 'string'},
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            } else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(data0 === 'success')) {
                            const err2 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues:
                                        schema20.properties.status.enum,
                                },
                                message:
                                    'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            } else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    } else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.result !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.result !== 'boolean') {
                                const err3 = {
                                    instancePath: instancePath + '/result',
                                    schemaPath:
                                        '#/definitions/lock/properties/200/definitions/200/properties/result/type',
                                    keyword: 'type',
                                    params: {type: 'boolean'},
                                    message: 'must be boolean',
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                } else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var valid2 = _errs7 === errors;
                        } else {
                            var valid2 = true;
                        }
                    }
                }
            }
        } else {
            const err4 = {
                instancePath,
                schemaPath:
                    '#/definitions/lock/properties/200/definitions/200/type',
                keyword: 'type',
                params: {type: 'object'},
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err4];
            } else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err5];
        } else {
            vErrors.push(err5);
        }
        errors++;
        validate60.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate60.errors = vErrors;
    return errors === 0;
}
export const validateGuestClearBreakoutBuzz200 = validate61;
function validate61(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))
            ) {
                const err0 = {
                    instancePath,
                    schemaPath:
                        '#/definitions/lock/properties/200/definitions/200/required',
                    keyword: 'required',
                    params: {missingProperty: missing0},
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                } else {
                    vErrors.push(err0);
                }
                errors++;
            } else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/type',
                                keyword: 'type',
                                params: {type: 'string'},
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            } else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(data0 === 'success')) {
                            const err2 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues:
                                        schema20.properties.status.enum,
                                },
                                message:
                                    'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            } else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    } else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.result !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.result !== 'boolean') {
                                const err3 = {
                                    instancePath: instancePath + '/result',
                                    schemaPath:
                                        '#/definitions/lock/properties/200/definitions/200/properties/result/type',
                                    keyword: 'type',
                                    params: {type: 'boolean'},
                                    message: 'must be boolean',
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                } else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var valid2 = _errs7 === errors;
                        } else {
                            var valid2 = true;
                        }
                    }
                }
            }
        } else {
            const err4 = {
                instancePath,
                schemaPath:
                    '#/definitions/lock/properties/200/definitions/200/type',
                keyword: 'type',
                params: {type: 'object'},
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err4];
            } else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err5];
        } else {
            vErrors.push(err5);
        }
        errors++;
        validate61.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate61.errors = vErrors;
    return errors === 0;
}
export const validateVideoMixesCreateBody = validate62;
const schema74 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        TopLevel: {
            type: 'object',
            additionalProperties: false,
            properties: {
                mix_name: {
                    type: 'string',
                    description: 'The name of the video mix.',
                },
            },
            required: ['mix_name'],
            title: 'TopLevel',
        },
    },
    oneOf: [
        {
            $ref: '#/definitions/video_mixes_create/properties/Body/definitions/TopLevel',
        },
    ],
};
const schema75 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        mix_name: {type: 'string', description: 'The name of the video mix.'},
    },
    required: ['mix_name'],
    title: 'TopLevel',
};
function validate62(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.mix_name === undefined && (missing0 = 'mix_name')) {
                const err0 = {
                    instancePath,
                    schemaPath:
                        '#/definitions/video_mixes_create/properties/Body/definitions/TopLevel/required',
                    keyword: 'required',
                    params: {missingProperty: missing0},
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                } else {
                    vErrors.push(err0);
                }
                errors++;
            } else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'mix_name')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.mix_name !== undefined) {
                        if (typeof data.mix_name !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/mix_name',
                                schemaPath:
                                    '#/definitions/video_mixes_create/properties/Body/definitions/TopLevel/properties/mix_name/type',
                                keyword: 'type',
                                params: {type: 'string'},
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            } else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                    }
                }
            }
        } else {
            const err2 = {
                instancePath,
                schemaPath:
                    '#/definitions/video_mixes_create/properties/Body/definitions/TopLevel/type',
                keyword: 'type',
                params: {type: 'object'},
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err2];
            } else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err3 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err3];
        } else {
            vErrors.push(err3);
        }
        errors++;
        validate62.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate62.errors = vErrors;
    return errors === 0;
}
export const validateVideoMixesCreate200 = validate63;
function validate63(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))
            ) {
                const err0 = {
                    instancePath,
                    schemaPath:
                        '#/definitions/lock/properties/200/definitions/200/required',
                    keyword: 'required',
                    params: {missingProperty: missing0},
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                } else {
                    vErrors.push(err0);
                }
                errors++;
            } else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/type',
                                keyword: 'type',
                                params: {type: 'string'},
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            } else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(data0 === 'success')) {
                            const err2 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues:
                                        schema20.properties.status.enum,
                                },
                                message:
                                    'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            } else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    } else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.result !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.result !== 'boolean') {
                                const err3 = {
                                    instancePath: instancePath + '/result',
                                    schemaPath:
                                        '#/definitions/lock/properties/200/definitions/200/properties/result/type',
                                    keyword: 'type',
                                    params: {type: 'boolean'},
                                    message: 'must be boolean',
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                } else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var valid2 = _errs7 === errors;
                        } else {
                            var valid2 = true;
                        }
                    }
                }
            }
        } else {
            const err4 = {
                instancePath,
                schemaPath:
                    '#/definitions/lock/properties/200/definitions/200/type',
                keyword: 'type',
                params: {type: 'object'},
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err4];
            } else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err5];
        } else {
            vErrors.push(err5);
        }
        errors++;
        validate63.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate63.errors = vErrors;
    return errors === 0;
}
export const validateVideoMixesConfigureBody = validate64;
const schema78 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        TopLevel: {
            type: 'object',
            additionalProperties: false,
            properties: {
                transform_layout: {
                    type: 'object',
                    additionalProperties: false,
                    description: 'Layout transformations for the mix.',
                    properties: {
                        layout: {
                            type: 'string',
                            description: 'Layout for the mix.',
                        },
                    },
                },
            },
            required: ['transform_layout'],
            title: 'TopLevel',
        },
    },
    oneOf: [
        {
            $ref: '#/definitions/video_mixes_configure/properties/Body/definitions/TopLevel',
        },
    ],
};
const schema79 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        transform_layout: {
            type: 'object',
            additionalProperties: false,
            description: 'Layout transformations for the mix.',
            properties: {
                layout: {type: 'string', description: 'Layout for the mix.'},
            },
        },
    },
    required: ['transform_layout'],
    title: 'TopLevel',
};
function validate64(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                data.transform_layout === undefined &&
                (missing0 = 'transform_layout')
            ) {
                const err0 = {
                    instancePath,
                    schemaPath:
                        '#/definitions/video_mixes_configure/properties/Body/definitions/TopLevel/required',
                    keyword: 'required',
                    params: {missingProperty: missing0},
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                } else {
                    vErrors.push(err0);
                }
                errors++;
            } else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'transform_layout')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.transform_layout !== undefined) {
                        let data0 = data.transform_layout;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (
                                data0 &&
                                typeof data0 == 'object' &&
                                !Array.isArray(data0)
                            ) {
                                const _errs7 = errors;
                                for (const key1 in data0) {
                                    if (!(key1 === 'layout')) {
                                        delete data0[key1];
                                    }
                                }
                                if (_errs7 === errors) {
                                    if (data0.layout !== undefined) {
                                        if (typeof data0.layout !== 'string') {
                                            const err1 = {
                                                instancePath:
                                                    instancePath +
                                                    '/transform_layout/layout',
                                                schemaPath:
                                                    '#/definitions/video_mixes_configure/properties/Body/definitions/TopLevel/properties/transform_layout/properties/layout/type',
                                                keyword: 'type',
                                                params: {type: 'string'},
                                                message: 'must be string',
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err1];
                                            } else {
                                                vErrors.push(err1);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                            } else {
                                const err2 = {
                                    instancePath:
                                        instancePath + '/transform_layout',
                                    schemaPath:
                                        '#/definitions/video_mixes_configure/properties/Body/definitions/TopLevel/properties/transform_layout/type',
                                    keyword: 'type',
                                    params: {type: 'object'},
                                    message: 'must be object',
                                };
                                if (vErrors === null) {
                                    vErrors = [err2];
                                } else {
                                    vErrors.push(err2);
                                }
                                errors++;
                            }
                        }
                    }
                }
            }
        } else {
            const err3 = {
                instancePath,
                schemaPath:
                    '#/definitions/video_mixes_configure/properties/Body/definitions/TopLevel/type',
                keyword: 'type',
                params: {type: 'object'},
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err3];
            } else {
                vErrors.push(err3);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err4 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err4];
        } else {
            vErrors.push(err4);
        }
        errors++;
        validate64.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate64.errors = vErrors;
    return errors === 0;
}
export const validateVideoMixesConfigure200 = validate65;
function validate65(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))
            ) {
                const err0 = {
                    instancePath,
                    schemaPath:
                        '#/definitions/lock/properties/200/definitions/200/required',
                    keyword: 'required',
                    params: {missingProperty: missing0},
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                } else {
                    vErrors.push(err0);
                }
                errors++;
            } else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/type',
                                keyword: 'type',
                                params: {type: 'string'},
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            } else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(data0 === 'success')) {
                            const err2 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues:
                                        schema20.properties.status.enum,
                                },
                                message:
                                    'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            } else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    } else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.result !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.result !== 'boolean') {
                                const err3 = {
                                    instancePath: instancePath + '/result',
                                    schemaPath:
                                        '#/definitions/lock/properties/200/definitions/200/properties/result/type',
                                    keyword: 'type',
                                    params: {type: 'boolean'},
                                    message: 'must be boolean',
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                } else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var valid2 = _errs7 === errors;
                        } else {
                            var valid2 = true;
                        }
                    }
                }
            }
        } else {
            const err4 = {
                instancePath,
                schemaPath:
                    '#/definitions/lock/properties/200/definitions/200/type',
                keyword: 'type',
                params: {type: 'object'},
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err4];
            } else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err5];
        } else {
            vErrors.push(err5);
        }
        errors++;
        validate65.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate65.errors = vErrors;
    return errors === 0;
}
export const validateVideoMixesDelete200 = validate66;
function validate66(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))
            ) {
                const err0 = {
                    instancePath,
                    schemaPath:
                        '#/definitions/lock/properties/200/definitions/200/required',
                    keyword: 'required',
                    params: {missingProperty: missing0},
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                } else {
                    vErrors.push(err0);
                }
                errors++;
            } else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/type',
                                keyword: 'type',
                                params: {type: 'string'},
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            } else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(data0 === 'success')) {
                            const err2 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/lock/properties/200/definitions/200/properties/status/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues:
                                        schema20.properties.status.enum,
                                },
                                message:
                                    'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            } else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    } else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.result !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.result !== 'boolean') {
                                const err3 = {
                                    instancePath: instancePath + '/result',
                                    schemaPath:
                                        '#/definitions/lock/properties/200/definitions/200/properties/result/type',
                                    keyword: 'type',
                                    params: {type: 'boolean'},
                                    message: 'must be boolean',
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                } else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var valid2 = _errs7 === errors;
                        } else {
                            var valid2 = true;
                        }
                    }
                }
            }
        } else {
            const err4 = {
                instancePath,
                schemaPath:
                    '#/definitions/lock/properties/200/definitions/200/type',
                keyword: 'type',
                params: {type: 'object'},
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err4];
            } else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err5];
        } else {
            vErrors.push(err5);
        }
        errors++;
        validate66.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate66.errors = vErrors;
    return errors === 0;
}
export const validateLiveCaptionsLanguages200 = validate67;
const schema84 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        '200': {
            type: 'object',
            additionalProperties: false,
            properties: {
                status: {
                    type: 'string',
                    description: 'Status of the response, eg. success.',
                    enum: ['success'],
                },
                result: {
                    $ref: '#/definitions/live_captions_languages/properties/200/definitions/Result',
                },
            },
            required: ['status', 'result'],
            title: 'Status200',
        },
        Result: {
            type: 'object',
            additionalProperties: false,
            properties: {
                available_captions_languages: {
                    type: 'array',
                    items: {type: 'string'},
                    description: 'The available languages for live captions.',
                },
            },
            required: ['available_captions_languages'],
            title: 'Result',
        },
    },
    oneOf: [
        {
            $ref: '#/definitions/live_captions_languages/properties/200/definitions/200',
        },
    ],
};
const schema85 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        status: {
            type: 'string',
            description: 'Status of the response, eg. success.',
            enum: ['success'],
        },
        result: {
            $ref: '#/definitions/live_captions_languages/properties/200/definitions/Result',
        },
    },
    required: ['status', 'result'],
    title: 'Status200',
};
const schema86 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        available_captions_languages: {
            type: 'array',
            items: {type: 'string'},
            description: 'The available languages for live captions.',
        },
    },
    required: ['available_captions_languages'],
    title: 'Result',
};
function validate68(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))
            ) {
                validate68.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: {missingProperty: missing0},
                        message:
                            "must have required property '" + missing0 + "'",
                    },
                ];
                return false;
            } else {
                const _errs1 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs1 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs2 = errors;
                        if (typeof data0 !== 'string') {
                            validate68.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/type',
                                    keyword: 'type',
                                    params: {type: 'string'},
                                    message: 'must be string',
                                },
                            ];
                            return false;
                        }
                        if (!(data0 === 'success')) {
                            validate68.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/enum',
                                    keyword: 'enum',
                                    params: {
                                        allowedValues:
                                            schema85.properties.status.enum,
                                    },
                                    message:
                                        'must be equal to one of the allowed values',
                                },
                            ];
                            return false;
                        }
                        var valid0 = _errs2 === errors;
                    } else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.result !== undefined) {
                            let data1 = data.result;
                            const _errs4 = errors;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (
                                    data1 &&
                                    typeof data1 == 'object' &&
                                    !Array.isArray(data1)
                                ) {
                                    let missing1;
                                    if (
                                        data1.available_captions_languages ===
                                            undefined &&
                                        (missing1 =
                                            'available_captions_languages')
                                    ) {
                                        validate68.errors = [
                                            {
                                                instancePath:
                                                    instancePath + '/result',
                                                schemaPath:
                                                    '#/definitions/live_captions_languages/properties/200/definitions/Result/required',
                                                keyword: 'required',
                                                params: {
                                                    missingProperty: missing1,
                                                },
                                                message:
                                                    "must have required property '" +
                                                    missing1 +
                                                    "'",
                                            },
                                        ];
                                        return false;
                                    } else {
                                        const _errs7 = errors;
                                        for (const key1 in data1) {
                                            if (
                                                !(
                                                    key1 ===
                                                    'available_captions_languages'
                                                )
                                            ) {
                                                delete data1[key1];
                                            }
                                        }
                                        if (_errs7 === errors) {
                                            if (
                                                data1.available_captions_languages !==
                                                undefined
                                            ) {
                                                let data2 =
                                                    data1.available_captions_languages;
                                                const _errs8 = errors;
                                                if (errors === _errs8) {
                                                    if (Array.isArray(data2)) {
                                                        var valid3 = true;
                                                        const len0 =
                                                            data2.length;
                                                        for (
                                                            let i0 = 0;
                                                            i0 < len0;
                                                            i0++
                                                        ) {
                                                            const _errs10 =
                                                                errors;
                                                            if (
                                                                typeof data2[
                                                                    i0
                                                                ] !== 'string'
                                                            ) {
                                                                validate68.errors =
                                                                    [
                                                                        {
                                                                            instancePath:
                                                                                instancePath +
                                                                                '/result/available_captions_languages/' +
                                                                                i0,
                                                                            schemaPath:
                                                                                '#/definitions/live_captions_languages/properties/200/definitions/Result/properties/available_captions_languages/items/type',
                                                                            keyword:
                                                                                'type',
                                                                            params: {
                                                                                type: 'string',
                                                                            },
                                                                            message:
                                                                                'must be string',
                                                                        },
                                                                    ];
                                                                return false;
                                                            }
                                                            var valid3 =
                                                                _errs10 ===
                                                                errors;
                                                            if (!valid3) {
                                                                break;
                                                            }
                                                        }
                                                    } else {
                                                        validate68.errors = [
                                                            {
                                                                instancePath:
                                                                    instancePath +
                                                                    '/result/available_captions_languages',
                                                                schemaPath:
                                                                    '#/definitions/live_captions_languages/properties/200/definitions/Result/properties/available_captions_languages/type',
                                                                keyword: 'type',
                                                                params: {
                                                                    type: 'array',
                                                                },
                                                                message:
                                                                    'must be array',
                                                            },
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    validate68.errors = [
                                        {
                                            instancePath:
                                                instancePath + '/result',
                                            schemaPath:
                                                '#/definitions/live_captions_languages/properties/200/definitions/Result/type',
                                            keyword: 'type',
                                            params: {type: 'object'},
                                            message: 'must be object',
                                        },
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs4 === errors;
                        } else {
                            var valid0 = true;
                        }
                    }
                }
            }
        } else {
            validate68.errors = [
                {
                    instancePath,
                    schemaPath: '#/type',
                    keyword: 'type',
                    params: {type: 'object'},
                    message: 'must be object',
                },
            ];
            return false;
        }
    }
    validate68.errors = vErrors;
    return errors === 0;
}
function validate67(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (
        !validate68(data, {
            instancePath,
            parentData,
            parentDataProperty,
            rootData,
        })
    ) {
        vErrors =
            vErrors === null
                ? validate68.errors
                : vErrors.concat(validate68.errors);
        errors = vErrors.length;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err0 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err0];
        } else {
            vErrors.push(err0);
        }
        errors++;
        validate67.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate67.errors = vErrors;
    return errors === 0;
}
export const validateLiveCaptionsLanguages403 = validate70;
const schema87 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        '403': {
            type: 'object',
            additionalProperties: false,
            properties: {
                status: {
                    type: 'string',
                    description: 'Status of the response, eg. success.',
                    enum: ['success', 'failed'],
                },
                result: {type: 'string', description: 'Error strings'},
            },
            required: ['status', 'result'],
            title: 'Status403',
        },
    },
    oneOf: [
        {
            $ref: '#/definitions/live_captions_languages/properties/403/definitions/403',
        },
    ],
};
const schema88 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        status: {
            type: 'string',
            description: 'Status of the response, eg. success.',
            enum: ['success', 'failed'],
        },
        result: {type: 'string', description: 'Error strings'},
    },
    required: ['status', 'result'],
    title: 'Status403',
};
function validate70(
    data,
    {instancePath = '', parentData, parentDataProperty, rootData = data} = {},
) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
                (data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))
            ) {
                const err0 = {
                    instancePath,
                    schemaPath:
                        '#/definitions/live_captions_languages/properties/403/definitions/403/required',
                    keyword: 'required',
                    params: {missingProperty: missing0},
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                } else {
                    vErrors.push(err0);
                }
                errors++;
            } else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/live_captions_languages/properties/403/definitions/403/properties/status/type',
                                keyword: 'type',
                                params: {type: 'string'},
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            } else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(data0 === 'success' || data0 === 'failed')) {
                            const err2 = {
                                instancePath: instancePath + '/status',
                                schemaPath:
                                    '#/definitions/live_captions_languages/properties/403/definitions/403/properties/status/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues:
                                        schema88.properties.status.enum,
                                },
                                message:
                                    'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            } else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    } else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.result !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.result !== 'string') {
                                const err3 = {
                                    instancePath: instancePath + '/result',
                                    schemaPath:
                                        '#/definitions/live_captions_languages/properties/403/definitions/403/properties/result/type',
                                    keyword: 'type',
                                    params: {type: 'string'},
                                    message: 'must be string',
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                } else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var valid2 = _errs7 === errors;
                        } else {
                            var valid2 = true;
                        }
                    }
                }
            }
        } else {
            const err4 = {
                instancePath,
                schemaPath:
                    '#/definitions/live_captions_languages/properties/403/definitions/403/type',
                keyword: 'type',
                params: {type: 'object'},
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err4];
            } else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: {passingSchemas: passing0},
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err5];
        } else {
            vErrors.push(err5);
        }
        errors++;
        validate70.errors = vErrors;
        return false;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            } else {
                vErrors = null;
            }
        }
    }
    validate70.errors = vErrors;
    return errors === 0;
}
